const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=[window.__toCdnUrl("assets/woob_collection-list.css"),window.__toCdnUrl("assets/woob_collection-grid.css"),window.__toCdnUrl("assets/woob_collection-hero.css"),window.__toCdnUrl("assets/woob_product-main.css"),window.__toCdnUrl("assets/woob_collection-slider.css"),window.__toCdnUrl("assets/woob_card.css"),window.__toCdnUrl("assets/woob_facets.css"),window.__toCdnUrl("assets/woob_quick-add.css"),window.__toCdnUrl("assets/woob_price.css")])))=>i.map(i=>d[i]);
//#region \0vite/modulepreload-polyfill.js
(function polyfill() {
	const relList = document.createElement("link").relList;
	if (relList && relList.supports && relList.supports("modulepreload")) return;
	for (const link of document.querySelectorAll("link[rel=\"modulepreload\"]")) processPreload(link);
	new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (mutation.type !== "childList") continue;
			for (const node of mutation.addedNodes) if (node.tagName === "LINK" && node.rel === "modulepreload") processPreload(node);
		}
	}).observe(document, {
		childList: true,
		subtree: true
	});
	function getFetchOpts(link) {
		const fetchOpts = {};
		if (link.integrity) fetchOpts.integrity = link.integrity;
		if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
		if (link.crossOrigin === "use-credentials") fetchOpts.credentials = "include";
		else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
		else fetchOpts.credentials = "same-origin";
		return fetchOpts;
	}
	function processPreload(link) {
		if (link.ep) return;
		link.ep = true;
		const fetchOpts = getFetchOpts(link);
		fetch(link.href, fetchOpts);
	}
})();
//#endregion
//#region node_modules/@splidejs/splide/dist/js/splide.esm.js
function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}
function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	Object.defineProperty(Constructor, "prototype", { writable: false });
	return Constructor;
}
/*!
* Splide.js
* Version  : 4.1.4
* License  : MIT
* Copyright: 2022 Naotoshi Fujita
*/
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
	CREATED,
	MOUNTED,
	IDLE,
	MOVING,
	SCROLLING,
	DRAGGING,
	DESTROYED
};
function empty(array) {
	array.length = 0;
}
function slice(arrayLike, start, end) {
	return Array.prototype.slice.call(arrayLike, start, end);
}
function apply$1(func) {
	return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick$1 = setTimeout;
var noop = function noop() {};
function raf(func) {
	return requestAnimationFrame(func);
}
function typeOf(type, subject) {
	return typeof subject === type;
}
function isObject$1(subject) {
	return !isNull(subject) && typeOf("object", subject);
}
var isArray$1 = Array.isArray;
var isFunction$1 = apply$1(typeOf, "function");
var isString$1 = apply$1(typeOf, "string");
var isUndefined = apply$1(typeOf, "undefined");
function isNull(subject) {
	return subject === null;
}
function isHTMLElement(subject) {
	try {
		return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
	} catch (e) {
		return false;
	}
}
function toArray(value) {
	return isArray$1(value) ? value : [value];
}
function forEach(values, iteratee) {
	toArray(values).forEach(iteratee);
}
function includes(array, value) {
	return array.indexOf(value) > -1;
}
function push(array, items) {
	array.push.apply(array, toArray(items));
	return array;
}
function toggleClass(elm, classes, add) {
	if (elm) forEach(classes, function(name) {
		if (name) elm.classList[add ? "add" : "remove"](name);
	});
}
function addClass(elm, classes) {
	toggleClass(elm, isString$1(classes) ? classes.split(" ") : classes, true);
}
function append(parent, children) {
	forEach(children, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
	forEach(nodes, function(node) {
		var parent = (ref || node).parentNode;
		if (parent) parent.insertBefore(node, ref);
	});
}
function matches(elm, selector) {
	return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
	var children2 = parent ? slice(parent.children) : [];
	return selector ? children2.filter(function(child) {
		return matches(child, selector);
	}) : children2;
}
function child(parent, selector) {
	return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
	if (object) (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
		key !== "__proto__" && iteratee(object[key], key);
	});
	return object;
}
function assign(object) {
	slice(arguments, 1).forEach(function(source) {
		forOwn(source, function(value, key) {
			object[key] = source[key];
		});
	});
	return object;
}
function merge(object) {
	slice(arguments, 1).forEach(function(source) {
		forOwn(source, function(value, key) {
			if (isArray$1(value)) object[key] = value.slice();
			else if (isObject$1(value)) object[key] = merge({}, isObject$1(object[key]) ? object[key] : {}, value);
			else object[key] = value;
		});
	});
	return object;
}
function omit(object, keys) {
	forEach(keys || ownKeys(object), function(key) {
		delete object[key];
	});
}
function removeAttribute(elms, attrs) {
	forEach(elms, function(elm) {
		forEach(attrs, function(attr) {
			elm && elm.removeAttribute(attr);
		});
	});
}
function setAttribute(elms, attrs, value) {
	if (isObject$1(attrs)) forOwn(attrs, function(value2, name) {
		setAttribute(elms, name, value2);
	});
	else forEach(elms, function(elm) {
		isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
	});
}
function create(tag, attrs, parent) {
	var elm = document.createElement(tag);
	if (attrs) isString$1(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
	parent && append(parent, elm);
	return elm;
}
function style(elm, prop, value) {
	if (isUndefined(value)) return getComputedStyle(elm)[prop];
	if (!isNull(value)) elm.style[prop] = "" + value;
}
function display(elm, display2) {
	style(elm, "display", display2);
}
function focus(elm) {
	elm["setActive"] && elm["setActive"]() || elm.focus({ preventScroll: true });
}
function getAttribute(elm, attr) {
	return elm.getAttribute(attr);
}
function hasClass(elm, className) {
	return elm && elm.classList.contains(className);
}
function rect(target) {
	return target.getBoundingClientRect();
}
function remove$2(nodes) {
	forEach(nodes, function(node) {
		if (node && node.parentNode) node.parentNode.removeChild(node);
	});
}
function parseHtml(html) {
	return child(new DOMParser().parseFromString(html, "text/html").body);
}
function prevent(e, stopPropagation) {
	e.preventDefault();
	if (stopPropagation) {
		e.stopPropagation();
		e.stopImmediatePropagation();
	}
}
function query(parent, selector) {
	return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
	return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
	toggleClass(elm, classes, false);
}
function timeOf(e) {
	return e.timeStamp;
}
function unit(value) {
	return isString$1(value) ? value : value ? value + "px" : "";
}
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(condition, message) {
	if (!condition) throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
}
var min = Math.min;
var max = Math.max;
var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
function approximatelyEqual(x, y, epsilon) {
	return abs(x - y) < epsilon;
}
function between(number, x, y, exclusive) {
	var minimum = min(x, y);
	var maximum = max(x, y);
	return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y) {
	var minimum = min(x, y);
	var maximum = max(x, y);
	return min(max(minimum, number), maximum);
}
function sign(x) {
	return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
	forEach(replacements, function(replacement) {
		string = string.replace("%s", "" + replacement);
	});
	return string;
}
function pad(number) {
	return number < 10 ? "0" + number : "" + number;
}
var ids = {};
function uniqueId(prefix) {
	return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
	var listeners = [];
	function bind(targets, events, callback, options) {
		forEachEvent(targets, events, function(target, event, namespace) {
			var isEventTarget = "addEventListener" in target;
			var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
			isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
			listeners.push([
				target,
				event,
				namespace,
				callback,
				remover
			]);
		});
	}
	function unbind(targets, events, callback) {
		forEachEvent(targets, events, function(target, event, namespace) {
			listeners = listeners.filter(function(listener) {
				if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
					listener[4]();
					return false;
				}
				return true;
			});
		});
	}
	function dispatch(target, type, detail) {
		var e;
		var bubbles = true;
		if (typeof CustomEvent === "function") e = new CustomEvent(type, {
			bubbles,
			detail
		});
		else {
			e = document.createEvent("CustomEvent");
			e.initCustomEvent(type, bubbles, false, detail);
		}
		target.dispatchEvent(e);
		return e;
	}
	function forEachEvent(targets, events, iteratee) {
		forEach(targets, function(target) {
			target && forEach(events, function(events2) {
				events2.split(" ").forEach(function(eventNS) {
					var fragment = eventNS.split(".");
					iteratee(target, fragment[0], fragment[1]);
				});
			});
		});
	}
	function destroy() {
		listeners.forEach(function(data) {
			data[4]();
		});
		empty(listeners);
	}
	return {
		bind,
		unbind,
		dispatch,
		destroy
	};
}
var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
function EventInterface(Splide2) {
	var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
	var binder = EventBinder();
	function on(events, callback) {
		binder.bind(bus, toArray(events).join(" "), function(e) {
			callback.apply(callback, isArray$1(e.detail) ? e.detail : []);
		});
	}
	function emit(event) {
		binder.dispatch(bus, event, slice(arguments, 1));
	}
	if (Splide2) Splide2.event.on(EVENT_DESTROY, binder.destroy);
	return assign(binder, {
		bus,
		on,
		off: apply$1(binder.unbind, bus),
		emit
	});
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
	var now = Date.now;
	var startTime;
	var rate = 0;
	var id;
	var paused = true;
	var count = 0;
	function update() {
		if (!paused) {
			rate = interval ? min((now() - startTime) / interval, 1) : 1;
			onUpdate && onUpdate(rate);
			if (rate >= 1) {
				onInterval();
				startTime = now();
				if (limit && ++count >= limit) return pause();
			}
			id = raf(update);
		}
	}
	function start(resume) {
		resume || cancel();
		startTime = now() - (resume ? rate * interval : 0);
		paused = false;
		id = raf(update);
	}
	function pause() {
		paused = true;
	}
	function rewind() {
		startTime = now();
		rate = 0;
		if (onUpdate) onUpdate(rate);
	}
	function cancel() {
		id && cancelAnimationFrame(id);
		rate = 0;
		id = 0;
		paused = true;
	}
	function set(time) {
		interval = time;
	}
	function isPaused() {
		return paused;
	}
	return {
		start,
		rewind,
		pause,
		cancel,
		set,
		isPaused
	};
}
function State(initialState) {
	var state = initialState;
	function set(value) {
		state = value;
	}
	function is(states) {
		return includes(toArray(states), state);
	}
	return {
		set,
		is
	};
}
function Throttle(func, duration) {
	var interval = RequestInterval(duration || 0, func, null, 1);
	return function() {
		interval.isPaused() && interval.start();
	};
}
function Media(Splide2, Components2, options) {
	var state = Splide2.state;
	var breakpoints = options.breakpoints || {};
	var reducedMotion = options.reducedMotion || {};
	var binder = EventBinder();
	var queries = [];
	function setup() {
		var isMin = options.mediaQuery === "min";
		ownKeys(breakpoints).sort(function(n, m) {
			return isMin ? +n - +m : +m - +n;
		}).forEach(function(key) {
			register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
		});
		register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
		update();
	}
	function destroy(completely) {
		if (completely) binder.destroy();
	}
	function register(options2, query) {
		var queryList = matchMedia(query);
		binder.bind(queryList, "change", update);
		queries.push([options2, queryList]);
	}
	function update() {
		var destroyed = state.is(DESTROYED);
		var direction = options.direction;
		var merged = queries.reduce(function(merged2, entry) {
			return merge(merged2, entry[1].matches ? entry[0] : {});
		}, {});
		omit(options);
		set(merged);
		if (options.destroy) Splide2.destroy(options.destroy === "completely");
		else if (destroyed) {
			destroy(true);
			Splide2.mount();
		} else direction !== options.direction && Splide2.refresh();
	}
	function reduce(enable) {
		if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
	}
	function set(opts, base, notify) {
		merge(options, opts);
		base && merge(Object.getPrototypeOf(options), opts);
		if (notify || !state.is(CREATED)) Splide2.emit(EVENT_UPDATED, options);
	}
	return {
		setup,
		destroy,
		reduce,
		set
	};
}
var ARROW = "Arrow";
var ARROW_LEFT = ARROW + "Left";
var ARROW_RIGHT = ARROW + "Right";
var ARROW_UP = ARROW + "Up";
var ARROW_DOWN = ARROW + "Down";
var ORIENTATION_MAP = {
	width: ["height"],
	left: ["top", "right"],
	right: ["bottom", "left"],
	x: ["y"],
	X: ["Y"],
	Y: ["X"],
	ArrowLeft: [ARROW_UP, ARROW_RIGHT],
	ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
	function resolve(prop, axisOnly, direction) {
		direction = direction || options.direction;
		var index = direction === "rtl" && !axisOnly ? 1 : direction === "ttb" ? 0 : -1;
		return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
			var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
			return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
		});
	}
	function orient(value) {
		return value * (options.direction === "rtl" ? 1 : -1);
	}
	return {
		resolve,
		orient
	};
}
var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = ARIA_PREFIX + "controls";
var ARIA_CURRENT = ARIA_PREFIX + "current";
var ARIA_SELECTED = ARIA_PREFIX + "selected";
var ARIA_LABEL = ARIA_PREFIX + "label";
var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
var ARIA_LIVE = ARIA_PREFIX + "live";
var ARIA_BUSY = ARIA_PREFIX + "busy";
var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
var ALL_ATTRIBUTES = [
	ROLE,
	TAB_INDEX,
	DISABLED,
	ARIA_CONTROLS,
	ARIA_CURRENT,
	ARIA_LABEL,
	ARIA_LABELLEDBY,
	ARIA_HIDDEN,
	ARIA_ORIENTATION,
	ARIA_ROLEDESCRIPTION
];
var CLASS_PREFIX = PROJECT_CODE + "__";
var STATUS_CLASS_PREFIX = "is-";
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + "track";
var CLASS_LIST = CLASS_PREFIX + "list";
var CLASS_SLIDE = CLASS_PREFIX + "slide";
var CLASS_CLONE = CLASS_SLIDE + "--clone";
var CLASS_CONTAINER = CLASS_SLIDE + "__container";
var CLASS_ARROWS = CLASS_PREFIX + "arrows";
var CLASS_ARROW = CLASS_PREFIX + "arrow";
var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
var CLASS_PROGRESS_BAR = CLASS_PREFIX + "progress__bar";
var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
CLASS_TOGGLE + "";
CLASS_TOGGLE + "";
var CLASS_SPINNER = CLASS_PREFIX + "spinner";
var CLASS_SR = CLASS_PREFIX + "sr";
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
var STATUS_CLASSES = [
	CLASS_ACTIVE,
	CLASS_VISIBLE,
	CLASS_PREV,
	CLASS_NEXT,
	CLASS_LOADING,
	CLASS_FOCUS_IN,
	CLASS_OVERFLOW
];
var CLASSES = {
	slide: CLASS_SLIDE,
	clone: CLASS_CLONE,
	arrows: CLASS_ARROWS,
	arrow: CLASS_ARROW,
	prev: CLASS_ARROW_PREV,
	next: CLASS_ARROW_NEXT,
	pagination: CLASS_PAGINATION,
	page: CLASS_PAGINATION_PAGE,
	spinner: CLASS_SPINNER
};
function closest(from, selector) {
	if (isFunction$1(from.closest)) return from.closest(selector);
	var elm = from;
	while (elm && elm.nodeType === 1) {
		if (matches(elm, selector)) break;
		elm = elm.parentElement;
	}
	return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(Splide2, Components2, options) {
	var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
	var root = Splide2.root;
	var i18n = options.i18n;
	var elements = {};
	var slides = [];
	var rootClasses = [];
	var trackClasses = [];
	var track;
	var list;
	var isUsingKey;
	function setup() {
		collect();
		init();
		update();
	}
	function mount() {
		on(EVENT_REFRESH, destroy);
		on(EVENT_REFRESH, setup);
		on(EVENT_UPDATED, update);
		bind(document, POINTER_DOWN_EVENTS + " keydown", function(e) {
			isUsingKey = e.type === "keydown";
		}, { capture: true });
		bind(root, "focusin", function() {
			toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
		});
	}
	function destroy(completely) {
		var attrs = ALL_ATTRIBUTES.concat("style");
		empty(slides);
		removeClass(root, rootClasses);
		removeClass(track, trackClasses);
		removeAttribute([track, list], attrs);
		removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
	}
	function update() {
		removeClass(root, rootClasses);
		removeClass(track, trackClasses);
		rootClasses = getClasses(CLASS_ROOT);
		trackClasses = getClasses(CLASS_TRACK);
		addClass(root, rootClasses);
		addClass(track, trackClasses);
		setAttribute(root, ARIA_LABEL, options.label);
		setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
	}
	function collect() {
		track = find("." + CLASS_TRACK);
		list = child(track, "." + CLASS_LIST);
		assert(track && list, "A track/list element is missing.");
		push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
		forOwn({
			arrows: CLASS_ARROWS,
			pagination: CLASS_PAGINATION,
			prev: CLASS_ARROW_PREV,
			next: CLASS_ARROW_NEXT,
			bar: CLASS_PROGRESS_BAR,
			toggle: CLASS_TOGGLE
		}, function(className, key) {
			elements[key] = find("." + className);
		});
		assign(elements, {
			root,
			track,
			list,
			slides
		});
	}
	function init() {
		var id = root.id || uniqueId(PROJECT_CODE);
		var role = options.role;
		root.id = id;
		track.id = track.id || id + "-track";
		list.id = list.id || id + "-list";
		if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) setAttribute(root, ROLE, role);
		setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
		setAttribute(list, ROLE, "presentation");
	}
	function find(selector) {
		var elm = query(root, selector);
		return elm && closest(elm, ".splide") === root ? elm : void 0;
	}
	function getClasses(base) {
		return [
			base + "--" + options.type,
			base + "--" + options.direction,
			options.drag && base + "--draggable",
			options.isNavigation && base + "--nav",
			base === "splide" && "is-active"
		];
	}
	return assign(elements, {
		setup,
		mount,
		destroy
	});
}
var SLIDE = "slide";
var LOOP = "loop";
function Slide$1(Splide2, index, slideIndex, slide) {
	var event = EventInterface(Splide2);
	var on = event.on, emit = event.emit, bind = event.bind;
	var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
	var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
	var resolve = Components.Direction.resolve;
	var styles = getAttribute(slide, "style");
	var label = getAttribute(slide, ARIA_LABEL);
	var isClone = slideIndex > -1;
	var container = child(slide, "." + CLASS_CONTAINER);
	var destroyed;
	function mount() {
		if (!isClone) {
			slide.id = root.id + "-slide" + pad(index + 1);
			setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
			setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
			setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
		}
		listen();
	}
	function listen() {
		bind(slide, "click", apply$1(emit, EVENT_CLICK, self));
		bind(slide, "keydown", apply$1(emit, "sk", self));
		on([
			EVENT_MOVED,
			"sh",
			EVENT_SCROLLED
		], update);
		on(EVENT_NAVIGATION_MOUNTED, initNavigation);
		if (updateOnMove) on(EVENT_MOVE, onMove);
	}
	function destroy() {
		destroyed = true;
		event.destroy();
		removeClass(slide, STATUS_CLASSES);
		removeAttribute(slide, ALL_ATTRIBUTES);
		setAttribute(slide, "style", styles);
		setAttribute(slide, ARIA_LABEL, label || "");
	}
	function initNavigation() {
		var controls = Splide2.splides.map(function(target) {
			var Slide2 = target.splide.Components.Slides.getAt(index);
			return Slide2 ? Slide2.slide.id : "";
		}).join(" ");
		setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
		setAttribute(slide, ARIA_CONTROLS, controls);
		setAttribute(slide, ROLE, slideFocus ? "button" : "");
		slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
	}
	function onMove() {
		if (!destroyed) update();
	}
	function update() {
		if (!destroyed) {
			var curr = Splide2.index;
			updateActivity();
			updateVisibility();
			toggleClass(slide, CLASS_PREV, index === curr - 1);
			toggleClass(slide, CLASS_NEXT, index === curr + 1);
		}
	}
	function updateActivity() {
		var active = isActive();
		if (active !== hasClass(slide, "is-active")) {
			toggleClass(slide, CLASS_ACTIVE, active);
			setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
			emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
		}
	}
	function updateVisibility() {
		var visible = isVisible();
		var hidden = !visible && (!isActive() || isClone);
		if (!Splide2.state.is([MOVING, SCROLLING])) setAttribute(slide, ARIA_HIDDEN, hidden || "");
		setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
		if (slideFocus) setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
		if (visible !== hasClass(slide, "is-visible")) {
			toggleClass(slide, CLASS_VISIBLE, visible);
			emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
		}
		if (!visible && document.activeElement === slide) {
			var Slide2 = Components.Slides.getAt(Splide2.index);
			Slide2 && focus(Slide2.slide);
		}
	}
	function style$1(prop, value, useContainer) {
		style(useContainer && container || slide, prop, value);
	}
	function isActive() {
		var curr = Splide2.index;
		return curr === index || options.cloneStatus && curr === slideIndex;
	}
	function isVisible() {
		if (Splide2.is("fade")) return isActive();
		var trackRect = rect(Components.Elements.track);
		var slideRect = rect(slide);
		var left = resolve("left", true);
		var right = resolve("right", true);
		return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
	}
	function isWithin(from, distance) {
		var diff = abs(from - index);
		if (!isClone && (options.rewind || Splide2.is("loop"))) diff = min(diff, Splide2.length - diff);
		return diff <= distance;
	}
	var self = {
		index,
		slideIndex,
		slide,
		container,
		isClone,
		mount,
		destroy,
		update,
		style: style$1,
		isWithin
	};
	return self;
}
function Slides(Splide2, Components2, options) {
	var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
	var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
	var Slides2 = [];
	function mount() {
		init();
		on(EVENT_REFRESH, destroy);
		on(EVENT_REFRESH, init);
	}
	function init() {
		slides.forEach(function(slide, index) {
			register(slide, index, -1);
		});
	}
	function destroy() {
		forEach$1(function(Slide2) {
			Slide2.destroy();
		});
		empty(Slides2);
	}
	function update() {
		forEach$1(function(Slide2) {
			Slide2.update();
		});
	}
	function register(slide, index, slideIndex) {
		var object = Slide$1(Splide2, index, slideIndex, slide);
		object.mount();
		Slides2.push(object);
		Slides2.sort(function(Slide1, Slide2) {
			return Slide1.index - Slide2.index;
		});
	}
	function get(excludeClones) {
		return excludeClones ? filter(function(Slide2) {
			return !Slide2.isClone;
		}) : Slides2;
	}
	function getIn(page) {
		var Controller = Components2.Controller;
		var index = Controller.toIndex(page);
		var max = Controller.hasFocus() ? 1 : options.perPage;
		return filter(function(Slide2) {
			return between(Slide2.index, index, index + max - 1);
		});
	}
	function getAt(index) {
		return filter(index)[0];
	}
	function add(items, index) {
		forEach(items, function(slide) {
			if (isString$1(slide)) slide = parseHtml(slide);
			if (isHTMLElement(slide)) {
				var ref = slides[index];
				ref ? before(slide, ref) : append(list, slide);
				addClass(slide, options.classes.slide);
				observeImages(slide, apply$1(emit, EVENT_RESIZE));
			}
		});
		emit(EVENT_REFRESH);
	}
	function remove$1(matcher) {
		remove$2(filter(matcher).map(function(Slide2) {
			return Slide2.slide;
		}));
		emit(EVENT_REFRESH);
	}
	function forEach$1(iteratee, excludeClones) {
		get(excludeClones).forEach(iteratee);
	}
	function filter(matcher) {
		return Slides2.filter(isFunction$1(matcher) ? matcher : function(Slide2) {
			return isString$1(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
		});
	}
	function style(prop, value, useContainer) {
		forEach$1(function(Slide2) {
			Slide2.style(prop, value, useContainer);
		});
	}
	function observeImages(elm, callback) {
		var images = queryAll(elm, "img");
		var length = images.length;
		if (length) images.forEach(function(img) {
			bind(img, "load error", function() {
				if (!--length) callback();
			});
		});
		else callback();
	}
	function getLength(excludeClones) {
		return excludeClones ? slides.length : Slides2.length;
	}
	function isEnough() {
		return Slides2.length > options.perPage;
	}
	return {
		mount,
		destroy,
		update,
		register,
		get,
		getIn,
		getAt,
		add,
		remove: remove$1,
		forEach: forEach$1,
		filter,
		style,
		getLength,
		isEnough
	};
}
function Layout(Splide2, Components2, options) {
	var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
	var Slides = Components2.Slides;
	var resolve = Components2.Direction.resolve;
	var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
	var getAt = Slides.getAt, styleSlides = Slides.style;
	var vertical;
	var rootRect;
	var overflow;
	function mount() {
		init();
		bind(window, "resize load", Throttle(apply$1(emit, EVENT_RESIZE)));
		on([EVENT_UPDATED, EVENT_REFRESH], init);
		on(EVENT_RESIZE, resize);
	}
	function init() {
		vertical = options.direction === "ttb";
		style(root, "maxWidth", unit(options.width));
		style(track, resolve("paddingLeft"), cssPadding(false));
		style(track, resolve("paddingRight"), cssPadding(true));
		resize(true);
	}
	function resize(force) {
		var newRect = rect(root);
		if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
			style(track, "height", cssTrackHeight());
			styleSlides(resolve("marginRight"), unit(options.gap));
			styleSlides("width", cssSlideWidth());
			styleSlides("height", cssSlideHeight(), true);
			rootRect = newRect;
			emit(EVENT_RESIZED);
			if (overflow !== (overflow = isOverflow())) {
				toggleClass(root, CLASS_OVERFLOW, overflow);
				emit(EVENT_OVERFLOW, overflow);
			}
		}
	}
	function cssPadding(right) {
		var padding = options.padding;
		var prop = resolve(right ? "right" : "left");
		return padding && unit(padding[prop] || (isObject$1(padding) ? 0 : padding)) || "0px";
	}
	function cssTrackHeight() {
		var height = "";
		if (vertical) {
			height = cssHeight();
			assert(height, "height or heightRatio is missing.");
			height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
		}
		return height;
	}
	function cssHeight() {
		return unit(options.height || rect(list).width * options.heightRatio);
	}
	function cssSlideWidth() {
		return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
	}
	function cssSlideHeight() {
		return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
	}
	function cssSlideSize() {
		var gap = unit(options.gap);
		return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
	}
	function listSize() {
		return rect(list)[resolve("width")];
	}
	function slideSize(index, withoutGap) {
		var Slide = getAt(index || 0);
		return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
	}
	function totalSize(index, withoutGap) {
		var Slide = getAt(index);
		if (Slide) {
			var right = rect(Slide.slide)[resolve("right")];
			var left = rect(list)[resolve("left")];
			return abs(right - left) + (withoutGap ? 0 : getGap());
		}
		return 0;
	}
	function sliderSize(withoutGap) {
		return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
	}
	function getGap() {
		var Slide = getAt(0);
		return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
	}
	function getPadding(right) {
		return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
	}
	function isOverflow() {
		return Splide2.is("fade") || sliderSize(true) > listSize();
	}
	return {
		mount,
		resize,
		listSize,
		slideSize,
		sliderSize,
		totalSize,
		getPadding,
		isOverflow
	};
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
	var event = EventInterface(Splide2);
	var on = event.on;
	var Elements = Components2.Elements, Slides = Components2.Slides;
	var resolve = Components2.Direction.resolve;
	var clones = [];
	var cloneCount;
	function mount() {
		on(EVENT_REFRESH, remount);
		on([EVENT_UPDATED, EVENT_RESIZE], observe);
		if (cloneCount = computeCloneCount()) {
			generate(cloneCount);
			Components2.Layout.resize(true);
		}
	}
	function remount() {
		destroy();
		mount();
	}
	function destroy() {
		remove$2(clones);
		empty(clones);
		event.destroy();
	}
	function observe() {
		var count = computeCloneCount();
		if (cloneCount !== count) {
			if (cloneCount < count || !count) event.emit(EVENT_REFRESH);
		}
	}
	function generate(count) {
		var slides = Slides.get().slice();
		var length = slides.length;
		if (length) {
			while (slides.length < count) push(slides, slides);
			push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
				var isHead = index < count;
				var clone = cloneDeep(Slide.slide, index);
				isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
				push(clones, clone);
				Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
			});
		}
	}
	function cloneDeep(elm, index) {
		var clone = elm.cloneNode(true);
		addClass(clone, options.classes.clone);
		clone.id = Splide2.root.id + "-clone" + pad(index + 1);
		return clone;
	}
	function computeCloneCount() {
		var clones2 = options.clones;
		if (!Splide2.is("loop")) clones2 = 0;
		else if (isUndefined(clones2)) {
			var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
			clones2 = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize) || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
		}
		return clones2;
	}
	return {
		mount,
		destroy
	};
}
function Move(Splide2, Components2, options) {
	var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
	var set = Splide2.state.set;
	var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
	var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
	var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
	var Transition;
	function mount() {
		Transition = Components2.Transition;
		on([
			EVENT_MOUNTED,
			EVENT_RESIZED,
			EVENT_UPDATED,
			EVENT_REFRESH
		], reposition);
	}
	function reposition() {
		if (!Components2.Controller.isBusy()) {
			Components2.Scroll.cancel();
			jump(Splide2.index);
			Components2.Slides.update();
		}
	}
	function move(dest, index, prev, callback) {
		if (dest !== index && canShift(dest > prev)) {
			cancel();
			translate(shift(getPosition(), dest > prev), true);
		}
		set(MOVING);
		emit(EVENT_MOVE, index, prev, dest);
		Transition.start(index, function() {
			set(IDLE);
			emit(EVENT_MOVED, index, prev, dest);
			callback && callback();
		});
	}
	function jump(index) {
		translate(toPosition(index, true));
	}
	function translate(position, preventLoop) {
		if (!Splide2.is("fade")) {
			var destination = preventLoop ? position : loop(position);
			style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
			position !== destination && emit("sh");
		}
	}
	function loop(position) {
		if (Splide2.is("loop")) {
			var index = toIndex(position);
			var exceededMax = index > Components2.Controller.getEnd();
			if (index < 0 || exceededMax) position = shift(position, exceededMax);
		}
		return position;
	}
	function shift(position, backwards) {
		var excess = position - getLimit(backwards);
		var size = sliderSize();
		position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
		return position;
	}
	function cancel() {
		translate(getPosition(), true);
		Transition.cancel();
	}
	function toIndex(position) {
		var Slides = Components2.Slides.get();
		var index = 0;
		var minDistance = Infinity;
		for (var i = 0; i < Slides.length; i++) {
			var slideIndex = Slides[i].index;
			var distance = abs(toPosition(slideIndex, true) - position);
			if (distance <= minDistance) {
				minDistance = distance;
				index = slideIndex;
			} else break;
		}
		return index;
	}
	function toPosition(index, trimming) {
		var position = orient(totalSize(index - 1) - offset(index));
		return trimming ? trim(position) : position;
	}
	function getPosition() {
		var left = resolve("left");
		return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
	}
	function trim(position) {
		if (options.trimSpace && Splide2.is("slide")) position = clamp(position, 0, orient(sliderSize(true) - listSize()));
		return position;
	}
	function offset(index) {
		var focus = options.focus;
		return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
	}
	function getLimit(max) {
		return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
	}
	function canShift(backwards) {
		var shifted = orient(shift(getPosition(), backwards));
		return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
	}
	function exceededLimit(max, position) {
		position = isUndefined(position) ? getPosition() : position;
		var exceededMin = max !== true && orient(position) < orient(getLimit(false));
		var exceededMax = max !== false && orient(position) > orient(getLimit(true));
		return exceededMin || exceededMax;
	}
	return {
		mount,
		move,
		jump,
		translate,
		shift,
		cancel,
		toIndex,
		toPosition,
		getPosition,
		getLimit,
		exceededLimit,
		reposition
	};
}
function Controller(Splide2, Components2, options) {
	var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
	var Move = Components2.Move;
	var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
	var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
	var omitEnd = options.omitEnd;
	var isLoop = Splide2.is(LOOP);
	var isSlide = Splide2.is(SLIDE);
	var getNext = apply$1(getAdjacent, false);
	var getPrev = apply$1(getAdjacent, true);
	var currIndex = options.start || 0;
	var endIndex;
	var prevIndex = currIndex;
	var slideCount;
	var perMove;
	var perPage;
	function mount() {
		init();
		on([
			EVENT_UPDATED,
			EVENT_REFRESH,
			"ei"
		], init);
		on(EVENT_RESIZED, onResized);
	}
	function init() {
		slideCount = getLength(true);
		perMove = options.perMove;
		perPage = options.perPage;
		endIndex = getEnd();
		var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
		if (index !== currIndex) {
			currIndex = index;
			Move.reposition();
		}
	}
	function onResized() {
		if (endIndex !== getEnd()) emit("ei");
	}
	function go(control, allowSameIndex, callback) {
		if (!isBusy()) {
			var dest = parse(control);
			var index = loop(dest);
			if (index > -1 && (allowSameIndex || index !== currIndex)) {
				setIndex(index);
				Move.move(dest, index, prevIndex, callback);
			}
		}
	}
	function scroll(destination, duration, snap, callback) {
		Components2.Scroll.scroll(destination, duration, snap, function() {
			var index = loop(Move.toIndex(getPosition()));
			setIndex(omitEnd ? min(index, endIndex) : index);
			callback && callback();
		});
	}
	function parse(control) {
		var index = currIndex;
		if (isString$1(control)) {
			var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
			if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
			else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
			else if (indicator === "<") index = getPrev(true);
		} else index = isLoop ? control : clamp(control, 0, endIndex);
		return index;
	}
	function getAdjacent(prev, destination) {
		var number = perMove || (hasFocus() ? 1 : perPage);
		var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
		if (dest === -1 && isSlide) {
			if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
		}
		return destination ? dest : loop(dest);
	}
	function computeDestIndex(dest, from, snapPage) {
		if (isEnough() || hasFocus()) {
			var index = computeMovableDestIndex(dest);
			if (index !== dest) {
				from = dest;
				dest = index;
				snapPage = false;
			}
			if (dest < 0 || dest > endIndex) {
				if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
				else if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
				else if (options.rewind) dest = dest < 0 ? endIndex : 0;
				else dest = -1;
			} else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
		} else dest = -1;
		return dest;
	}
	function computeMovableDestIndex(dest) {
		if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
			var position = getPosition();
			while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) dest < currIndex ? --dest : ++dest;
		}
		return dest;
	}
	function loop(index) {
		return isLoop ? (index + slideCount) % slideCount || 0 : index;
	}
	function getEnd() {
		var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
		while (omitEnd && end-- > 0) if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
			end++;
			break;
		}
		return clamp(end, 0, slideCount - 1);
	}
	function toIndex(page) {
		return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
	}
	function toPage(index) {
		return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
	}
	function toDest(destination) {
		var closest = Move.toIndex(destination);
		return isSlide ? clamp(closest, 0, endIndex) : closest;
	}
	function setIndex(index) {
		if (index !== currIndex) {
			prevIndex = currIndex;
			currIndex = index;
		}
	}
	function getIndex(prev) {
		return prev ? prevIndex : currIndex;
	}
	function hasFocus() {
		return !isUndefined(options.focus) || options.isNavigation;
	}
	function isBusy() {
		return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
	}
	return {
		mount,
		go,
		scroll,
		getNext,
		getPrev,
		getAdjacent,
		getEnd,
		setIndex,
		getIndex,
		toIndex,
		toPage,
		toDest,
		hasFocus,
		isBusy
	};
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
	var event = EventInterface(Splide2);
	var on = event.on, bind = event.bind, emit = event.emit;
	var classes = options.classes, i18n = options.i18n;
	var Elements = Components2.Elements, Controller = Components2.Controller;
	var placeholder = Elements.arrows, track = Elements.track;
	var wrapper = placeholder;
	var prev = Elements.prev;
	var next = Elements.next;
	var created;
	var wrapperClasses;
	var arrows = {};
	function mount() {
		init();
		on(EVENT_UPDATED, remount);
	}
	function remount() {
		destroy();
		mount();
	}
	function init() {
		var enabled = options.arrows;
		if (enabled && !(prev && next)) createArrows();
		if (prev && next) {
			assign(arrows, {
				prev,
				next
			});
			display(wrapper, enabled ? "" : "none");
			addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
			if (enabled) {
				listen();
				update();
				setAttribute([prev, next], ARIA_CONTROLS, track.id);
				emit(EVENT_ARROWS_MOUNTED, prev, next);
			}
		}
	}
	function destroy() {
		event.destroy();
		removeClass(wrapper, wrapperClasses);
		if (created) {
			remove$2(placeholder ? [prev, next] : wrapper);
			prev = next = null;
		} else removeAttribute([prev, next], ALL_ATTRIBUTES);
	}
	function listen() {
		on([
			EVENT_MOUNTED,
			EVENT_MOVED,
			EVENT_REFRESH,
			EVENT_SCROLLED,
			"ei"
		], update);
		bind(next, "click", apply$1(go, ">"));
		bind(prev, "click", apply$1(go, "<"));
	}
	function go(control) {
		Controller.go(control, true);
	}
	function createArrows() {
		wrapper = placeholder || create("div", classes.arrows);
		prev = createArrow(true);
		next = createArrow(false);
		created = true;
		append(wrapper, [prev, next]);
		!placeholder && before(wrapper, track);
	}
	function createArrow(prev2) {
		return parseHtml("<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || PATH) + "\" />");
	}
	function update() {
		if (prev && next) {
			var index = Splide2.index;
			var prevIndex = Controller.getPrev();
			var nextIndex = Controller.getNext();
			var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
			var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
			prev.disabled = prevIndex < 0;
			next.disabled = nextIndex < 0;
			setAttribute(prev, ARIA_LABEL, prevLabel);
			setAttribute(next, ARIA_LABEL, nextLabel);
			emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
		}
	}
	return {
		arrows,
		mount,
		destroy,
		update
	};
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(Splide2, Components2, options) {
	var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
	var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
	var isPaused = interval.isPaused;
	var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
	var autoplay = options.autoplay;
	var hovered;
	var focused;
	var stopped = autoplay === "pause";
	function mount() {
		if (autoplay) {
			listen();
			toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
			stopped || play();
			update();
		}
	}
	function listen() {
		if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
			hovered = e.type === "mouseenter";
			autoToggle();
		});
		if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
			focused = e.type === "focusin";
			autoToggle();
		});
		if (toggle) bind(toggle, "click", function() {
			stopped ? play() : pause(true);
		});
		on([
			EVENT_MOVE,
			EVENT_SCROLL,
			EVENT_REFRESH
		], interval.rewind);
		on(EVENT_MOVE, onMove);
	}
	function play() {
		if (isPaused() && Components2.Slides.isEnough()) {
			interval.start(!options.resetProgress);
			focused = hovered = stopped = false;
			update();
			emit(EVENT_AUTOPLAY_PLAY);
		}
	}
	function pause(stop) {
		if (stop === void 0) stop = true;
		stopped = !!stop;
		update();
		if (!isPaused()) {
			interval.pause();
			emit(EVENT_AUTOPLAY_PAUSE);
		}
	}
	function autoToggle() {
		if (!stopped) hovered || focused ? pause(false) : play();
	}
	function update() {
		if (toggle) {
			toggleClass(toggle, CLASS_ACTIVE, !stopped);
			setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
		}
	}
	function onAnimationFrame(rate) {
		var bar = Elements.bar;
		bar && style(bar, "width", rate * 100 + "%");
		emit(EVENT_AUTOPLAY_PLAYING, rate);
	}
	function onMove(index) {
		var Slide = Components2.Slides.getAt(index);
		interval.set(Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
	}
	return {
		mount,
		destroy: interval.cancel,
		play,
		pause,
		isPaused
	};
}
function Cover(Splide2, Components2, options) {
	var on = EventInterface(Splide2).on;
	function mount() {
		if (options.cover) {
			on(EVENT_LAZYLOAD_LOADED, apply$1(toggle, true));
			on([
				EVENT_MOUNTED,
				EVENT_UPDATED,
				EVENT_REFRESH
			], apply$1(cover, true));
		}
	}
	function cover(cover2) {
		Components2.Slides.forEach(function(Slide) {
			var img = child(Slide.container || Slide.slide, "img");
			if (img && img.src) toggle(cover2, img, Slide);
		});
	}
	function toggle(cover2, img, Slide) {
		Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
		display(img, cover2 ? "none" : "");
	}
	return {
		mount,
		destroy: apply$1(cover, false)
	};
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = .6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
	var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
	var set = Splide2.state.set;
	var Move = Components2.Move;
	var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
	var isSlide = Splide2.is(SLIDE);
	var interval;
	var callback;
	var friction = 1;
	function mount() {
		on(EVENT_MOVE, clear);
		on([EVENT_UPDATED, EVENT_REFRESH], cancel);
	}
	function scroll(destination, duration, snap, onScrolled, noConstrain) {
		var from = getPosition();
		clear();
		if (snap && (!isSlide || !exceededLimit())) {
			var size = Components2.Layout.sliderSize();
			var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
			destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
		}
		var noDistance = approximatelyEqual(from, destination, 1);
		friction = 1;
		duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
		callback = onScrolled;
		interval = RequestInterval(duration, onEnd, apply$1(update, from, destination, noConstrain), 1);
		set(SCROLLING);
		emit(EVENT_SCROLL);
		interval.start();
	}
	function onEnd() {
		set(IDLE);
		callback && callback();
		emit(EVENT_SCROLLED);
	}
	function update(from, to, noConstrain, rate) {
		var position = getPosition();
		var diff = (from + (to - from) * easing(rate) - position) * friction;
		translate(position + diff);
		if (isSlide && !noConstrain && exceededLimit()) {
			friction *= FRICTION_FACTOR;
			if (abs(diff) < BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
		}
	}
	function clear() {
		if (interval) interval.cancel();
	}
	function cancel() {
		if (interval && !interval.isPaused()) {
			clear();
			onEnd();
		}
	}
	function easing(t) {
		var easingFunc = options.easingFunc;
		return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
	}
	return {
		mount,
		destroy: clear,
		scroll,
		cancel
	};
}
var SCROLL_LISTENER_OPTIONS = {
	passive: false,
	capture: true
};
function Drag(Splide2, Components2, options) {
	var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
	var state = Splide2.state;
	var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
	var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
	var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
	var basePosition;
	var baseEvent;
	var prevBaseEvent;
	var isFree;
	var dragging;
	var exceeded = false;
	var clickPrevented;
	var disabled;
	var target;
	function mount() {
		bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
		bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
		bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
		bind(track, "click", onClick, { capture: true });
		bind(track, "dragstart", prevent);
		on([EVENT_MOUNTED, EVENT_UPDATED], init);
	}
	function init() {
		var drag = options.drag;
		disable(!drag);
		isFree = drag === "free";
	}
	function onPointerDown(e) {
		clickPrevented = false;
		if (!disabled) {
			var isTouch = isTouchEvent(e);
			if (isDraggable(e.target) && (isTouch || !e.button)) {
				if (!Controller.isBusy()) {
					target = isTouch ? track : window;
					dragging = state.is([MOVING, SCROLLING]);
					prevBaseEvent = null;
					bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
					bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
					Move.cancel();
					Scroll.cancel();
					save(e);
				} else prevent(e, true);
			}
		}
	}
	function onPointerMove(e) {
		if (!state.is(DRAGGING)) {
			state.set(DRAGGING);
			emit(EVENT_DRAG);
		}
		if (e.cancelable) {
			if (dragging) {
				Move.translate(basePosition + constrain(diffCoord(e)));
				var expired = diffTime(e) > LOG_INTERVAL;
				var hasExceeded = exceeded !== (exceeded = exceededLimit());
				if (expired || hasExceeded) save(e);
				clickPrevented = true;
				emit(EVENT_DRAGGING);
				prevent(e);
			} else if (isSliderDirection(e)) {
				dragging = shouldStart(e);
				prevent(e);
			}
		}
	}
	function onPointerUp(e) {
		if (state.is(DRAGGING)) {
			state.set(IDLE);
			emit(EVENT_DRAGGED);
		}
		if (dragging) {
			move(e);
			prevent(e);
		}
		unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
		unbind(target, POINTER_UP_EVENTS, onPointerUp);
		dragging = false;
	}
	function onClick(e) {
		if (!disabled && clickPrevented) prevent(e, true);
	}
	function save(e) {
		prevBaseEvent = baseEvent;
		baseEvent = e;
		basePosition = getPosition();
	}
	function move(e) {
		var velocity = computeVelocity(e);
		var destination = computeDestination(velocity);
		var rewind = options.rewind && options.rewindByDrag;
		reduce(false);
		if (isFree) Controller.scroll(destination, 0, options.snap);
		else if (Splide2.is("fade")) Controller.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
		else if (Splide2.is("slide") && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
		else Controller.go(Controller.toDest(destination), true);
		reduce(true);
	}
	function shouldStart(e) {
		var thresholds = options.dragMinThreshold;
		var isObj = isObject$1(thresholds);
		var mouse = isObj && thresholds.mouse || 0;
		var touch = (isObj ? thresholds.touch : +thresholds) || 10;
		return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
	}
	function isSliderDirection(e) {
		return abs(diffCoord(e)) > abs(diffCoord(e, true));
	}
	function computeVelocity(e) {
		if (Splide2.is("loop") || !exceeded) {
			var time = diffTime(e);
			if (time && time < LOG_INTERVAL) return diffCoord(e) / time;
		}
		return 0;
	}
	function computeDestination(velocity) {
		return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
	}
	function diffCoord(e, orthogonal) {
		return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
	}
	function diffTime(e) {
		return timeOf(e) - timeOf(getBaseEvent(e));
	}
	function getBaseEvent(e) {
		return baseEvent === e && prevBaseEvent || baseEvent;
	}
	function coordOf(e, orthogonal) {
		return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
	}
	function constrain(diff) {
		return diff / (exceeded && Splide2.is("slide") ? FRICTION : 1);
	}
	function isDraggable(target2) {
		var noDrag = options.noDrag;
		return !matches(target2, ".splide__pagination__page, .splide__arrow") && (!noDrag || !matches(target2, noDrag));
	}
	function isTouchEvent(e) {
		return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
	}
	function isDragging() {
		return dragging;
	}
	function disable(value) {
		disabled = value;
	}
	return {
		mount,
		disable,
		isDragging
	};
}
var NORMALIZATION_MAP = {
	Spacebar: " ",
	Right: ARROW_RIGHT,
	Left: ARROW_LEFT,
	Up: ARROW_UP,
	Down: ARROW_DOWN
};
function normalizeKey$1(key) {
	key = isString$1(key) ? key : key.key;
	return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(Splide2, Components2, options) {
	var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
	var root = Splide2.root;
	var resolve = Components2.Direction.resolve;
	var target;
	var disabled;
	function mount() {
		init();
		on(EVENT_UPDATED, destroy);
		on(EVENT_UPDATED, init);
		on(EVENT_MOVE, onMove);
	}
	function init() {
		var keyboard = options.keyboard;
		if (keyboard) {
			target = keyboard === "global" ? window : root;
			bind(target, KEYBOARD_EVENT, onKeydown);
		}
	}
	function destroy() {
		unbind(target, KEYBOARD_EVENT);
	}
	function disable(value) {
		disabled = value;
	}
	function onMove() {
		var _disabled = disabled;
		disabled = true;
		nextTick$1(function() {
			disabled = _disabled;
		});
	}
	function onKeydown(e) {
		if (!disabled) {
			var key = normalizeKey$1(e);
			if (key === resolve(ARROW_LEFT)) Splide2.go("<");
			else if (key === resolve(ARROW_RIGHT)) Splide2.go(">");
		}
	}
	return {
		mount,
		destroy,
		disable
	};
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(Splide2, Components2, options) {
	var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
	var isSequential = options.lazyLoad === "sequential";
	var events = [EVENT_MOVED, EVENT_SCROLLED];
	var entries = [];
	function mount() {
		if (options.lazyLoad) {
			init();
			on(EVENT_REFRESH, init);
		}
	}
	function init() {
		empty(entries);
		register();
		if (isSequential) loadNext();
		else {
			off(events);
			on(events, check);
			check();
		}
	}
	function register() {
		Components2.Slides.forEach(function(Slide) {
			queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function(img) {
				var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
				var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
				if (src !== img.src || srcset !== img.srcset) {
					var className = options.classes.spinner;
					var parent = img.parentElement;
					var spinner = child(parent, "." + className) || create("span", className, parent);
					entries.push([
						img,
						Slide,
						spinner
					]);
					img.src || display(img, "none");
				}
			});
		});
	}
	function check() {
		entries = entries.filter(function(data) {
			var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
			return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
		});
		entries.length || off(events);
	}
	function load(data) {
		var img = data[0];
		addClass(data[1].slide, CLASS_LOADING);
		bind(img, "load error", apply$1(onLoad, data));
		setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
		setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
		removeAttribute(img, SRC_DATA_ATTRIBUTE);
		removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
	}
	function onLoad(data, e) {
		var img = data[0], Slide = data[1];
		removeClass(Slide.slide, CLASS_LOADING);
		if (e.type !== "error") {
			remove$2(data[2]);
			display(img, "");
			emit(EVENT_LAZYLOAD_LOADED, img, Slide);
			emit(EVENT_RESIZE);
		}
		isSequential && loadNext();
	}
	function loadNext() {
		entries.length && load(entries.shift());
	}
	return {
		mount,
		destroy: apply$1(empty, entries),
		check
	};
}
function Pagination(Splide2, Components2, options) {
	var event = EventInterface(Splide2);
	var on = event.on, emit = event.emit, bind = event.bind;
	var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
	var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
	var resolve = Components2.Direction.resolve;
	var placeholder = Elements.pagination;
	var items = [];
	var list;
	var paginationClasses;
	function mount() {
		destroy();
		on([
			EVENT_UPDATED,
			EVENT_REFRESH,
			"ei"
		], mount);
		var enabled = options.pagination;
		placeholder && display(placeholder, enabled ? "" : "none");
		if (enabled) {
			on([
				EVENT_MOVE,
				EVENT_SCROLL,
				EVENT_SCROLLED
			], update);
			createPagination();
			update();
			emit(EVENT_PAGINATION_MOUNTED, {
				list,
				items
			}, getAt(Splide2.index));
		}
	}
	function destroy() {
		if (list) {
			remove$2(placeholder ? slice(list.children) : list);
			removeClass(list, paginationClasses);
			empty(items);
			list = null;
		}
		event.destroy();
	}
	function createPagination() {
		var length = Splide2.length;
		var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
		var max = hasFocus() ? Controller.getEnd() + 1 : ceil(length / perPage);
		list = placeholder || create("ul", classes.pagination, Elements.track.parentElement);
		addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
		setAttribute(list, ROLE, "tablist");
		setAttribute(list, ARIA_LABEL, i18n.select);
		setAttribute(list, ARIA_ORIENTATION, getDirection() === "ttb" ? "vertical" : "");
		for (var i = 0; i < max; i++) {
			var li = create("li", null, list);
			var button = create("button", {
				class: classes.page,
				type: "button"
			}, li);
			var controls = Slides.getIn(i).map(function(Slide) {
				return Slide.slide.id;
			});
			var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
			bind(button, "click", apply$1(onClick, i));
			if (options.paginationKeyboard) bind(button, "keydown", apply$1(onKeydown, i));
			setAttribute(li, ROLE, "presentation");
			setAttribute(button, ROLE, "tab");
			setAttribute(button, ARIA_CONTROLS, controls.join(" "));
			setAttribute(button, ARIA_LABEL, format(text, i + 1));
			setAttribute(button, TAB_INDEX, -1);
			items.push({
				li,
				button,
				page: i
			});
		}
	}
	function onClick(page) {
		go(">" + page, true);
	}
	function onKeydown(page, e) {
		var length = items.length;
		var key = normalizeKey$1(e);
		var dir = getDirection();
		var nextPage = -1;
		if (key === resolve(ARROW_RIGHT, false, dir)) nextPage = ++page % length;
		else if (key === resolve(ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
		else if (key === "Home") nextPage = 0;
		else if (key === "End") nextPage = length - 1;
		var item = items[nextPage];
		if (item) {
			focus(item.button);
			go(">" + nextPage);
			prevent(e, true);
		}
	}
	function getDirection() {
		return options.paginationDirection || options.direction;
	}
	function getAt(index) {
		return items[Controller.toPage(index)];
	}
	function update() {
		var prev = getAt(getIndex(true));
		var curr = getAt(getIndex());
		if (prev) {
			var button = prev.button;
			removeClass(button, CLASS_ACTIVE);
			removeAttribute(button, ARIA_SELECTED);
			setAttribute(button, TAB_INDEX, -1);
		}
		if (curr) {
			var _button = curr.button;
			addClass(_button, CLASS_ACTIVE);
			setAttribute(_button, ARIA_SELECTED, true);
			setAttribute(_button, TAB_INDEX, "");
		}
		emit(EVENT_PAGINATION_UPDATED, {
			list,
			items
		}, prev, curr);
	}
	return {
		items,
		mount,
		destroy,
		getAt,
		update
	};
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(Splide2, Components2, options) {
	var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
	var events = [];
	function mount() {
		Splide2.splides.forEach(function(target) {
			if (!target.isParent) {
				sync(Splide2, target.splide);
				sync(target.splide, Splide2);
			}
		});
		if (isNavigation) navigate();
	}
	function destroy() {
		events.forEach(function(event) {
			event.destroy();
		});
		empty(events);
	}
	function remount() {
		destroy();
		mount();
	}
	function sync(splide, target) {
		var event = EventInterface(splide);
		event.on(EVENT_MOVE, function(index, prev, dest) {
			target.go(target.is("loop") ? dest : index);
		});
		events.push(event);
	}
	function navigate() {
		var event = EventInterface(Splide2);
		var on = event.on;
		on(EVENT_CLICK, onClick);
		on("sk", onKeydown);
		on([EVENT_MOUNTED, EVENT_UPDATED], update);
		events.push(event);
		event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
	}
	function update() {
		setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === "ttb" ? "vertical" : "");
	}
	function onClick(Slide) {
		Splide2.go(Slide.index);
	}
	function onKeydown(Slide, e) {
		if (includes(TRIGGER_KEYS, normalizeKey$1(e))) {
			onClick(Slide);
			prevent(e);
		}
	}
	return {
		setup: apply$1(Components2.Media.set, { slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus }, true),
		mount,
		destroy,
		remount
	};
}
function Wheel(Splide2, Components2, options) {
	var bind = EventInterface(Splide2).bind;
	var lastTime = 0;
	function mount() {
		if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
	}
	function onWheel(e) {
		if (e.cancelable) {
			var deltaY = e.deltaY;
			var backwards = deltaY < 0;
			var timeStamp = timeOf(e);
			var _min = options.wheelMinThreshold || 0;
			var sleep = options.wheelSleep || 0;
			if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
				Splide2.go(backwards ? "<" : ">");
				lastTime = timeStamp;
			}
			shouldPrevent(backwards) && prevent(e);
		}
	}
	function shouldPrevent(backwards) {
		return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
	}
	return { mount };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
	var on = EventInterface(Splide2).on;
	var track = Components2.Elements.track;
	var enabled = options.live && !options.isNavigation;
	var sr = create("span", CLASS_SR);
	var interval = RequestInterval(SR_REMOVAL_DELAY, apply$1(toggle, false));
	function mount() {
		if (enabled) {
			disable(!Components2.Autoplay.isPaused());
			setAttribute(track, ARIA_ATOMIC, true);
			sr.textContent = "…";
			on(EVENT_AUTOPLAY_PLAY, apply$1(disable, true));
			on(EVENT_AUTOPLAY_PAUSE, apply$1(disable, false));
			on([EVENT_MOVED, EVENT_SCROLLED], apply$1(toggle, true));
		}
	}
	function toggle(active) {
		setAttribute(track, ARIA_BUSY, active);
		if (active) {
			append(track, sr);
			interval.start();
		} else {
			remove$2(sr);
			interval.cancel();
		}
	}
	function destroy() {
		removeAttribute(track, [
			ARIA_LIVE,
			ARIA_ATOMIC,
			ARIA_BUSY
		]);
		remove$2(sr);
	}
	function disable(disabled) {
		if (enabled) setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
	}
	return {
		mount,
		disable,
		destroy
	};
}
var ComponentConstructors = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	Media,
	Direction,
	Elements,
	Slides,
	Layout,
	Clones,
	Move,
	Controller,
	Arrows,
	Autoplay,
	Cover,
	Scroll,
	Drag,
	Keyboard,
	LazyLoad,
	Pagination,
	Sync,
	Wheel,
	Live
});
var DEFAULTS = {
	type: "slide",
	role: "region",
	speed: 400,
	perPage: 1,
	cloneStatus: true,
	arrows: true,
	pagination: true,
	paginationKeyboard: true,
	interval: 5e3,
	pauseOnHover: true,
	pauseOnFocus: true,
	resetProgress: true,
	easing: "cubic-bezier(0.25, 1, 0.5, 1)",
	drag: true,
	direction: "ltr",
	trimSpace: true,
	focusableNodes: "a, button, textarea, input, select, iframe",
	live: true,
	classes: CLASSES,
	i18n: {
		prev: "Previous slide",
		next: "Next slide",
		first: "Go to first slide",
		last: "Go to last slide",
		slideX: "Go to slide %s",
		pageX: "Go to page %s",
		play: "Start autoplay",
		pause: "Pause autoplay",
		carousel: "carousel",
		slide: "slide",
		select: "Select a slide to show",
		slideLabel: "%s of %s"
	},
	reducedMotion: {
		speed: 0,
		rewindSpeed: 0,
		autoplay: "pause"
	}
};
function Fade(Splide2, Components2, options) {
	var Slides = Components2.Slides;
	function mount() {
		EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
	}
	function init() {
		Slides.forEach(function(Slide) {
			Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
		});
	}
	function start(index, done) {
		Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
		nextTick$1(done);
	}
	return {
		mount,
		start,
		cancel: noop
	};
}
function Slide(Splide2, Components2, options) {
	var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
	var list = Components2.Elements.list;
	var transition = apply$1(style, list, "transition");
	var endCallback;
	function mount() {
		EventInterface(Splide2).bind(list, "transitionend", function(e) {
			if (e.target === list && endCallback) {
				cancel();
				endCallback();
			}
		});
	}
	function start(index, done) {
		var destination = Move.toPosition(index, true);
		var position = Move.getPosition();
		var speed = getSpeed(index);
		if (abs(destination - position) >= 1 && speed >= 1) {
			if (options.useScroll) Scroll.scroll(destination, speed, false, done);
			else {
				transition("transform " + speed + "ms " + options.easing);
				Move.translate(destination, true);
				endCallback = done;
			}
		} else {
			Move.jump(index);
			done();
		}
	}
	function cancel() {
		transition("");
		Scroll.cancel();
	}
	function getSpeed(index) {
		var rewindSpeed = options.rewindSpeed;
		if (Splide2.is("slide") && rewindSpeed) {
			var prev = Controller.getIndex(true);
			var end = Controller.getEnd();
			if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
		}
		return options.speed;
	}
	return {
		mount,
		start,
		cancel
	};
}
var Splide = /* @__PURE__ */ function() {
	function _Splide(target, options) {
		this.event = EventInterface();
		this.Components = {};
		this.state = State(CREATED);
		this.splides = [];
		this._o = {};
		this._E = {};
		var root = isString$1(target) ? query(document, target) : target;
		assert(root, root + " is invalid.");
		this.root = root;
		options = merge({
			label: getAttribute(root, ARIA_LABEL) || "",
			labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
		}, DEFAULTS, _Splide.defaults, options || {});
		try {
			merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
		} catch (e) {
			assert(false, "Invalid JSON");
		}
		this._o = Object.create(merge({}, options));
	}
	var _proto = _Splide.prototype;
	_proto.mount = function mount(Extensions, Transition) {
		var _this = this;
		var state = this.state, Components2 = this.Components;
		assert(state.is([CREATED, DESTROYED]), "Already mounted!");
		state.set(CREATED);
		this._C = Components2;
		this._T = Transition || this._T || (this.is("fade") ? Fade : Slide);
		this._E = Extensions || this._E;
		forOwn(assign({}, ComponentConstructors, this._E, { Transition: this._T }), function(Component, key) {
			var component = Component(_this, Components2, _this._o);
			Components2[key] = component;
			component.setup && component.setup();
		});
		forOwn(Components2, function(component) {
			component.mount && component.mount();
		});
		this.emit(EVENT_MOUNTED);
		addClass(this.root, CLASS_INITIALIZED);
		state.set(IDLE);
		this.emit(EVENT_READY);
		return this;
	};
	_proto.sync = function sync(splide) {
		this.splides.push({ splide });
		splide.splides.push({
			splide: this,
			isParent: true
		});
		if (this.state.is(IDLE)) {
			this._C.Sync.remount();
			splide.Components.Sync.remount();
		}
		return this;
	};
	_proto.go = function go(control) {
		this._C.Controller.go(control);
		return this;
	};
	_proto.on = function on(events, callback) {
		this.event.on(events, callback);
		return this;
	};
	_proto.off = function off(events) {
		this.event.off(events);
		return this;
	};
	_proto.emit = function emit(event) {
		var _this$event;
		(_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
		return this;
	};
	_proto.add = function add(slides, index) {
		this._C.Slides.add(slides, index);
		return this;
	};
	_proto.remove = function remove(matcher) {
		this._C.Slides.remove(matcher);
		return this;
	};
	_proto.is = function is(type) {
		return this._o.type === type;
	};
	_proto.refresh = function refresh() {
		this.emit(EVENT_REFRESH);
		return this;
	};
	_proto.destroy = function destroy(completely) {
		if (completely === void 0) completely = true;
		var event = this.event, state = this.state;
		if (state.is(CREATED)) EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
		else {
			forOwn(this._C, function(component) {
				component.destroy && component.destroy(completely);
			}, true);
			event.emit(EVENT_DESTROY);
			event.destroy();
			completely && empty(this.splides);
			state.set(DESTROYED);
		}
		return this;
	};
	_createClass(_Splide, [
		{
			key: "options",
			get: function get() {
				return this._o;
			},
			set: function set(options) {
				this._C.Media.set(options, true, true);
			}
		},
		{
			key: "length",
			get: function get() {
				return this._C.Slides.getLength(true);
			}
		},
		{
			key: "index",
			get: function get() {
				return this._C.Controller.getIndex();
			}
		}
	]);
	return _Splide;
}();
Splide.defaults = {};
Splide.STATES = STATES;
//#endregion
//#region node_modules/@vue/shared/dist/shared.esm-bundler.js
/**
* @vue/shared v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
// @__NO_SIDE_EFFECTS__
function makeMap(str) {
	const map = /* @__PURE__ */ Object.create(null);
	for (const key of str.split(",")) map[key] = 1;
	return (val) => val in map;
}
var EMPTY_OBJ = {};
var EMPTY_ARR = [];
var NOOP = () => {};
var NO = () => false;
var isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
var isModelListener = (key) => key.startsWith("onUpdate:");
var extend = Object.assign;
var remove = (arr, el) => {
	const i = arr.indexOf(el);
	if (i > -1) arr.splice(i, 1);
};
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var hasOwn = (val, key) => hasOwnProperty$1.call(val, key);
var isArray = Array.isArray;
var isMap = (val) => toTypeString(val) === "[object Map]";
var isSet = (val) => toTypeString(val) === "[object Set]";
var isDate = (val) => toTypeString(val) === "[object Date]";
var isFunction = (val) => typeof val === "function";
var isString = (val) => typeof val === "string";
var isSymbol = (val) => typeof val === "symbol";
var isObject = (val) => val !== null && typeof val === "object";
var isPromise = (val) => {
	return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
var objectToString = Object.prototype.toString;
var toTypeString = (value) => objectToString.call(value);
var toRawType = (value) => {
	return toTypeString(value).slice(8, -1);
};
var isPlainObject = (val) => toTypeString(val) === "[object Object]";
var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var isReservedProp = /* @__PURE__ */ makeMap(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var cacheStringFunction = (fn) => {
	const cache = /* @__PURE__ */ Object.create(null);
	return ((str) => {
		return cache[str] || (cache[str] = fn(str));
	});
};
var camelizeRE = /-\w/g;
var camelize = cacheStringFunction((str) => {
	return str.replace(camelizeRE, (c) => c.slice(1).toUpperCase());
});
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
var capitalize = cacheStringFunction((str) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
});
var toHandlerKey = cacheStringFunction((str) => {
	return str ? `on${capitalize(str)}` : ``;
});
var hasChanged = (value, oldValue) => !Object.is(value, oldValue);
var invokeArrayFns = (fns, ...arg) => {
	for (let i = 0; i < fns.length; i++) fns[i](...arg);
};
var def = (obj, key, value, writable = false) => {
	Object.defineProperty(obj, key, {
		configurable: true,
		enumerable: false,
		writable,
		value
	});
};
var looseToNumber = (val) => {
	const n = parseFloat(val);
	return isNaN(n) ? val : n;
};
var _globalThis;
var getGlobalThis = () => {
	return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function normalizeStyle(value) {
	if (isArray(value)) {
		const res = {};
		for (let i = 0; i < value.length; i++) {
			const item = value[i];
			const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
			if (normalized) for (const key in normalized) res[key] = normalized[key];
		}
		return res;
	} else if (isString(value) || isObject(value)) return value;
}
var listDelimiterRE = /;(?![^(]*\))/g;
var propertyDelimiterRE = /:([^]+)/;
var styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
	const ret = {};
	cssText.replace(styleCommentRE, (match) => match.startsWith("/*") ? "" : match).split(listDelimiterRE).forEach((item) => {
		if (item) {
			const tmp = item.split(propertyDelimiterRE);
			tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
		}
	});
	return ret;
}
function normalizeClass(value) {
	let res = "";
	if (isString(value)) res = value;
	else if (isArray(value)) for (let i = 0; i < value.length; i++) {
		const normalized = normalizeClass(value[i]);
		if (normalized) res += normalized + " ";
	}
	else if (isObject(value)) {
		for (const name in value) if (value[name]) res += name + " ";
	}
	return res.trim();
}
var isSpecialBooleanAttr = /* @__PURE__ */ makeMap(`itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,playsinline,readonly`);
function includeBooleanAttr(value) {
	return !!value || value === "";
}
function looseCompareArrays(a, b, seen) {
	if (a.length !== b.length) return false;
	let equal = true;
	for (let i = 0; equal && i < a.length; i++) equal = looseEqual(a[i], b[i], seen);
	return equal;
}
function looseCompareCollections(a, b, seen) {
	if (a.size !== b.size) return false;
	const candidates = Array.from(b);
	const matched = new Uint8Array(candidates.length);
	for (const item of a) {
		let index = -1;
		for (let i = 0; i < candidates.length; i++) if (!matched[i] && looseEqual(item, candidates[i], seen)) {
			index = i;
			break;
		}
		if (index < 0) return false;
		matched[index] = 1;
	}
	return true;
}
function looseCompareObjects(a, b, seen) {
	let aValidType = isMap(a);
	let bValidType = isMap(b);
	if (aValidType || bValidType) return aValidType && bValidType ? looseCompareCollections(a, b, seen) : false;
	aValidType = isSet(a);
	bValidType = isSet(b);
	if (aValidType || bValidType) return aValidType && bValidType ? looseCompareCollections(a, b, seen) : false;
	if (Object.keys(a).length !== Object.keys(b).length) return false;
	for (const key in a) {
		const aHasKey = a.hasOwnProperty(key);
		const bHasKey = b.hasOwnProperty(key);
		if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key], seen)) return false;
	}
	return String(a) === String(b);
}
function looseCompareNested(a, b, seen, compare) {
	if (!seen) seen = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()];
	const [seenA, seenB] = seen;
	if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
	seenA.set(a, b);
	seenB.set(b, a);
	const equal = compare(a, b, seen);
	seenA.delete(a);
	seenB.delete(b);
	return equal;
}
function looseEqual(a, b, seen) {
	if (a === b) return true;
	let aValidType = isDate(a);
	let bValidType = isDate(b);
	if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
	aValidType = isSymbol(a);
	bValidType = isSymbol(b);
	if (aValidType || bValidType) return a === b;
	aValidType = isArray(a);
	bValidType = isArray(b);
	if (aValidType || bValidType) return aValidType && bValidType ? looseCompareNested(a, b, seen, looseCompareArrays) : false;
	aValidType = isObject(a);
	bValidType = isObject(b);
	if (aValidType || bValidType) {
		if (!aValidType || !bValidType) return false;
		return looseCompareNested(a, b, seen, looseCompareObjects);
	}
	return String(a) === String(b);
}
var isRef$1 = (val) => {
	return !!(val && val["__v_isRef"] === true);
};
var toDisplayString = (val) => {
	return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef$1(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
var replacer = (_key, val) => {
	if (isRef$1(val)) return replacer(_key, val.value);
	else if (isMap(val)) return { [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val2], i) => {
		entries[stringifySymbol(key, i) + " =>"] = val2;
		return entries;
	}, {}) };
	else if (isSet(val)) return { [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v)) };
	else if (isSymbol(val)) return stringifySymbol(val);
	else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
	return val;
};
var stringifySymbol = (v, i = "") => {
	var _a;
	return isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v;
};
//#endregion
//#region node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
/**
* @vue/reactivity v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
var activeEffectScope;
var EffectScope = class {
	constructor(detached = false) {
		this.detached = detached;
		/**
		* @internal
		*/
		this._active = true;
		/**
		* @internal track `on` calls, allow `on` call multiple times
		*/
		this._on = 0;
		/**
		* @internal
		*/
		this.effects = [];
		/**
		* @internal
		*/
		this.cleanups = [];
		this._isPaused = false;
		this._warnOnRun = true;
		this.__v_skip = true;
		if (!detached && activeEffectScope) {
			if (activeEffectScope.active) {
				this.parent = activeEffectScope;
				this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
			} else {
				this._active = false;
				this._warnOnRun = false;
			}
		}
	}
	get active() {
		return this._active;
	}
	pause() {
		if (this._active) {
			this._isPaused = true;
			let i, l;
			if (this.scopes) {
				const scopes = this.scopes.slice();
				for (i = 0, l = scopes.length; i < l; i++) scopes[i].pause();
			}
			for (i = 0, l = this.effects.length; i < l; i++) this.effects[i].pause();
		}
	}
	/**
	* Resumes the effect scope, including all child scopes and effects.
	*/
	resume() {
		if (this._active) {
			if (this._isPaused) {
				this._isPaused = false;
				let i, l;
				if (this.scopes) {
					const scopes = this.scopes.slice();
					for (i = 0, l = scopes.length; i < l; i++) scopes[i].resume();
				}
				const effects = this.effects.slice();
				for (i = 0, l = effects.length; i < l; i++) effects[i].resume();
			}
		}
	}
	run(fn) {
		if (this._active) {
			const currentEffectScope = activeEffectScope;
			try {
				activeEffectScope = this;
				return fn();
			} finally {
				activeEffectScope = currentEffectScope;
			}
		}
	}
	/**
	* This should only be called on non-detached scopes
	* @internal
	*/
	on() {
		if (++this._on === 1) {
			this.prevScope = activeEffectScope;
			activeEffectScope = this;
		}
	}
	/**
	* This should only be called on non-detached scopes
	* @internal
	*/
	off() {
		if (this._on > 0 && --this._on === 0) {
			if (activeEffectScope === this) activeEffectScope = this.prevScope;
			else {
				let current = activeEffectScope;
				while (current) {
					if (current.prevScope === this) {
						current.prevScope = this.prevScope;
						break;
					}
					current = current.prevScope;
				}
			}
			this.prevScope = void 0;
		}
	}
	stop(fromParent) {
		if (this._active) {
			this._active = false;
			let i, l;
			for (i = 0, l = this.effects.length; i < l; i++) this.effects[i].stop();
			this.effects.length = 0;
			for (i = 0, l = this.cleanups.length; i < l; i++) this.cleanups[i]();
			this.cleanups.length = 0;
			if (this.scopes) {
				const scopes = this.scopes.slice();
				for (i = 0, l = scopes.length; i < l; i++) scopes[i].stop(true);
				this.scopes.length = 0;
			}
			if (!this.detached && this.parent && !fromParent) {
				const last = this.parent.scopes.pop();
				if (last && last !== this) {
					this.parent.scopes[this.index] = last;
					last.index = this.index;
				}
			}
			this.parent = void 0;
		}
	}
};
function getCurrentScope() {
	return activeEffectScope;
}
var activeSub;
var pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var ReactiveEffect = class {
	constructor(fn) {
		this.fn = fn;
		/**
		* @internal
		*/
		this.deps = void 0;
		/**
		* @internal
		*/
		this.depsTail = void 0;
		/**
		* @internal
		*/
		this.flags = 5;
		/**
		* @internal
		*/
		this.next = void 0;
		/**
		* @internal
		*/
		this.cleanup = void 0;
		this.scheduler = void 0;
		if (activeEffectScope) {
			if (activeEffectScope.active) activeEffectScope.effects.push(this);
			else this.flags &= -2;
		}
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		if (this.flags & 64) {
			this.flags &= -65;
			if (pausedQueueEffects.has(this)) {
				pausedQueueEffects.delete(this);
				this.trigger();
			}
		}
	}
	/**
	* @internal
	*/
	notify() {
		if (this.flags & 2 && !(this.flags & 32)) return;
		if (!(this.flags & 8)) batch(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2;
		cleanupEffect(this);
		prepareDeps(this);
		const prevEffect = activeSub;
		const prevShouldTrack = shouldTrack;
		activeSub = this;
		shouldTrack = true;
		try {
			return this.fn();
		} finally {
			cleanupDeps(this);
			activeSub = prevEffect;
			shouldTrack = prevShouldTrack;
			this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let link = this.deps; link; link = link.nextDep) removeSub(link);
			this.deps = this.depsTail = void 0;
			cleanupEffect(this);
			this.onStop && this.onStop();
			this.flags &= -2;
		}
	}
	trigger() {
		if (this.flags & 64) pausedQueueEffects.add(this);
		else if (this.scheduler) this.scheduler();
		else this.runIfDirty();
	}
	/**
	* @internal
	*/
	runIfDirty() {
		if (isDirty(this)) this.run();
	}
	get dirty() {
		return isDirty(this);
	}
};
var batchDepth = 0;
var batchedSub;
var batchedComputed;
function batch(sub, isComputed = false) {
	sub.flags |= 8;
	if (isComputed) {
		sub.next = batchedComputed;
		batchedComputed = sub;
		return;
	}
	sub.next = batchedSub;
	batchedSub = sub;
}
function startBatch() {
	batchDepth++;
}
function endBatch() {
	if (--batchDepth > 0) return;
	if (batchedComputed) {
		let e = batchedComputed;
		batchedComputed = void 0;
		while (e) {
			const next = e.next;
			e.next = void 0;
			e.flags &= -9;
			e = next;
		}
	}
	let error;
	while (batchedSub) {
		let e = batchedSub;
		batchedSub = void 0;
		while (e) {
			const next = e.next;
			e.next = void 0;
			e.flags &= -9;
			if (e.flags & 1) try {
				e.trigger();
			} catch (err) {
				if (!error) error = err;
			}
			e = next;
		}
	}
	if (error) throw error;
}
function prepareDeps(sub) {
	for (let link = sub.deps; link; link = link.nextDep) {
		link.version = -1;
		link.prevActiveLink = link.dep.activeLink;
		link.dep.activeLink = link;
	}
}
function cleanupDeps(sub) {
	let head;
	let tail = sub.depsTail;
	let link = tail;
	while (link) {
		const prev = link.prevDep;
		if (link.version === -1) {
			if (link === tail) tail = prev;
			removeSub(link);
			removeDep(link);
		} else head = link;
		link.dep.activeLink = link.prevActiveLink;
		link.prevActiveLink = void 0;
		link = prev;
	}
	sub.deps = head;
	sub.depsTail = tail;
}
function isDirty(sub) {
	for (let link = sub.deps; link; link = link.nextDep) if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
	if (sub._dirty) return true;
	return false;
}
function refreshComputed(computed) {
	if (computed.flags & 4 && !(computed.flags & 16)) return;
	computed.flags &= -17;
	if (computed.globalVersion === globalVersion) return;
	computed.globalVersion = globalVersion;
	if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !isDirty(computed))) return;
	computed.flags |= 2;
	const dep = computed.dep;
	const prevSub = activeSub;
	const prevShouldTrack = shouldTrack;
	activeSub = computed;
	shouldTrack = true;
	try {
		prepareDeps(computed);
		const value = computed.fn(computed._value);
		if (dep.version === 0 || hasChanged(value, computed._value)) {
			computed.flags |= 128;
			computed._value = value;
			dep.version++;
		}
	} catch (err) {
		dep.version++;
		throw err;
	} finally {
		activeSub = prevSub;
		shouldTrack = prevShouldTrack;
		cleanupDeps(computed);
		computed.flags &= -3;
	}
}
function removeSub(link, soft = false) {
	const { dep, prevSub, nextSub } = link;
	if (prevSub) {
		prevSub.nextSub = nextSub;
		link.prevSub = void 0;
	}
	if (nextSub) {
		nextSub.prevSub = prevSub;
		link.nextSub = void 0;
	}
	if (dep.subs === link) {
		dep.subs = prevSub;
		if (!prevSub && dep.computed) {
			dep.computed.flags &= -5;
			for (let l = dep.computed.deps; l; l = l.nextDep) removeSub(l, true);
		}
	}
	if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function removeDep(link) {
	const { prevDep, nextDep } = link;
	if (prevDep) {
		prevDep.nextDep = nextDep;
		link.prevDep = void 0;
	}
	if (nextDep) {
		nextDep.prevDep = prevDep;
		link.nextDep = void 0;
	}
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
	trackStack.push(shouldTrack);
	shouldTrack = false;
}
function resetTracking() {
	const last = trackStack.pop();
	shouldTrack = last === void 0 ? true : last;
}
function cleanupEffect(e) {
	const { cleanup } = e;
	e.cleanup = void 0;
	if (cleanup) {
		const prevSub = activeSub;
		activeSub = void 0;
		try {
			cleanup();
		} finally {
			activeSub = prevSub;
		}
	}
}
var globalVersion = 0;
var Link = class {
	constructor(sub, dep) {
		this.sub = sub;
		this.dep = dep;
		this.version = dep.version;
		this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
};
var Dep = class {
	constructor(computed) {
		this.computed = computed;
		this.version = 0;
		/**
		* Link between this dep and the current active effect
		*/
		this.activeLink = void 0;
		/**
		* Doubly linked list representing the subscribing effects (tail)
		*/
		this.subs = void 0;
		/**
		* For object property deps cleanup
		*/
		this.map = void 0;
		this.key = void 0;
		/**
		* Subscriber counter
		*/
		this.sc = 0;
		/**
		* @internal
		*/
		this.__v_skip = true;
	}
	track(debugInfo) {
		if (!activeSub || !shouldTrack || activeSub === this.computed) return;
		let link = this.activeLink;
		if (link === void 0 || link.sub !== activeSub) {
			link = this.activeLink = new Link(activeSub, this);
			if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
			else {
				link.prevDep = activeSub.depsTail;
				activeSub.depsTail.nextDep = link;
				activeSub.depsTail = link;
			}
			addSub(link);
		} else if (link.version === -1) {
			link.version = this.version;
			if (link.nextDep) {
				const next = link.nextDep;
				next.prevDep = link.prevDep;
				if (link.prevDep) link.prevDep.nextDep = next;
				link.prevDep = activeSub.depsTail;
				link.nextDep = void 0;
				activeSub.depsTail.nextDep = link;
				activeSub.depsTail = link;
				if (activeSub.deps === link) activeSub.deps = next;
			}
		}
		return link;
	}
	trigger(debugInfo) {
		this.version++;
		globalVersion++;
		this.notify(debugInfo);
	}
	notify(debugInfo) {
		startBatch();
		try {
			for (let link = this.subs; link; link = link.prevSub) if (link.sub.notify()) link.sub.dep.notify();
		} finally {
			endBatch();
		}
	}
};
function addSub(link) {
	link.dep.sc++;
	if (link.sub.flags & 4) {
		const computed = link.dep.computed;
		if (computed && !link.dep.subs) {
			computed.flags |= 20;
			for (let l = computed.deps; l; l = l.nextDep) addSub(l);
		}
		const currentTail = link.dep.subs;
		if (currentTail !== link) {
			link.prevSub = currentTail;
			if (currentTail) currentTail.nextSub = link;
		}
		link.dep.subs = link;
	}
}
var targetMap = /* @__PURE__ */ new WeakMap();
var ITERATE_KEY = /* @__PURE__ */ Symbol("");
var MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("");
var ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("");
function track(target, type, key) {
	if (shouldTrack && activeSub) {
		let depsMap = targetMap.get(target);
		if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
		let dep = depsMap.get(key);
		if (!dep) {
			depsMap.set(key, dep = new Dep());
			dep.map = depsMap;
			dep.key = key;
		}
		dep.track();
	}
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
	const depsMap = targetMap.get(target);
	if (!depsMap) {
		globalVersion++;
		return;
	}
	const run = (dep) => {
		if (dep) dep.trigger();
	};
	startBatch();
	if (type === "clear") depsMap.forEach(run);
	else {
		const targetIsArray = isArray(target);
		const isArrayIndex = targetIsArray && isIntegerKey(key);
		if (targetIsArray && key === "length") {
			const newLength = Number(newValue);
			depsMap.forEach((dep, key2) => {
				if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) run(dep);
			});
		} else {
			if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
			if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
			switch (type) {
				case "add":
					if (!targetIsArray) {
						run(depsMap.get(ITERATE_KEY));
						if (isMap(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
					} else if (isArrayIndex) run(depsMap.get("length"));
					break;
				case "delete":
					if (!targetIsArray) {
						run(depsMap.get(ITERATE_KEY));
						if (isMap(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
					}
					break;
				case "set": if (isMap(target)) run(depsMap.get(ITERATE_KEY));
			}
		}
	}
	endBatch();
}
function reactiveReadArray(array) {
	const raw = /* @__PURE__ */ toRaw(array);
	if (raw === array) return raw;
	track(raw, "iterate", ARRAY_ITERATE_KEY);
	if (/* @__PURE__ */ isShallow(array)) return raw;
	if (!/* @__PURE__ */ isReadonly(array)) return raw.map(toReactive);
	return /* @__PURE__ */ isReactive(array) ? raw.map((item) => toReadonly(toReactive(item))) : raw.map(toReadonly);
}
function shallowReadArray(arr) {
	track(arr = /* @__PURE__ */ toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
	return arr;
}
function toWrapped(target, item) {
	if (/* @__PURE__ */ isReadonly(target)) return /* @__PURE__ */ isReactive(target) ? toReadonly(toReactive(item)) : toReadonly(item);
	return toReactive(item);
}
var arrayInstrumentations = {
	__proto__: null,
	[Symbol.iterator]() {
		return iterator(this, Symbol.iterator, (item) => toWrapped(this, item));
	},
	concat(...args) {
		return reactiveReadArray(this).concat(...args.map((x) => isArray(x) ? reactiveReadArray(x) : x));
	},
	entries() {
		return iterator(this, "entries", (value) => {
			value[1] = toWrapped(this, value[1]);
			return value;
		});
	},
	every(fn, thisArg) {
		return apply(this, "every", fn, thisArg, void 0, arguments);
	},
	filter(fn, thisArg) {
		return apply(this, "filter", fn, thisArg, (v) => v.map((item) => toWrapped(this, item)), arguments);
	},
	find(fn, thisArg) {
		return apply(this, "find", fn, thisArg, (item) => toWrapped(this, item), arguments);
	},
	findIndex(fn, thisArg) {
		return apply(this, "findIndex", fn, thisArg, void 0, arguments);
	},
	findLast(fn, thisArg) {
		return apply(this, "findLast", fn, thisArg, (item) => toWrapped(this, item), arguments);
	},
	findLastIndex(fn, thisArg) {
		return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
	},
	forEach(fn, thisArg) {
		return apply(this, "forEach", fn, thisArg, void 0, arguments);
	},
	includes(...args) {
		return searchProxy(this, "includes", args);
	},
	indexOf(...args) {
		return searchProxy(this, "indexOf", args);
	},
	join(separator) {
		return reactiveReadArray(this).join(separator);
	},
	lastIndexOf(...args) {
		return searchProxy(this, "lastIndexOf", args);
	},
	map(fn, thisArg) {
		return apply(this, "map", fn, thisArg, void 0, arguments);
	},
	pop() {
		return noTracking(this, "pop");
	},
	push(...args) {
		return noTracking(this, "push", args);
	},
	reduce(fn, ...args) {
		return reduce(this, "reduce", fn, args);
	},
	reduceRight(fn, ...args) {
		return reduce(this, "reduceRight", fn, args);
	},
	shift() {
		return noTracking(this, "shift");
	},
	some(fn, thisArg) {
		return apply(this, "some", fn, thisArg, void 0, arguments);
	},
	splice(...args) {
		return noTracking(this, "splice", args);
	},
	toReversed() {
		return reactiveReadArray(this).toReversed();
	},
	toSorted(comparer) {
		return reactiveReadArray(this).toSorted(comparer);
	},
	toSpliced(...args) {
		return reactiveReadArray(this).toSpliced(...args);
	},
	unshift(...args) {
		return noTracking(this, "unshift", args);
	},
	values() {
		return iterator(this, "values", (item) => toWrapped(this, item));
	}
};
function iterator(self, method, wrapValue) {
	const arr = shallowReadArray(self);
	const methodFn = arr[method];
	const iter = methodFn.call(arr);
	if (arr !== self && !/* @__PURE__ */ isShallow(self)) {
		if (iter[Symbol.toStringTag] === "Array Iterator") {
			const wrapped = Object.create(Object.getPrototypeOf(iter));
			wrapped.next = () => wrapResult(iter.next(), wrapValue);
			if (methodFn !== arrayProto[method]) Object.defineProperties(wrapped, {
				return: { get() {
					const fn = iter.return;
					return typeof fn === "function" ? fn.bind(iter) : fn;
				} },
				throw: { get() {
					const fn = iter.throw;
					return typeof fn === "function" ? fn.bind(iter) : fn;
				} }
			});
			return wrapped;
		}
		iter._next = iter.next;
		iter.next = () => wrapResult(iter._next(), wrapValue);
	}
	return iter;
}
function wrapResult(result, wrapValue) {
	if (!result.done) result.value = wrapValue(result.value);
	return result;
}
var arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
	const arr = shallowReadArray(self);
	const needsWrap = arr !== self && !/* @__PURE__ */ isShallow(self);
	const methodFn = arr[method];
	if (methodFn !== arrayProto[method]) {
		const result2 = methodFn.apply(self, args);
		return needsWrap ? toReactive(result2) : result2;
	}
	let wrappedFn = fn;
	if (arr !== self) {
		if (needsWrap) wrappedFn = function(item, index) {
			return fn.call(this, toWrapped(self, item), index, self);
		};
		else if (fn.length > 2) wrappedFn = function(item, index) {
			return fn.call(this, item, index, self);
		};
	}
	const result = methodFn.call(arr, wrappedFn, thisArg);
	return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
	const arr = shallowReadArray(self);
	const needsWrap = arr !== self && !/* @__PURE__ */ isShallow(self);
	let wrappedFn = fn;
	let wrapInitialAccumulator = false;
	if (arr !== self) {
		if (needsWrap) {
			wrapInitialAccumulator = args.length === 0;
			wrappedFn = function(acc, item, index) {
				if (wrapInitialAccumulator) {
					wrapInitialAccumulator = false;
					acc = toWrapped(self, acc);
				}
				return fn.call(this, acc, toWrapped(self, item), index, self);
			};
		} else if (fn.length > 3) wrappedFn = function(acc, item, index) {
			return fn.call(this, acc, item, index, self);
		};
	}
	const result = arr[method](wrappedFn, ...args);
	return wrapInitialAccumulator ? toWrapped(self, result) : result;
}
function searchProxy(self, method, args) {
	const arr = /* @__PURE__ */ toRaw(self);
	track(arr, "iterate", ARRAY_ITERATE_KEY);
	const res = arr[method](...args);
	if ((res === -1 || res === false) && /* @__PURE__ */ isProxy(args[0])) {
		args[0] = /* @__PURE__ */ toRaw(args[0]);
		return arr[method](...args);
	}
	return res;
}
function noTracking(self, method, args = []) {
	pauseTracking();
	startBatch();
	const res = (/* @__PURE__ */ toRaw(self))[method].apply(self, args);
	endBatch();
	resetTracking();
	return res;
}
var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
var builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol));
function hasOwnProperty(key) {
	if (!isSymbol(key)) key = String(key);
	const obj = /* @__PURE__ */ toRaw(this);
	track(obj, "has", key);
	return obj.hasOwnProperty(key);
}
var BaseReactiveHandler = class {
	constructor(_isReadonly = false, _isShallow = false) {
		this._isReadonly = _isReadonly;
		this._isShallow = _isShallow;
	}
	get(target, key, receiver) {
		if (key === "__v_skip") return target["__v_skip"];
		const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
		if (key === "__v_isReactive") return !isReadonly2;
		else if (key === "__v_isReadonly") return isReadonly2;
		else if (key === "__v_isShallow") return isShallow2;
		else if (key === "__v_raw") {
			if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
			return;
		}
		const targetIsArray = isArray(target);
		if (!isReadonly2) {
			let fn;
			if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
			if (key === "hasOwnProperty") return hasOwnProperty;
		}
		const res = Reflect.get(target, key, /* @__PURE__ */ isRef(target) ? target : receiver);
		if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
		if (!isReadonly2) track(target, "get", key);
		if (isShallow2) return res;
		if (/* @__PURE__ */ isRef(res)) {
			const value = targetIsArray && isIntegerKey(key) ? res : res.value;
			return isReadonly2 && isObject(value) ? /* @__PURE__ */ readonly(value) : value;
		}
		if (isObject(res)) return isReadonly2 ? /* @__PURE__ */ readonly(res) : /* @__PURE__ */ reactive(res);
		return res;
	}
};
var MutableReactiveHandler = class extends BaseReactiveHandler {
	constructor(isShallow2 = false) {
		super(false, isShallow2);
	}
	set(target, key, value, receiver) {
		let oldValue = target[key];
		const isArrayWithIntegerKey = isArray(target) && isIntegerKey(key);
		if (!this._isShallow) {
			const isOldValueReadonly = /* @__PURE__ */ isReadonly(oldValue);
			if (!/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
				oldValue = /* @__PURE__ */ toRaw(oldValue);
				value = /* @__PURE__ */ toRaw(value);
			}
			if (!isArrayWithIntegerKey && /* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
				if (isOldValueReadonly) return true;
				else {
					oldValue.value = value;
					return true;
				}
			}
		}
		const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : hasOwn(target, key);
		const result = Reflect.set(target, key, value, /* @__PURE__ */ isRef(target) ? target : receiver);
		if (target === /* @__PURE__ */ toRaw(receiver) && result) {
			if (!hadKey) trigger(target, "add", key, value);
			else if (hasChanged(value, oldValue)) trigger(target, "set", key, value, oldValue);
		}
		return result;
	}
	deleteProperty(target, key) {
		const hadKey = hasOwn(target, key);
		const oldValue = target[key];
		const result = Reflect.deleteProperty(target, key);
		if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
		return result;
	}
	has(target, key) {
		const result = Reflect.has(target, key);
		if (!isSymbol(key) || !builtInSymbols.has(key)) track(target, "has", key);
		return result;
	}
	ownKeys(target) {
		track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
		return Reflect.ownKeys(target);
	}
};
var ReadonlyReactiveHandler = class extends BaseReactiveHandler {
	constructor(isShallow2 = false) {
		super(true, isShallow2);
	}
	set(target, key) {
		return true;
	}
	deleteProperty(target, key) {
		return true;
	}
};
var mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
var readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
var shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
var toShallow = (value) => value;
var getProto = (v) => Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
	return function(...args) {
		const target = this["__v_raw"];
		const rawTarget = /* @__PURE__ */ toRaw(target);
		const targetIsMap = isMap(rawTarget);
		const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
		const isKeyOnly = method === "keys" && targetIsMap;
		const innerIterator = target[method](...args);
		const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
		!isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
		return extend(Object.create(innerIterator), { next() {
			const { value, done } = innerIterator.next();
			return done ? {
				value,
				done
			} : {
				value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
				done
			};
		} });
	};
}
function createReadonlyMethod(type) {
	return function(...args) {
		return type === "delete" ? false : type === "clear" ? void 0 : this;
	};
}
function createInstrumentations(readonly, shallow) {
	const instrumentations = {
		get(key) {
			const target = this["__v_raw"];
			const rawTarget = /* @__PURE__ */ toRaw(target);
			const rawKey = /* @__PURE__ */ toRaw(key);
			if (!readonly) {
				if (hasChanged(key, rawKey)) track(rawTarget, "get", key);
				track(rawTarget, "get", rawKey);
			}
			const { has } = getProto(rawTarget);
			const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
			if (has.call(rawTarget, key)) return wrap(target.get(key));
			else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
			else if (target !== rawTarget) target.get(key);
		},
		get size() {
			const target = this["__v_raw"];
			!readonly && track(/* @__PURE__ */ toRaw(target), "iterate", ITERATE_KEY);
			return target.size;
		},
		has(key) {
			const target = this["__v_raw"];
			const rawTarget = /* @__PURE__ */ toRaw(target);
			const rawKey = /* @__PURE__ */ toRaw(key);
			if (!readonly) {
				if (hasChanged(key, rawKey)) track(rawTarget, "has", key);
				track(rawTarget, "has", rawKey);
			}
			return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
		},
		forEach(callback, thisArg) {
			const observed = this;
			const target = observed["__v_raw"];
			const rawTarget = /* @__PURE__ */ toRaw(target);
			const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
			!readonly && track(rawTarget, "iterate", ITERATE_KEY);
			return target.forEach((value, key) => {
				return callback.call(thisArg, wrap(value), wrap(key), observed);
			});
		}
	};
	extend(instrumentations, readonly ? {
		add: createReadonlyMethod("add"),
		set: createReadonlyMethod("set"),
		delete: createReadonlyMethod("delete"),
		clear: createReadonlyMethod("clear")
	} : {
		add(value) {
			const target = /* @__PURE__ */ toRaw(this);
			const proto = getProto(target);
			const rawValue = /* @__PURE__ */ toRaw(value);
			const valueToAdd = !shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value) ? rawValue : value;
			if (!(proto.has.call(target, valueToAdd) || hasChanged(value, valueToAdd) && proto.has.call(target, value) || hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue))) {
				target.add(valueToAdd);
				trigger(target, "add", valueToAdd, valueToAdd);
			}
			return this;
		},
		set(key, value) {
			if (!shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) value = /* @__PURE__ */ toRaw(value);
			const target = /* @__PURE__ */ toRaw(this);
			const { has, get } = getProto(target);
			let hadKey = has.call(target, key);
			if (!hadKey) {
				key = /* @__PURE__ */ toRaw(key);
				hadKey = has.call(target, key);
			}
			const oldValue = get.call(target, key);
			target.set(key, value);
			if (!hadKey) trigger(target, "add", key, value);
			else if (hasChanged(value, oldValue)) trigger(target, "set", key, value, oldValue);
			return this;
		},
		delete(key) {
			const target = /* @__PURE__ */ toRaw(this);
			const { has, get } = getProto(target);
			let hadKey = has.call(target, key);
			if (!hadKey) {
				key = /* @__PURE__ */ toRaw(key);
				hadKey = has.call(target, key);
			}
			const oldValue = get ? get.call(target, key) : void 0;
			const result = target.delete(key);
			if (hadKey) trigger(target, "delete", key, void 0, oldValue);
			return result;
		},
		clear() {
			const target = /* @__PURE__ */ toRaw(this);
			const hadItems = target.size !== 0;
			const oldTarget = void 0;
			const result = target.clear();
			if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
			return result;
		}
	});
	[
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((method) => {
		instrumentations[method] = createIterableMethod(method, readonly, shallow);
	});
	return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
	const instrumentations = createInstrumentations(isReadonly2, shallow);
	return (target, key, receiver) => {
		if (key === "__v_isReactive") return !isReadonly2;
		else if (key === "__v_isReadonly") return isReadonly2;
		else if (key === "__v_isShallow") return shallow;
		else if (key === "__v_raw") return target;
		return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
	};
}
var mutableCollectionHandlers = { get: /* @__PURE__ */ createInstrumentationGetter(false, false) };
var shallowCollectionHandlers = { get: /* @__PURE__ */ createInstrumentationGetter(false, true) };
var readonlyCollectionHandlers = { get: /* @__PURE__ */ createInstrumentationGetter(true, false) };
var reactiveMap = /* @__PURE__ */ new WeakMap();
var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var readonlyMap = /* @__PURE__ */ new WeakMap();
var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
	switch (rawType) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function reactive(target) {
	if (/* @__PURE__ */ isReadonly(target)) return target;
	return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function shallowReactive(target) {
	return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function readonly(target) {
	return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
	if (!isObject(target)) return target;
	if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
	if (target["__v_skip"] || !Object.isExtensible(target)) return target;
	const existingProxy = proxyMap.get(target);
	if (existingProxy) return existingProxy;
	const targetType = targetTypeMap(toRawType(target));
	if (targetType === 0) return target;
	const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
	proxyMap.set(target, proxy);
	return proxy;
}
// @__NO_SIDE_EFFECTS__
function isReactive(value) {
	if (/* @__PURE__ */ isReadonly(value)) return /* @__PURE__ */ isReactive(value["__v_raw"]);
	return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function isReadonly(value) {
	return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function isShallow(value) {
	return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function isProxy(value) {
	return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function toRaw(observed) {
	const raw = observed && observed["__v_raw"];
	return raw ? /* @__PURE__ */ toRaw(raw) : observed;
}
function markRaw(value) {
	if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) def(value, "__v_skip", true);
	return value;
}
var toReactive = (value) => isObject(value) ? /* @__PURE__ */ reactive(value) : value;
var toReadonly = (value) => isObject(value) ? /* @__PURE__ */ readonly(value) : value;
// @__NO_SIDE_EFFECTS__
function isRef(r) {
	return r ? r["__v_isRef"] === true : false;
}
function unref(ref2) {
	return /* @__PURE__ */ isRef(ref2) ? ref2.value : ref2;
}
var shallowUnwrapHandlers = {
	get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
	set: (target, key, value, receiver) => {
		const oldValue = target[key];
		if (/* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
			oldValue.value = value;
			return true;
		} else return Reflect.set(target, key, value, receiver);
	}
};
function proxyRefs(objectWithRefs) {
	return /* @__PURE__ */ isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
var ComputedRefImpl = class {
	constructor(fn, setter, isSSR) {
		this.fn = fn;
		this.setter = setter;
		/**
		* @internal
		*/
		this._value = void 0;
		/**
		* @internal
		*/
		this.dep = new Dep(this);
		/**
		* @internal
		*/
		this.__v_isRef = true;
		/**
		* @internal
		*/
		this.deps = void 0;
		/**
		* @internal
		*/
		this.depsTail = void 0;
		/**
		* @internal
		*/
		this.flags = 16;
		/**
		* @internal
		*/
		this.globalVersion = globalVersion - 1;
		/**
		* @internal
		*/
		this.next = void 0;
		this.effect = this;
		this["__v_isReadonly"] = !setter;
		this.isSSR = isSSR;
	}
	/**
	* @internal
	*/
	notify() {
		this.flags |= 16;
		if (!(this.flags & 8) && activeSub !== this) {
			batch(this, true);
			return true;
		}
	}
	get value() {
		const link = this.dep.track();
		refreshComputed(this);
		if (link) link.version = this.dep.version;
		return this._value;
	}
	set value(newValue) {
		if (this.setter) this.setter(newValue);
	}
};
// @__NO_SIDE_EFFECTS__
function computed$1(getterOrOptions, debugOptions, isSSR = false) {
	let getter;
	let setter;
	if (isFunction(getterOrOptions)) getter = getterOrOptions;
	else {
		getter = getterOrOptions.get;
		setter = getterOrOptions.set;
	}
	return new ComputedRefImpl(getter, setter, isSSR);
}
var INITIAL_WATCHER_VALUE = {};
var cleanupMap = /* @__PURE__ */ new WeakMap();
var activeWatcher = void 0;
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
	if (owner) {
		let cleanups = cleanupMap.get(owner);
		if (!cleanups) cleanupMap.set(owner, cleanups = []);
		cleanups.push(cleanupFn);
	}
}
function watch$1(source, cb, options = EMPTY_OBJ) {
	const { immediate, deep, once, scheduler, augmentJob, call } = options;
	const reactiveGetter = (source2) => {
		if (deep) return source2;
		if (/* @__PURE__ */ isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
		return traverse(source2);
	};
	let effect;
	let getter;
	let cleanup;
	let boundCleanup;
	let forceTrigger = false;
	let isMultiSource = false;
	if (/* @__PURE__ */ isRef(source)) {
		getter = () => source.value;
		forceTrigger = /* @__PURE__ */ isShallow(source);
	} else if (/* @__PURE__ */ isReactive(source)) {
		getter = () => reactiveGetter(source);
		forceTrigger = true;
	} else if (isArray(source)) {
		isMultiSource = true;
		forceTrigger = source.some((s) => /* @__PURE__ */ isReactive(s) || /* @__PURE__ */ isShallow(s));
		getter = () => source.map((s) => {
			if (/* @__PURE__ */ isRef(s)) return s.value;
			else if (/* @__PURE__ */ isReactive(s)) return reactiveGetter(s);
			else if (isFunction(s)) return call ? call(s, 2) : s();
		});
	} else if (isFunction(source)) {
		if (cb) getter = call ? () => call(source, 2) : source;
		else getter = () => {
			if (cleanup) {
				pauseTracking();
				try {
					cleanup();
				} finally {
					resetTracking();
				}
			}
			const currentEffect = activeWatcher;
			activeWatcher = effect;
			try {
				return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
			} finally {
				activeWatcher = currentEffect;
			}
		};
	} else getter = NOOP;
	if (cb && deep) {
		const baseGetter = getter;
		const depth = deep === true ? Infinity : deep;
		getter = () => traverse(baseGetter(), depth);
	}
	const scope = getCurrentScope();
	const watchHandle = () => {
		effect.stop();
		if (scope && scope.active) remove(scope.effects, effect);
	};
	if (once && cb) {
		const _cb = cb;
		cb = (...args) => {
			try {
				return _cb(...args);
			} finally {
				watchHandle();
			}
		};
	}
	let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
	const job = (immediateFirstRun) => {
		if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
		if (cb) {
			const newValue = effect.run();
			if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
				const currentWatcher = activeWatcher;
				pauseTracking();
				try {
					if (cleanup) cleanup();
					activeWatcher = effect;
					const args = [
						newValue,
						oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
						boundCleanup
					];
					oldValue = newValue;
					call ? call(cb, 3, args) : cb(...args);
				} finally {
					activeWatcher = currentWatcher;
					resetTracking();
				}
			}
		} else effect.run();
	};
	if (augmentJob) augmentJob(job);
	effect = new ReactiveEffect(getter);
	effect.scheduler = scheduler ? () => scheduler(job, false) : job;
	boundCleanup = (fn) => onWatcherCleanup(fn, false, effect);
	cleanup = effect.onStop = () => {
		const cleanups = cleanupMap.get(effect);
		if (cleanups) {
			if (call) call(cleanups, 4);
			else for (const cleanup2 of cleanups) cleanup2();
			cleanupMap.delete(effect);
		}
	};
	if (cb) {
		if (immediate) job(true);
		else oldValue = effect.run();
	} else if (scheduler) scheduler(job.bind(null, true), true);
	else effect.run();
	watchHandle.pause = effect.pause.bind(effect);
	watchHandle.resume = effect.resume.bind(effect);
	watchHandle.stop = watchHandle;
	return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
	if (depth <= 0 || !isObject(value) || value["__v_skip"]) return value;
	seen = seen || /* @__PURE__ */ new Map();
	if ((seen.get(value) || 0) >= depth) return value;
	seen.set(value, depth);
	depth--;
	if (/* @__PURE__ */ isRef(value)) traverse(value.value, depth, seen);
	else if (isArray(value)) for (let i = 0; i < value.length; i++) traverse(value[i], depth, seen);
	else if (isSet(value) || isMap(value)) value.forEach((v) => {
		traverse(v, depth, seen);
	});
	else if (isPlainObject(value)) {
		for (const key in value) traverse(value[key], depth, seen);
		for (const key of Object.getOwnPropertySymbols(value)) if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
	}
	return value;
}
//#endregion
//#region node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
/**
* @vue/runtime-core v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function callWithErrorHandling(fn, instance, type, args) {
	try {
		return args ? fn(...args) : fn();
	} catch (err) {
		handleError(err, instance, type);
	}
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
	if (isFunction(fn)) {
		const res = callWithErrorHandling(fn, instance, type, args);
		if (res && isPromise(res)) res.catch((err) => {
			handleError(err, instance, type);
		});
		return res;
	}
	if (isArray(fn)) {
		const values = [];
		for (let i = 0; i < fn.length; i++) values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
		return values;
	}
}
function handleError(err, instance, type, throwInDev = true) {
	const contextVNode = instance ? instance.vnode : null;
	const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
	if (instance) {
		let cur = instance.parent;
		const exposedInstance = instance.proxy;
		const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
		while (cur) {
			const errorCapturedHooks = cur.ec;
			if (errorCapturedHooks) {
				for (let i = 0; i < errorCapturedHooks.length; i++) if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
			}
			cur = cur.parent;
		}
		if (errorHandler) {
			pauseTracking();
			callWithErrorHandling(errorHandler, null, 10, [
				err,
				exposedInstance,
				errorInfo
			]);
			resetTracking();
			return;
		}
	}
	logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
	if (throwInProd) throw err;
	else console.error(err);
}
var queue = [];
var flushIndex = -1;
var pendingPostFlushCbs = [];
var activePostFlushCbs = null;
var postFlushIndex = 0;
var resolvedPromise = /* @__PURE__ */ Promise.resolve();
var currentFlushPromise = null;
function nextTick(fn) {
	const p = currentFlushPromise || resolvedPromise;
	return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
	let start = flushIndex + 1;
	let end = queue.length;
	while (start < end) {
		const middle = start + end >>> 1;
		const middleJob = queue[middle];
		const middleJobId = getId(middleJob);
		if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
		else end = middle;
	}
	return start;
}
function queueJob(job) {
	if (!(job.flags & 1)) {
		const jobId = getId(job);
		const lastJob = queue[queue.length - 1];
		if (!lastJob || !(job.flags & 2) && jobId >= getId(lastJob)) queue.push(job);
		else queue.splice(findInsertionIndex(jobId), 0, job);
		job.flags |= 1;
		queueFlush();
	}
}
function queueFlush() {
	if (!currentFlushPromise) currentFlushPromise = resolvedPromise.then(flushJobs);
}
function queuePostFlushCb(cb) {
	if (!isArray(cb)) {
		if (activePostFlushCbs && cb.id === -1) activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
		else if (!(cb.flags & 1)) {
			pendingPostFlushCbs.push(cb);
			cb.flags |= 1;
		}
	} else for (let i = 0; i < cb.length; i++) pendingPostFlushCbs.push(cb[i]);
	queueFlush();
}
function flushPreFlushCbs(instance, minUid, seen, i = flushIndex + 1) {
	for (; i < queue.length; i++) {
		const cb = queue[i];
		if (cb && cb.flags & 2) {
			if (instance && cb.id !== instance.uid || minUid !== void 0 && !(cb.id >= minUid)) continue;
			queue.splice(i, 1);
			i = instance ? i - 1 : flushIndex;
			if (cb.flags & 4) cb.flags &= -2;
			cb();
			if (!(cb.flags & 4)) cb.flags &= -2;
		}
	}
}
function flushPostFlushCbs(seen, skip, minUid = 0) {
	if (pendingPostFlushCbs.length) {
		let cbs = pendingPostFlushCbs;
		let kept = 0;
		if (skip) {
			cbs = [];
			for (let i = 0; i < pendingPostFlushCbs.length; i++) {
				const cb = pendingPostFlushCbs[i];
				if (cb.i !== void 0 ? !cb.i || cb.i.uid < minUid : skip.has(cb)) pendingPostFlushCbs[kept++] = cb;
				else cbs.push(cb);
			}
		}
		const deduped = [...new Set(cbs)].sort((a, b) => getId(a) - getId(b));
		pendingPostFlushCbs.length = kept;
		if (activePostFlushCbs) {
			for (let i = 0; i < deduped.length; i++) activePostFlushCbs.push(deduped[i]);
			return;
		}
		activePostFlushCbs = deduped;
		for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
			const cb = activePostFlushCbs[postFlushIndex];
			if (cb.flags & 4) cb.flags &= -2;
			if (!(cb.flags & 8)) cb();
			cb.flags &= -2;
		}
		activePostFlushCbs = null;
		postFlushIndex = 0;
	}
}
var isFlushing = false;
function flushOnAppMount(fn, minUid) {
	if (isFlushing) {
		fn();
		return;
	}
	const queued = minUid === void 0 ? void 0 : new Set(pendingPostFlushCbs);
	fn();
	isFlushing = true;
	try {
		flushPreFlushCbs(void 0, minUid);
		flushPostFlushCbs(void 0, queued, minUid);
	} finally {
		isFlushing = false;
	}
}
var getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
	try {
		for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
			const job = queue[flushIndex];
			if (job && !(job.flags & 8)) {
				if (job.flags & 4) job.flags &= -2;
				callWithErrorHandling(job, job.i, job.i ? 15 : 14);
				if (!(job.flags & 4)) job.flags &= -2;
			}
		}
	} finally {
		for (; flushIndex < queue.length; flushIndex++) {
			const job = queue[flushIndex];
			if (job) job.flags &= -2;
		}
		flushIndex = -1;
		queue.length = 0;
		flushPostFlushCbs(seen);
		currentFlushPromise = null;
		if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
	}
}
var devtools$1;
var buffer = [];
var devtoolsNotInstalled = false;
function emit$1(event, ...args) {
	if (devtools$1) devtools$1.emit(event, ...args);
	else if (!devtoolsNotInstalled) buffer.push({
		event,
		args
	});
}
function setDevtoolsHook$1(hook, target) {
	var _a, _b;
	devtools$1 = hook;
	if (devtools$1) {
		devtools$1.enabled = true;
		buffer.forEach(({ event, args }) => devtools$1.emit(event, ...args));
		buffer = [];
	} else if (typeof window !== "undefined" && window.HTMLElement && !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
		(target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((newHook) => {
			setDevtoolsHook$1(newHook, target);
		});
		setTimeout(() => {
			if (!devtools$1) {
				target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
				devtoolsNotInstalled = true;
				buffer = [];
			}
		}, 3e3);
	} else {
		devtoolsNotInstalled = true;
		buffer = [];
	}
}
function devtoolsInitApp(app, version) {
	emit$1("app:init", app, version, {
		Fragment,
		Text,
		Comment,
		Static
	});
}
function devtoolsUnmountApp(app) {
	emit$1("app:unmount", app);
}
var devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added");
var devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated");
var _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed");
var devtoolsComponentRemoved = (component) => {
	if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
	return (component) => {
		emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
	};
}
function devtoolsComponentEmit(component, event, params) {
	emit$1("component:emit", component.appContext.app, component, event, params);
}
var currentRenderingInstance = null;
var currentScopeId = null;
function setCurrentRenderingInstance(instance) {
	const prev = currentRenderingInstance;
	currentRenderingInstance = instance;
	currentScopeId = instance && instance.type.__scopeId || null;
	return prev;
}
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
	if (!ctx) return fn;
	if (fn._n) return fn;
	const renderFnWithContext = (...args) => {
		if (renderFnWithContext._d) setBlockTracking(-1);
		const prevInstance = setCurrentRenderingInstance(ctx);
		const prevStackSize = blockStack.length;
		let res;
		try {
			res = fn(...args);
		} finally {
			for (let i = blockStack.length; i > prevStackSize; i--) closeBlock();
			setCurrentRenderingInstance(prevInstance);
			if (renderFnWithContext._d) setBlockTracking(1);
		}
		devtoolsComponentUpdated(ctx);
		return res;
	};
	renderFnWithContext._n = true;
	renderFnWithContext._c = true;
	renderFnWithContext._d = true;
	return renderFnWithContext;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
	const bindings = vnode.dirs;
	const oldBindings = prevVNode && prevVNode.dirs;
	for (let i = 0; i < bindings.length; i++) {
		const binding = bindings[i];
		if (oldBindings) binding.oldValue = oldBindings[i].value;
		let hook = binding.dir[name];
		if (hook) {
			pauseTracking();
			callWithAsyncErrorHandling(hook, instance, 8, [
				vnode.el,
				binding,
				vnode,
				prevVNode
			]);
			resetTracking();
		}
	}
}
function provide(key, value) {
	if (currentInstance) {
		let provides = currentInstance.provides;
		const parentProvides = currentInstance.parent && currentInstance.parent.provides;
		if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
		provides[key] = value;
	}
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
	const instance = getCurrentInstance();
	if (instance || currentApp) {
		let provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
		if (provides && key in provides) return provides[key];
		else if (arguments.length > 1) return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
	}
}
var ssrContextKey = /* @__PURE__ */ Symbol.for("v-scx");
var useSSRContext = () => {
	{
		const ctx = inject(ssrContextKey);
		if (!ctx) {}
		return ctx;
	}
};
function watch(source, cb, options) {
	return doWatch(source, cb, options);
}
function doWatch(source, cb, options = EMPTY_OBJ) {
	const { immediate, deep, flush, once } = options;
	const baseWatchOptions = extend({}, options);
	const runsImmediately = cb && immediate || !cb && flush !== "post";
	let ssrCleanup;
	if (isInSSRComponentSetup) {
		if (flush === "sync") {
			const ctx = useSSRContext();
			ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
		} else if (!runsImmediately) {
			const watchStopHandle = () => {};
			watchStopHandle.stop = NOOP;
			watchStopHandle.resume = NOOP;
			watchStopHandle.pause = NOOP;
			return watchStopHandle;
		}
	}
	const instance = currentInstance;
	baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
	let isPre = false;
	if (flush === "post") baseWatchOptions.scheduler = (job) => {
		job.i = instance;
		queuePostRenderEffect(job, instance && instance.suspense);
	};
	else if (flush !== "sync") {
		isPre = true;
		baseWatchOptions.scheduler = (job, isFirstRun) => {
			if (isFirstRun) job();
			else queueJob(job);
		};
	}
	baseWatchOptions.augmentJob = (job) => {
		if (cb) job.flags |= 4;
		if (isPre) {
			job.flags |= 2;
			if (instance) {
				job.id = instance.uid;
				job.i = instance;
			}
		}
	};
	const watchHandle = watch$1(source, cb, baseWatchOptions);
	if (isInSSRComponentSetup) {
		if (ssrCleanup) ssrCleanup.push(watchHandle);
		else if (runsImmediately) watchHandle();
	}
	return watchHandle;
}
function instanceWatch(source, value, options) {
	const publicThis = this.proxy;
	const getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
	let cb;
	if (isFunction(value)) cb = value;
	else {
		cb = value.handler;
		options = value;
	}
	const reset = setCurrentInstance(this);
	const res = doWatch(getter, cb.bind(publicThis), options);
	reset();
	return res;
}
function createPathGetter(ctx, path) {
	const segments = path.split(".");
	return () => {
		let cur = ctx;
		for (let i = 0; i < segments.length && cur; i++) cur = cur[segments[i]];
		return cur;
	};
}
var TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
var isTeleport = (type) => type.__isTeleport;
var leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
function findNonCommentChild(children) {
	let child = children[0];
	if (children.length > 1) {
		for (const c of children) if (c.type !== Comment) {
			child = c;
			break;
		}
	}
	return child;
}
function getInnerChild$1(vnode) {
	if (!isKeepAlive(vnode)) {
		if (isTeleport(vnode.type) && vnode.children) return findNonCommentChild(vnode.children);
		return vnode;
	}
	if (vnode.component) return vnode.component.subTree;
	const { shapeFlag, children } = vnode;
	if (children) {
		if (shapeFlag & 16) return children[0];
		if (shapeFlag & 32 && isFunction(children.default)) return children.default();
	}
}
function setTransitionHooks(vnode, hooks) {
	if (vnode.shapeFlag & 6 && vnode.component) {
		vnode.transition = hooks;
		const subTree = vnode.component.subTree;
		setTransitionHooks(isTeleport(subTree.type) ? getInnerChild$1(subTree) || subTree : subTree, hooks);
	} else if (vnode.shapeFlag & 128) {
		vnode.ssContent.transition = hooks.clone(vnode.ssContent);
		vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
	} else {
		vnode.transition = hooks;
		if (vnode.type === Fragment && isArray(vnode.children)) {
			const child = filterSingleRoot(vnode.children, false);
			if (child) setTransitionHooks(child, hooks);
		}
	}
}
function getTransitionRoot(vnode) {
	if (vnode.component) return getTransitionRoot(vnode.component.subTree);
	if (vnode.type === Fragment) {
		const child = isArray(vnode.children) && filterSingleRoot(vnode.children, false);
		return child ? getTransitionRoot(child) : void 0;
	}
	if (vnode.type !== Comment) return vnode;
}
function markAsyncBoundary(instance) {
	instance.ids = [
		instance.ids[0] + instance.ids[2]++ + "-",
		0,
		0
	];
}
function isTemplateRefKey(refs, key) {
	let desc;
	return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
var pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
	if (isArray(rawRef)) {
		rawRef.forEach((r, i) => setRef(r, oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
		return;
	}
	if (isAsyncWrapper(vnode) && !isUnmount) {
		if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
		return;
	}
	const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
	const value = isUnmount ? null : refValue;
	const { i: owner, r: ref } = rawRef;
	const oldRef = oldRawRef && oldRawRef.r;
	const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
	const setupState = owner.setupState;
	const rawSetupState = /* @__PURE__ */ toRaw(setupState);
	const canSetSetupRef = setupState === EMPTY_OBJ ? NO : (key) => {
		if (isTemplateRefKey(refs, key)) return false;
		return hasOwn(rawSetupState, key);
	};
	const canSetRef = (ref2, key) => {
		if (key && isTemplateRefKey(refs, key)) return false;
		return true;
	};
	if (oldRef != null && oldRef !== ref) {
		invalidatePendingSetRef(oldRawRef);
		if (isString(oldRef)) {
			refs[oldRef] = null;
			if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
		} else if (/* @__PURE__ */ isRef(oldRef)) {
			const oldRawRefAtom = oldRawRef;
			if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
			if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
		}
	}
	if (isFunction(ref)) callWithErrorHandling(ref, owner, 12, [value, refs]);
	else {
		const _isString = isString(ref);
		const _isRef = /* @__PURE__ */ isRef(ref);
		if (_isString || _isRef) {
			const doSet = () => {
				if (rawRef.f) {
					const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
					if (isUnmount) isArray(existing) && remove(existing, refValue);
					else if (!isArray(existing)) {
						if (_isString) {
							refs[ref] = [refValue];
							if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
						} else {
							const newVal = [refValue];
							if (canSetRef(ref, rawRef.k)) ref.value = newVal;
							if (rawRef.k) refs[rawRef.k] = newVal;
						}
					} else if (!existing.includes(refValue)) existing.push(refValue);
				} else if (_isString) {
					refs[ref] = value;
					if (canSetSetupRef(ref)) setupState[ref] = value;
				} else if (_isRef) {
					if (canSetRef(ref, rawRef.k)) ref.value = value;
					if (rawRef.k) refs[rawRef.k] = value;
				}
			};
			if (value) {
				const job = () => {
					doSet();
					pendingSetRefMap.delete(rawRef);
				};
				job.id = -1;
				pendingSetRefMap.set(rawRef, job);
				queuePostRenderEffect(job, parentSuspense);
			} else {
				invalidatePendingSetRef(rawRef);
				doSet();
			}
		}
	}
}
function invalidatePendingSetRef(rawRef) {
	const pendingSetRef = pendingSetRefMap.get(rawRef);
	if (pendingSetRef) {
		pendingSetRef.flags |= 8;
		pendingSetRefMap.delete(rawRef);
	}
}
getGlobalThis().requestIdleCallback;
getGlobalThis().cancelIdleCallback;
var isAsyncWrapper = (i) => !!i.type.__asyncLoader;
var isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
	registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
	registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
	const wrappedHook = hook.__wdc || (hook.__wdc = () => {
		let current = target;
		while (current) {
			if (current.isDeactivated) return;
			current = current.parent;
		}
		return hook();
	});
	injectHook(type, wrappedHook, target);
	if (target) {
		let current = target.parent;
		while (current && current.parent) {
			if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
			current = current.parent;
		}
	}
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
	const injected = injectHook(type, hook, keepAliveRoot, true);
	onUnmounted(() => {
		remove(keepAliveRoot[type], injected);
	}, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
	if (target) {
		const hooks = target[type] || (target[type] = []);
		const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
			pauseTracking();
			const reset = setCurrentInstance(target);
			const res = callWithAsyncErrorHandling(hook, target, type, args);
			reset();
			resetTracking();
			return res;
		});
		if (prepend) hooks.unshift(wrappedHook);
		else hooks.push(wrappedHook);
		return wrappedHook;
	}
}
var createHook = (lifecycle) => (hook, target = currentInstance) => {
	if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args) => hook(...args), target);
};
var onBeforeMount = createHook("bm");
var onMounted = createHook("m");
var onBeforeUpdate = createHook("bu");
var onUpdated = createHook("u");
var onBeforeUnmount = createHook("bum");
var onUnmounted = createHook("um");
var onServerPrefetch = createHook("sp");
var onRenderTriggered = createHook("rtg");
var onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
	injectHook("ec", hook, target);
}
var NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function renderList(source, renderItem, cache, index) {
	let ret;
	const cached = cache && cache[index];
	const sourceIsArray = isArray(source);
	if (sourceIsArray || isString(source)) {
		const sourceIsReactiveArray = sourceIsArray && /* @__PURE__ */ isReactive(source);
		let needsWrap = false;
		let isReadonlySource = false;
		if (sourceIsReactiveArray) {
			needsWrap = !/* @__PURE__ */ isShallow(source);
			isReadonlySource = /* @__PURE__ */ isReadonly(source);
			source = shallowReadArray(source);
		}
		ret = new Array(source.length);
		for (let i = 0, l = source.length; i < l; i++) ret[i] = renderItem(needsWrap ? isReadonlySource ? toReadonly(toReactive(source[i])) : toReactive(source[i]) : source[i], i, void 0, cached && cached[i]);
	} else if (typeof source === "number") {
		if (!Number.isInteger(source) || source < 0) ret = [];
		else {
			ret = new Array(source);
			for (let i = 0; i < source; i++) ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
		}
	} else if (isObject(source)) {
		if (source[Symbol.iterator]) ret = Array.from(source, (item, i) => renderItem(item, i, void 0, cached && cached[i]));
		else {
			const keys = Object.keys(source);
			ret = new Array(keys.length);
			for (let i = 0, l = keys.length; i < l; i++) {
				const key = keys[i];
				ret[i] = renderItem(source[key], key, i, cached && cached[i]);
			}
		}
	} else ret = [];
	if (cache) cache[index] = ret;
	return ret;
}
var getPublicInstance = (i) => {
	if (!i) return null;
	if (isStatefulComponent(i)) return getComponentPublicInstance(i);
	return getPublicInstance(i.parent);
};
var publicPropertiesMap = /* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
	$: (i) => i,
	$el: (i) => i.vnode.el,
	$data: (i) => i.data,
	$props: (i) => i.props,
	$attrs: (i) => i.attrs,
	$slots: (i) => i.slots,
	$refs: (i) => i.refs,
	$parent: (i) => getPublicInstance(i.parent),
	$root: (i) => getPublicInstance(i.root),
	$host: (i) => i.ce,
	$emit: (i) => i.emit,
	$options: (i) => resolveMergedOptions(i),
	$forceUpdate: (i) => i.f || (i.f = () => {
		queueJob(i.update);
	}),
	$nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
	$watch: (i) => instanceWatch.bind(i)
});
var hasSetupBinding = (state, key) => state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key);
var PublicInstanceProxyHandlers = {
	get({ _: instance }, key) {
		if (key === "__v_skip") return true;
		const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
		if (key[0] !== "$") {
			const n = accessCache[key];
			if (n !== void 0) switch (n) {
				case 1: return setupState[key];
				case 2: return data[key];
				case 4: return ctx[key];
				case 3: return props[key];
			}
			else if (hasSetupBinding(setupState, key)) {
				accessCache[key] = 1;
				return setupState[key];
			} else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
				accessCache[key] = 2;
				return data[key];
			} else if (hasOwn(props, key)) {
				accessCache[key] = 3;
				return props[key];
			} else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
				accessCache[key] = 4;
				return ctx[key];
			} else if (shouldCacheAccess) accessCache[key] = 0;
		}
		const publicGetter = publicPropertiesMap[key];
		let cssModule, globalProperties;
		if (publicGetter) {
			if (key === "$attrs") track(instance.attrs, "get", "");
			return publicGetter(instance);
		} else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
		else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
			accessCache[key] = 4;
			return ctx[key];
		} else if (globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)) return globalProperties[key];
	},
	set({ _: instance }, key, value) {
		const { data, setupState, ctx } = instance;
		if (hasSetupBinding(setupState, key)) {
			setupState[key] = value;
			return true;
		} else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
			data[key] = value;
			return true;
		} else if (hasOwn(instance.props, key)) return false;
		if (key[0] === "$" && key.slice(1) in instance) return false;
		else ctx[key] = value;
		return true;
	},
	has({ _: { data, setupState, accessCache, ctx, appContext, props, type } }, key) {
		let cssModules;
		return !!(accessCache[key] || data !== EMPTY_OBJ && key[0] !== "$" && hasOwn(data, key) || hasSetupBinding(setupState, key) || hasOwn(props, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
	},
	defineProperty(target, key, descriptor) {
		if (descriptor.get != null) target._.accessCache[key] = 0;
		else if (hasOwn(descriptor, "value")) this.set(target, key, descriptor.value, null);
		return Reflect.defineProperty(target, key, descriptor);
	}
};
function normalizePropsOrEmits(props) {
	return isArray(props) ? props.reduce((normalized, p) => (normalized[p] = null, normalized), {}) : props;
}
var shouldCacheAccess = true;
function applyOptions(instance) {
	const options = resolveMergedOptions(instance);
	const publicThis = instance.proxy;
	const ctx = instance.ctx;
	shouldCacheAccess = false;
	if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
	const { data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, expose, inheritAttrs, components, directives, filters } = options;
	const checkDuplicateProperties = null;
	if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
	if (methods) for (const key in methods) {
		const methodHandler = methods[key];
		if (isFunction(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
	}
	if (dataOptions) {
		const data = dataOptions.call(publicThis, publicThis);
		if (!isObject(data)) {} else instance.data = /* @__PURE__ */ reactive(data);
	}
	shouldCacheAccess = true;
	if (computedOptions) for (const key in computedOptions) {
		const opt = computedOptions[key];
		const c = computed({
			get: isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP,
			set: !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : NOOP
		});
		Object.defineProperty(ctx, key, {
			enumerable: true,
			configurable: true,
			get: () => c.value,
			set: (v) => c.value = v
		});
	}
	if (watchOptions) for (const key in watchOptions) createWatcher(watchOptions[key], ctx, publicThis, key);
	if (provideOptions) {
		const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
		Reflect.ownKeys(provides).forEach((key) => {
			provide(key, provides[key]);
		});
	}
	if (created) callHook(created, instance, "c");
	function registerLifecycleHook(register, hook) {
		if (isArray(hook)) hook.forEach((_hook) => register(_hook.bind(publicThis)));
		else if (hook) register(hook.bind(publicThis));
	}
	registerLifecycleHook(onBeforeMount, beforeMount);
	registerLifecycleHook(onMounted, mounted);
	registerLifecycleHook(onBeforeUpdate, beforeUpdate);
	registerLifecycleHook(onUpdated, updated);
	registerLifecycleHook(onActivated, activated);
	registerLifecycleHook(onDeactivated, deactivated);
	registerLifecycleHook(onErrorCaptured, errorCaptured);
	registerLifecycleHook(onRenderTracked, renderTracked);
	registerLifecycleHook(onRenderTriggered, renderTriggered);
	registerLifecycleHook(onBeforeUnmount, beforeUnmount);
	registerLifecycleHook(onUnmounted, unmounted);
	registerLifecycleHook(onServerPrefetch, serverPrefetch);
	if (isArray(expose)) {
		if (expose.length) {
			const exposed = instance.exposed || (instance.exposed = {});
			expose.forEach((key) => {
				Object.defineProperty(exposed, key, {
					get: () => publicThis[key],
					set: (val) => publicThis[key] = val,
					enumerable: true
				});
			});
		} else if (!instance.exposed) instance.exposed = {};
	}
	if (render && instance.render === NOOP) instance.render = render;
	if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
	if (components) instance.components = components;
	if (directives) instance.directives = directives;
	if (serverPrefetch) markAsyncBoundary(instance);
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
	if (isArray(injectOptions)) injectOptions = normalizeInject(injectOptions);
	for (const key in injectOptions) {
		const opt = injectOptions[key];
		let injected;
		if (isObject(opt)) {
			if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
			else injected = inject(opt.from || key);
		} else injected = inject(opt);
		if (/* @__PURE__ */ isRef(injected)) Object.defineProperty(ctx, key, {
			enumerable: true,
			configurable: true,
			get: () => injected.value,
			set: (v) => injected.value = v
		});
		else ctx[key] = injected;
	}
}
function callHook(hook, instance, type) {
	callWithAsyncErrorHandling(isArray(hook) ? hook.map((h) => h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
	let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
	if (isString(raw)) {
		const handler = ctx[raw];
		if (isFunction(handler)) watch(getter, handler);
	} else if (isFunction(raw)) watch(getter, raw.bind(publicThis));
	else if (isObject(raw)) {
		if (isArray(raw)) raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
		else {
			const handler = isFunction(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
			if (isFunction(handler)) watch(getter, handler, raw);
		}
	}
}
function resolveMergedOptions(instance) {
	const base = instance.type;
	const { mixins, extends: extendsOptions } = base;
	const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
	const cached = cache.get(base);
	let resolved;
	if (cached) resolved = cached;
	else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
	else {
		resolved = {};
		if (globalMixins.length) globalMixins.forEach((m) => mergeOptions(resolved, m, optionMergeStrategies, true));
		mergeOptions(resolved, base, optionMergeStrategies);
	}
	if (isObject(base)) cache.set(base, resolved);
	return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
	const { mixins, extends: extendsOptions } = from;
	if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
	if (mixins) mixins.forEach((m) => mergeOptions(to, m, strats, true));
	for (const key in from) if (asMixin && key === "expose") {} else {
		const strat = internalOptionMergeStrats[key] || strats && strats[key];
		to[key] = strat ? strat(to[key], from[key]) : from[key];
	}
	return to;
}
var internalOptionMergeStrats = {
	data: mergeDataFn,
	props: mergeEmitsOrPropsOptions,
	emits: mergeEmitsOrPropsOptions,
	methods: mergeObjectOptions,
	computed: mergeObjectOptions,
	beforeCreate: mergeAsArray,
	created: mergeAsArray,
	beforeMount: mergeAsArray,
	mounted: mergeAsArray,
	beforeUpdate: mergeAsArray,
	updated: mergeAsArray,
	beforeDestroy: mergeAsArray,
	beforeUnmount: mergeAsArray,
	destroyed: mergeAsArray,
	unmounted: mergeAsArray,
	activated: mergeAsArray,
	deactivated: mergeAsArray,
	errorCaptured: mergeAsArray,
	serverPrefetch: mergeAsArray,
	components: mergeObjectOptions,
	directives: mergeObjectOptions,
	watch: mergeWatchOptions,
	provide: mergeDataFn,
	inject: mergeInject
};
function mergeDataFn(to, from) {
	if (!from) return to;
	if (!to) return from;
	return function mergedDataFn() {
		return extend(isFunction(to) ? to.call(this, this) : to, isFunction(from) ? from.call(this, this) : from);
	};
}
function mergeInject(to, from) {
	return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
	if (isArray(raw)) {
		const res = {};
		for (let i = 0; i < raw.length; i++) res[raw[i]] = raw[i];
		return res;
	}
	return raw;
}
function mergeAsArray(to, from) {
	return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
	return to ? extend(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
	if (to) {
		if (isArray(to) && isArray(from)) return [.../* @__PURE__ */ new Set([...to, ...from])];
		return extend(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
	} else return from;
}
function mergeWatchOptions(to, from) {
	if (!to) return from;
	if (!from) return to;
	const merged = extend(/* @__PURE__ */ Object.create(null), to);
	for (const key in from) merged[key] = mergeAsArray(to[key], from[key]);
	return merged;
}
function createAppContext() {
	return {
		app: null,
		config: {
			isNativeTag: NO,
			performance: false,
			globalProperties: {},
			optionMergeStrategies: {},
			errorHandler: void 0,
			warnHandler: void 0,
			compilerOptions: {}
		},
		mixins: [],
		components: {},
		directives: {},
		provides: /* @__PURE__ */ Object.create(null),
		optionsCache: /* @__PURE__ */ new WeakMap(),
		propsCache: /* @__PURE__ */ new WeakMap(),
		emitsCache: /* @__PURE__ */ new WeakMap()
	};
}
var uid$1 = 0;
function createAppAPI(render, hydrate) {
	return function createApp(rootComponent, rootProps = null) {
		if (!isFunction(rootComponent)) rootComponent = extend({}, rootComponent);
		if (rootProps != null && !isObject(rootProps)) rootProps = null;
		const context = createAppContext();
		const installedPlugins = /* @__PURE__ */ new WeakSet();
		const pluginCleanupFns = [];
		let isMounted = false;
		const app = context.app = {
			_uid: uid$1++,
			_component: rootComponent,
			_props: rootProps,
			_container: null,
			_context: context,
			_instance: null,
			version,
			get config() {
				return context.config;
			},
			set config(v) {},
			use(plugin, ...options) {
				if (installedPlugins.has(plugin)) {} else if (plugin && isFunction(plugin.install)) {
					installedPlugins.add(plugin);
					plugin.install(app, ...options);
				} else if (isFunction(plugin)) {
					installedPlugins.add(plugin);
					plugin(app, ...options);
				}
				return app;
			},
			mixin(mixin) {
				if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
				return app;
			},
			component(name, component) {
				if (!component) return context.components[name];
				context.components[name] = component;
				return app;
			},
			directive(name, directive) {
				if (!directive) return context.directives[name];
				context.directives[name] = directive;
				return app;
			},
			mount(rootContainer, isHydrate, namespace) {
				if (!isMounted) {
					const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
					vnode.appContext = context;
					if (namespace === true) namespace = "svg";
					else if (namespace === false) namespace = void 0;
					if (isHydrate && hydrate) hydrate(vnode, rootContainer);
					else render(vnode, rootContainer, namespace);
					isMounted = true;
					app._container = rootContainer;
					rootContainer.__vue_app__ = app;
					app._instance = vnode.component;
					devtoolsInitApp(app, version);
					return getComponentPublicInstance(vnode.component);
				}
			},
			onUnmount(cleanupFn) {
				pluginCleanupFns.push(cleanupFn);
			},
			unmount() {
				if (isMounted) {
					callWithAsyncErrorHandling(pluginCleanupFns, app._instance, 16);
					render(null, app._container);
					app._instance = null;
					devtoolsUnmountApp(app);
					delete app._container.__vue_app__;
				}
			},
			provide(key, value) {
				context.provides[key] = value;
				return app;
			},
			runWithContext(fn) {
				const lastApp = currentApp;
				currentApp = app;
				try {
					return fn();
				} finally {
					currentApp = lastApp;
				}
			}
		};
		return app;
	};
}
var currentApp = null;
var getModelModifiers = (props, modelName) => {
	return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
	if (instance.isUnmounted) return;
	const props = instance.vnode.props || EMPTY_OBJ;
	let args = rawArgs;
	const isModelListener = event.startsWith("update:");
	const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
	if (modifiers) {
		if (modifiers.trim) args = rawArgs.map((a) => isString(a) ? a.trim() : a);
		if (modifiers.number) args = args.map(looseToNumber);
	}
	devtoolsComponentEmit(instance, event, args);
	let handlerName;
	let handler = props[handlerName = toHandlerKey(event)] || props[handlerName = toHandlerKey(camelize(event))];
	if (!handler && isModelListener) handler = props[handlerName = toHandlerKey(hyphenate(event))];
	if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
	const onceHandler = props[handlerName + `Once`];
	if (onceHandler) {
		if (!instance.emitted) instance.emitted = {};
		else if (instance.emitted[handlerName]) return;
		instance.emitted[handlerName] = true;
		callWithAsyncErrorHandling(onceHandler, instance, 6, args);
	}
}
var mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
	const cache = asMixin ? mixinEmitsCache : appContext.emitsCache;
	const cached = cache.get(comp);
	if (cached !== void 0) return cached;
	const raw = comp.emits;
	let normalized = {};
	let hasExtends = false;
	if (!isFunction(comp)) {
		const extendEmits = (raw2) => {
			const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
			if (normalizedFromExtend) {
				hasExtends = true;
				extend(normalized, normalizedFromExtend);
			}
		};
		if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
		if (comp.extends) extendEmits(comp.extends);
		if (comp.mixins) comp.mixins.forEach(extendEmits);
	}
	if (!raw && !hasExtends) {
		if (isObject(comp)) cache.set(comp, null);
		return null;
	}
	if (isArray(raw)) raw.forEach((key) => normalized[key] = null);
	else extend(normalized, raw);
	if (isObject(comp)) cache.set(comp, normalized);
	return normalized;
}
function isEmitListener(options, key) {
	if (!options || !isOn(key)) return false;
	key = key.slice(2);
	key = key === "Once" ? key : key.replace(/Once$/, "");
	return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
}
function renderComponentRoot(instance) {
	const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
	const prev = setCurrentRenderingInstance(instance);
	let result;
	let fallthroughAttrs;
	try {
		if (vnode.shapeFlag & 4) {
			const proxyToUse = withProxy || proxy;
			const thisProxy = proxyToUse;
			result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
			fallthroughAttrs = attrs;
		} else {
			const render2 = Component;
			result = normalizeVNode(render2.length > 1 ? render2(props, {
				attrs,
				slots,
				emit
			}) : render2(props, null));
			fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
		}
	} catch (err) {
		blockStack.length = 0;
		handleError(err, instance, 1);
		result = createVNode(Comment);
	}
	let root = result;
	if (fallthroughAttrs && inheritAttrs !== false) {
		const keys = Object.keys(fallthroughAttrs);
		const { shapeFlag } = root;
		if (keys.length) {
			if (shapeFlag & 7) {
				if (propsOptions && keys.some(isModelListener)) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
				root = cloneVNode(root, fallthroughAttrs, false, true);
			}
		}
	}
	if (vnode.dirs) {
		root = cloneVNode(root, null, false, true);
		root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
	}
	if (vnode.transition) setTransitionHooks(isTeleport(root.type) ? getInnerChild$1(root) || root : root, vnode.transition);
	result = root;
	setCurrentRenderingInstance(prev);
	return result;
}
function filterSingleRoot(children, recurse = true) {
	let singleRoot;
	for (let i = 0; i < children.length; i++) {
		const child = children[i];
		if (isVNode(child)) {
			if (child.type !== Comment || child.children === "v-if") {
				if (singleRoot) return;
				else singleRoot = child;
			}
		} else return;
	}
	return singleRoot;
}
var getFunctionalFallthrough = (attrs) => {
	let res;
	for (const key in attrs) if (key === "class" || key === "style" || isOn(key)) (res || (res = {}))[key] = attrs[key];
	return res;
};
var filterModelListeners = (attrs, props) => {
	const res = {};
	for (const key in attrs) if (!isModelListener(key) || !(key.slice(9) in props)) res[key] = attrs[key];
	return res;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
	const { props: prevProps, children: prevChildren, component } = prevVNode;
	const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
	const emits = component.emitsOptions;
	if (nextVNode.dirs || nextVNode.transition) return true;
	if (optimized && patchFlag >= 0) {
		if (patchFlag & 1024) return true;
		if (patchFlag & 16) {
			if (!prevProps) return !!nextProps;
			return hasPropsChanged(prevProps, nextProps, emits);
		} else if (patchFlag & 8) {
			const dynamicProps = nextVNode.dynamicProps;
			for (let i = 0; i < dynamicProps.length; i++) {
				const key = dynamicProps[i];
				if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emits, key)) return true;
			}
		}
	} else {
		if (prevChildren || nextChildren) {
			if (!nextChildren || !nextChildren.$stable) return true;
		}
		if (prevProps === nextProps) return false;
		if (!prevProps) return !!nextProps;
		if (!nextProps) return true;
		return hasPropsChanged(prevProps, nextProps, emits);
	}
	return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
	const nextKeys = Object.keys(nextProps);
	if (nextKeys.length !== Object.keys(prevProps).length) return true;
	for (let i = 0; i < nextKeys.length; i++) {
		const key = nextKeys[i];
		if (!hasOwn(prevProps, key) || hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emitsOptions, key)) return true;
	}
	return false;
}
function hasPropValueChanged(nextProps, prevProps, key) {
	const nextProp = nextProps[key];
	const prevProp = prevProps[key];
	if (key === "style" && isObject(nextProp) && isObject(prevProp)) return !looseEqual(nextProp, prevProp);
	return nextProp !== prevProp;
}
function updateHOCHostEl({ vnode, parent, suspense }, el) {
	while (parent) {
		const root = parent.subTree;
		if (root.suspense && root.suspense.activeBranch === vnode) {
			root.suspense.vnode.el = root.el = el;
			vnode = root;
		}
		if (root === vnode) {
			(vnode = parent.vnode).el = el;
			parent = parent.parent;
		} else break;
	}
	if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
var internalObjectProto = {};
var createInternalObject = () => Object.create(internalObjectProto);
var isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
	const props = {};
	const attrs = createInternalObject();
	instance.propsDefaults = /* @__PURE__ */ Object.create(null);
	setFullProps(instance, rawProps, props, attrs);
	for (const key in instance.propsOptions[0]) if (!(key in props)) props[key] = void 0;
	if (isStateful) instance.props = isSSR ? props : /* @__PURE__ */ shallowReactive(props);
	else if (!instance.type.props) instance.props = attrs;
	else instance.props = props;
	instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
	const { props, attrs, vnode: { patchFlag } } = instance;
	const rawCurrentProps = /* @__PURE__ */ toRaw(props);
	const [options] = instance.propsOptions;
	let hasAttrsChanged = false;
	if ((optimized || patchFlag > 0) && !(patchFlag & 16)) {
		if (patchFlag & 8) {
			const propsToUpdate = instance.vnode.dynamicProps;
			for (let i = 0; i < propsToUpdate.length; i++) {
				let key = propsToUpdate[i];
				if (isEmitListener(instance.emitsOptions, key)) continue;
				const value = rawProps[key];
				if (options) {
					if (hasOwn(attrs, key)) {
						if (value !== attrs[key]) {
							attrs[key] = value;
							hasAttrsChanged = true;
						}
					} else {
						const camelizedKey = camelize(key);
						props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
					}
				} else if (value !== attrs[key]) {
					attrs[key] = value;
					hasAttrsChanged = true;
				}
			}
		}
	} else {
		if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
		let kebabKey;
		for (const key in rawCurrentProps) if (!rawProps || !hasOwn(rawProps, key) && ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
			if (options) {
				if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
			} else delete props[key];
		}
		if (attrs !== rawCurrentProps) {
			for (const key in attrs) if (!rawProps || !hasOwn(rawProps, key) && true) {
				delete attrs[key];
				hasAttrsChanged = true;
			}
		}
	}
	if (hasAttrsChanged) trigger(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
	const [options, needCastKeys] = instance.propsOptions;
	let hasAttrsChanged = false;
	let rawCastValues;
	if (rawProps) for (let key in rawProps) {
		if (isReservedProp(key)) continue;
		const value = rawProps[key];
		let camelKey;
		if (options && hasOwn(options, camelKey = camelize(key))) {
			if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
			else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
		} else if (!isEmitListener(instance.emitsOptions, key)) {
			if (!(key in attrs) || value !== attrs[key]) {
				attrs[key] = value;
				hasAttrsChanged = true;
			}
		}
	}
	if (needCastKeys) {
		const rawCurrentProps = /* @__PURE__ */ toRaw(props);
		const castValues = rawCastValues || EMPTY_OBJ;
		for (let i = 0; i < needCastKeys.length; i++) {
			const key = needCastKeys[i];
			props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !hasOwn(castValues, key));
		}
	}
	return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
	const opt = options[key];
	if (opt != null) {
		const hasDefault = hasOwn(opt, "default");
		if (hasDefault && value === void 0) {
			const defaultValue = opt.default;
			if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
				const { propsDefaults } = instance;
				if (key in propsDefaults) value = propsDefaults[key];
				else {
					const reset = setCurrentInstance(instance);
					value = propsDefaults[key] = defaultValue.call(null, props);
					reset();
				}
			} else value = defaultValue;
			if (instance.ce) instance.ce._setProp(key, value);
		}
		if (opt[0]) {
			if (isAbsent && !hasDefault) value = false;
			else if (opt[1] && (value === "" || value === hyphenate(key))) value = true;
		}
	}
	return value;
}
var mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
	const cache = asMixin ? mixinPropsCache : appContext.propsCache;
	const cached = cache.get(comp);
	if (cached) return cached;
	const raw = comp.props;
	const normalized = {};
	const needCastKeys = [];
	let hasExtends = false;
	if (!isFunction(comp)) {
		const extendProps = (raw2) => {
			hasExtends = true;
			const [props, keys] = normalizePropsOptions(raw2, appContext, true);
			extend(normalized, props);
			if (keys) needCastKeys.push(...keys);
		};
		if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
		if (comp.extends) extendProps(comp.extends);
		if (comp.mixins) comp.mixins.forEach(extendProps);
	}
	if (!raw && !hasExtends) {
		if (isObject(comp)) cache.set(comp, EMPTY_ARR);
		return EMPTY_ARR;
	}
	if (isArray(raw)) for (let i = 0; i < raw.length; i++) {
		const normalizedKey = camelize(raw[i]);
		if (validatePropName(normalizedKey)) normalized[normalizedKey] = EMPTY_OBJ;
	}
	else if (raw) for (const key in raw) {
		const normalizedKey = camelize(key);
		if (validatePropName(normalizedKey)) {
			const opt = raw[key];
			const prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend({}, opt);
			const propType = prop.type;
			let shouldCast = false;
			let shouldCastTrue = true;
			if (isArray(propType)) for (let index = 0; index < propType.length; ++index) {
				const type = propType[index];
				const typeName = isFunction(type) && type.name;
				if (typeName === "Boolean") {
					shouldCast = true;
					break;
				} else if (typeName === "String") shouldCastTrue = false;
			}
			else shouldCast = isFunction(propType) && propType.name === "Boolean";
			prop[0] = shouldCast;
			prop[1] = shouldCastTrue;
			if (shouldCast || hasOwn(prop, "default")) needCastKeys.push(normalizedKey);
		}
	}
	const res = [normalized, needCastKeys];
	if (isObject(comp)) cache.set(comp, res);
	return res;
}
function validatePropName(key) {
	if (key[0] !== "$" && !isReservedProp(key)) return true;
	return false;
}
var isInternalKey = (key) => key === "_" || key === "_ctx" || key === "$stable";
var normalizeSlotValue = (value) => isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
var normalizeSlot = (key, rawSlot, ctx) => {
	if (rawSlot._n) return rawSlot;
	const normalized = withCtx((...args) => {
		return normalizeSlotValue(rawSlot(...args));
	}, ctx);
	normalized._c = false;
	return normalized;
};
var normalizeObjectSlots = (rawSlots, slots, instance) => {
	const ctx = rawSlots._ctx;
	for (const key in rawSlots) {
		if (isInternalKey(key)) continue;
		const value = rawSlots[key];
		if (isFunction(value)) slots[key] = normalizeSlot(key, value, ctx);
		else if (value != null) {
			const normalized = normalizeSlotValue(value);
			slots[key] = () => normalized;
		}
	}
};
var normalizeVNodeSlots = (instance, children) => {
	const normalized = normalizeSlotValue(children);
	instance.slots.default = () => normalized;
};
var assignSlots = (slots, children, optimized) => {
	for (const key in children) if (optimized || !isInternalKey(key)) slots[key] = children[key];
};
var initSlots = (instance, children, optimized) => {
	const slots = instance.slots = createInternalObject();
	if (instance.vnode.shapeFlag & 32) {
		const type = children._;
		if (type) {
			assignSlots(slots, children, optimized);
			if (optimized) def(slots, "_", type, true);
		} else normalizeObjectSlots(children, slots);
	} else if (children) normalizeVNodeSlots(instance, children);
};
var updateSlots = (instance, children, optimized) => {
	const { vnode, slots } = instance;
	let needDeletionCheck = true;
	let deletionComparisonTarget = EMPTY_OBJ;
	if (vnode.shapeFlag & 32) {
		const type = children._;
		if (type) {
			if (optimized && type === 1) needDeletionCheck = false;
			else assignSlots(slots, children, optimized);
		} else {
			needDeletionCheck = !children.$stable;
			normalizeObjectSlots(children, slots);
		}
		deletionComparisonTarget = children;
	} else if (children) {
		normalizeVNodeSlots(instance, children);
		deletionComparisonTarget = { default: 1 };
	}
	if (needDeletionCheck) {
		for (const key in slots) if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
	}
};
var queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
	return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
	const target = getGlobalThis();
	target.__VUE__ = true;
	setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
	const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, insertStaticContent: hostInsertStaticContent } = options;
	const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
		if (n1 === n2) return;
		if (n1 && !isSameVNodeType(n1, n2)) {
			anchor = getNextHostNode(n1);
			unmount(n1, parentComponent, parentSuspense, true);
			n1 = null;
		}
		if (n2.patchFlag === -2) {
			optimized = false;
			n2.dynamicChildren = null;
		}
		if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
			if (n2.dynamicChildren === EMPTY_ARR) n2.dynamicChildren = [];
			n2.dynamicChildren.hasOnce = true;
		}
		const { type, ref, shapeFlag } = n2;
		switch (type) {
			case Text:
				processText(n1, n2, container, anchor);
				break;
			case Comment:
				processCommentNode(n1, n2, container, anchor);
				break;
			case Static:
				if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
				break;
			case Fragment:
				processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
				break;
			default: if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
			else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
		}
		if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
		else if (ref == null && n1 && n1.ref != null) setRef(n1.ref, null, parentSuspense, n1, true);
	};
	const processText = (n1, n2, container, anchor) => {
		if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
		else {
			const el = n2.el = n1.el;
			if (n2.children !== n1.children) hostSetText(el, n2.children);
		}
	};
	const processCommentNode = (n1, n2, container, anchor) => {
		if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
		else n2.el = n1.el;
	};
	const mountStaticNode = (n2, container, anchor, namespace) => {
		[n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
	};
	const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
		let next;
		while (el && el !== anchor) {
			next = hostNextSibling(el);
			hostInsert(el, container, nextSibling);
			el = next;
		}
		hostInsert(anchor, container, nextSibling);
	};
	const removeStaticNode = ({ el, anchor }) => {
		let next;
		while (el && el !== anchor) {
			next = hostNextSibling(el);
			hostRemove(el);
			el = next;
		}
		hostRemove(anchor);
	};
	const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		if (n2.type === "svg") namespace = "svg";
		else if (n2.type === "math") namespace = "mathml";
		if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
		else {
			const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
			try {
				if (customElement) customElement._beginPatch();
				patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			} finally {
				if (customElement) customElement._endPatch();
			}
		}
	};
	const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		let el;
		let vnodeHook;
		const { props, shapeFlag, transition, dirs } = vnode;
		el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
		if (shapeFlag & 8) hostSetElementText(el, vnode.children);
		else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
		if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
		setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
		if (props) {
			for (const key in props) if (key !== "value" && !isReservedProp(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
			if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
			if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
		}
		def(el, "__vnode", vnode, true);
		def(el, "__vueParentComponent", parentComponent, true);
		if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
		const needCallTransitionHooks = needTransition(parentSuspense, transition);
		if (needCallTransitionHooks) transition.beforeEnter(el);
		hostInsert(el, container, anchor);
		if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) queuePostRenderEffect(() => {
			try {
				vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
				needCallTransitionHooks && transition.enter(el);
				dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
			} finally {}
		}, parentSuspense);
	};
	const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
		if (scopeId) hostSetScopeId(el, scopeId);
		if (slotScopeIds) for (let i = 0; i < slotScopeIds.length; i++) hostSetScopeId(el, slotScopeIds[i]);
		if (parentComponent) {
			let subTree = parentComponent.subTree;
			if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
				const parentVNode = parentComponent.vnode;
				setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
			}
		}
	};
	const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
		for (let i = start; i < children.length; i++) {
			const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
			patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
		}
	};
	const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		const el = n2.el = n1.el;
		el.__vnode = n2;
		let { patchFlag, dynamicChildren, dirs } = n2;
		patchFlag |= n1.patchFlag & 16;
		const oldProps = n1.props || EMPTY_OBJ;
		const newProps = n2.props || EMPTY_OBJ;
		let vnodeHook;
		parentComponent && toggleRecurse(parentComponent, false);
		if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
		if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
		parentComponent && toggleRecurse(parentComponent, true);
		if (dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
			patchFlag = 0;
			optimized = false;
			dynamicChildren = null;
		}
		if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
		if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
		else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
		if (patchFlag > 0) {
			if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
			else {
				if (patchFlag & 2) {
					if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
				}
				if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
				if (patchFlag & 8) {
					const propsToUpdate = n2.dynamicProps;
					for (let i = 0; i < propsToUpdate.length; i++) {
						const key = propsToUpdate[i];
						const prev = oldProps[key];
						const next = newProps[key];
						if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
					}
				}
			}
			if (patchFlag & 1) {
				if (n1.children !== n2.children) hostSetElementText(el, n2.children);
			}
		} else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
		if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(() => {
			vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
			dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
		}, parentSuspense);
	};
	const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
		for (let i = 0; i < newChildren.length; i++) {
			const oldVNode = oldChildren[i];
			const newVNode = newChildren[i];
			const oldEl = oldVNode.el || resolveAsyncComponentPlaceholder(oldVNode);
			const container = oldEl && (oldVNode.type === Fragment || !isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & 198) ? hostParentNode(oldEl) : fallbackContainer;
			patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
		}
	};
	const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
		if (oldProps !== newProps) {
			if (oldProps !== EMPTY_OBJ) {
				for (const key in oldProps) if (!isReservedProp(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
			}
			for (const key in newProps) {
				if (isReservedProp(key)) continue;
				const next = newProps[key];
				const prev = oldProps[key];
				if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
			}
			if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
		}
	};
	const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
		const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
		let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
		if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
		if (n1 == null) {
			hostInsert(fragmentStartAnchor, container, anchor);
			hostInsert(fragmentEndAnchor, container, anchor);
			mountChildren(n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
		} else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
			patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
			if (n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
		} else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
	};
	const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		n2.slotScopeIds = slotScopeIds;
		if (n1 == null) {
			if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
			else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
		} else updateComponent(n1, n2, optimized);
	};
	const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
		const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
		if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
		setupComponent(instance, false, optimized);
		if (instance.asyncDep) {
			parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized, namespace);
			if (!initialVNode.el) {
				const placeholder = instance.subTree = createVNode(Comment);
				processCommentNode(null, placeholder, container, anchor);
				initialVNode.placeholder = placeholder.el;
			}
		} else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
	};
	const updateComponent = (n1, n2, optimized) => {
		const instance = n2.component = n1.component;
		if (shouldUpdateComponent(n1, n2, optimized)) {
			if (instance.asyncDep && !instance.asyncResolved) {
				n2.el = n1.el;
				n2.placeholder = n1.placeholder;
				updateComponentPreRender(instance, n2, optimized);
				return;
			} else {
				instance.next = n2;
				instance.update();
			}
		} else {
			n2.el = n1.el;
			n2.placeholder = n1.placeholder;
			instance.vnode = n2;
		}
	};
	const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
		const componentUpdateFn = () => {
			if (!instance.isMounted) {
				let vnodeHook;
				const { el, props } = initialVNode;
				const { bm, m, parent, root, type } = instance;
				const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
				toggleRecurse(instance, false);
				if (bm) invokeArrayFns(bm);
				if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
				toggleRecurse(instance, true);
				if (el && hydrateNode) {
					const hydrateSubTree = () => {
						instance.subTree = renderComponentRoot(instance);
						hydrateNode(el, instance.subTree, instance, parentSuspense, null);
					};
					if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
					else hydrateSubTree();
				} else {
					if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
					const subTree = instance.subTree = renderComponentRoot(instance);
					patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
					initialVNode.el = subTree.el;
				}
				if (m) queuePostRenderEffect(m, parentSuspense);
				if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
					const scopedInitialVNode = initialVNode;
					queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
				}
				if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
				instance.isMounted = true;
				devtoolsComponentAdded(instance);
				initialVNode = container = anchor = null;
			} else {
				let { next, bu, u, parent, vnode } = instance;
				{
					const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
					if (nonHydratedAsyncRoot) {
						if (next) {
							next.el = vnode.el;
							updateComponentPreRender(instance, next, optimized);
						}
						nonHydratedAsyncRoot.asyncDep.then(() => {
							queuePostRenderEffect(() => {
								if (!instance.isUnmounted) update();
							}, parentSuspense);
						});
						return;
					}
				}
				let originNext = next;
				let vnodeHook;
				toggleRecurse(instance, false);
				if (next) {
					next.el = vnode.el;
					updateComponentPreRender(instance, next, optimized);
				} else next = vnode;
				if (bu) invokeArrayFns(bu);
				if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
				toggleRecurse(instance, true);
				const nextTree = renderComponentRoot(instance);
				const prevTree = instance.subTree;
				instance.subTree = nextTree;
				patch(prevTree, nextTree, hostParentNode(prevTree.el), getNextHostNode(prevTree), instance, parentSuspense, namespace);
				next.el = nextTree.el;
				if (originNext === null) updateHOCHostEl(instance, nextTree.el);
				if (u) queuePostRenderEffect(u, parentSuspense);
				if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
				devtoolsComponentUpdated(instance);
			}
		};
		instance.scope.on();
		const effect = instance.effect = new ReactiveEffect(componentUpdateFn);
		instance.scope.off();
		const update = instance.update = effect.run.bind(effect);
		const job = instance.job = effect.runIfDirty.bind(effect);
		job.i = instance;
		job.id = instance.uid;
		effect.scheduler = () => queueJob(job);
		toggleRecurse(instance, true);
		update();
	};
	const updateComponentPreRender = (instance, nextVNode, optimized) => {
		nextVNode.component = instance;
		const prevProps = instance.vnode.props;
		instance.vnode = nextVNode;
		instance.next = null;
		updateProps(instance, nextVNode.props, prevProps, optimized);
		updateSlots(instance, nextVNode.children, optimized);
		pauseTracking();
		flushPreFlushCbs(instance);
		resetTracking();
	};
	const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
		const c1 = n1 && n1.children;
		const prevShapeFlag = n1 ? n1.shapeFlag : 0;
		const c2 = n2.children;
		const { patchFlag, shapeFlag } = n2;
		if (patchFlag > 0) {
			if (patchFlag & 128) {
				patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
				return;
			} else if (patchFlag & 256) {
				patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
				return;
			}
		}
		if (shapeFlag & 8) {
			if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
			if (c2 !== c1) hostSetElementText(container, c2);
		} else if (prevShapeFlag & 16) {
			if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			else unmountChildren(c1, parentComponent, parentSuspense, true);
		} else {
			if (prevShapeFlag & 8) hostSetElementText(container, "");
			if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
		}
	};
	const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		c1 = c1 || EMPTY_ARR;
		c2 = c2 || EMPTY_ARR;
		const oldLength = c1.length;
		const newLength = c2.length;
		const commonLength = Math.min(oldLength, newLength);
		let i = 0;
		for (; i < commonLength; i++) {
			const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
			patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
		}
		if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
		else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
	};
	const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
		let i = 0;
		const l2 = c2.length;
		let e1 = c1.length - 1;
		let e2 = l2 - 1;
		while (i <= e1 && i <= e2) {
			const n1 = c1[i];
			const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
			if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			else break;
			i++;
		}
		while (i <= e1 && i <= e2) {
			const n1 = c1[e1];
			const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
			if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
			else break;
			e1--;
			e2--;
		}
		if (i > e1) {
			if (i <= e2) {
				const nextPos = e2 + 1;
				const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
				while (i <= e2) {
					patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
					i++;
				}
			}
		} else if (i > e2) while (i <= e1) {
			unmount(c1[i], parentComponent, parentSuspense, true);
			i++;
		}
		else {
			const s1 = i;
			const s2 = i;
			const keyToNewIndexMap = /* @__PURE__ */ new Map();
			for (i = s2; i <= e2; i++) {
				const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
				if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
			}
			let j;
			let patched = 0;
			const toBePatched = e2 - s2 + 1;
			let moved = false;
			let maxNewIndexSoFar = 0;
			const newIndexToOldIndexMap = new Array(toBePatched);
			for (i = 0; i < toBePatched; i++) newIndexToOldIndexMap[i] = 0;
			for (i = s1; i <= e1; i++) {
				const prevChild = c1[i];
				if (patched >= toBePatched) {
					unmount(prevChild, parentComponent, parentSuspense, true);
					continue;
				}
				let newIndex;
				if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
				else for (j = s2; j <= e2; j++) if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
					newIndex = j;
					break;
				}
				if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
				else {
					newIndexToOldIndexMap[newIndex - s2] = i + 1;
					if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
					else moved = true;
					patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
					patched++;
				}
			}
			const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
			j = increasingNewIndexSequence.length - 1;
			for (i = toBePatched - 1; i >= 0; i--) {
				const nextIndex = s2 + i;
				const nextChild = c2[nextIndex];
				const anchorVNode = c2[nextIndex + 1];
				const anchor = nextIndex + 1 < l2 ? anchorVNode.el || resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
				if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
				else if (moved) {
					if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
					else j--;
				}
			}
		}
	};
	const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
		const { el, type, transition, children, shapeFlag } = vnode;
		if (shapeFlag & 6) {
			move(vnode.component.subTree, container, anchor, moveType);
			return;
		}
		if (shapeFlag & 128) {
			vnode.suspense.move(container, anchor, moveType);
			return;
		}
		if (shapeFlag & 64) {
			type.move(vnode, container, anchor, internals);
			return;
		}
		if (type === Fragment) {
			hostInsert(el, container, anchor);
			for (let i = 0; i < children.length; i++) move(children[i], container, anchor, moveType);
			hostInsert(vnode.anchor, container, anchor);
			return;
		}
		if (type === Static) {
			moveStaticNode(vnode, container, anchor);
			return;
		}
		if (moveType !== 2 && shapeFlag & 1 && transition) {
			if (moveType === 0) {
				if (transition.persisted && !el[leaveCbKey]) hostInsert(el, container, anchor);
				else {
					transition.beforeEnter(el);
					hostInsert(el, container, anchor);
					queuePostRenderEffect(() => transition.enter(el), parentSuspense);
				}
			} else {
				const { leave, delayLeave, afterLeave } = transition;
				const remove2 = () => {
					if (vnode.ctx.isUnmounted) hostRemove(el);
					else hostInsert(el, container, anchor);
				};
				const performLeave = () => {
					const wasLeaving = el._isLeaving || !!el[leaveCbKey];
					if (el._isLeaving) el[leaveCbKey](true);
					if (transition.persisted && !wasLeaving) remove2();
					else leave(el, () => {
						remove2();
						afterLeave && afterLeave();
					});
				};
				if (delayLeave) delayLeave(el, remove2, performLeave);
				else performLeave();
			}
		} else hostInsert(el, container, anchor);
	};
	const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
		const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex, memo } = vnode;
		if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
		if (ref != null) {
			pauseTracking();
			setRef(ref, null, parentSuspense, vnode, true);
			resetTracking();
		}
		if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
		if (shapeFlag & 256) {
			parentComponent.ctx.deactivate(vnode);
			return;
		}
		const shouldInvokeDirs = shapeFlag & 1 && dirs;
		const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
		let vnodeHook;
		if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
		if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
		else {
			if (shapeFlag & 128) {
				vnode.suspense.unmount(parentSuspense, doRemove);
				return;
			}
			if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
			if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
			else if (dynamicChildren && !dynamicChildren.hasOnce && (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
			else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
			if (doRemove) remove(vnode);
		}
		const shouldInvalidateMemo = memo != null && cacheIndex == null;
		if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) queuePostRenderEffect(() => {
			vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
			shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
			if (shouldInvalidateMemo) vnode.el = null;
		}, parentSuspense);
	};
	const remove = (vnode) => {
		const { type, el, anchor, transition } = vnode;
		const isFragment = type === Fragment;
		if (isFragment && !transition) {
			removeFragment(el, anchor);
			return;
		}
		if (type === Static) {
			removeStaticNode(vnode);
			if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
			return;
		}
		const leavingNode = isFragment ? getTransitionRoot(vnode) : vnode;
		const performRemove = () => {
			if (isFragment) {
				if (hostParentNode(el)) removeFragment(el, anchor);
			} else hostRemove(el);
			if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
		};
		if (leavingNode && leavingNode.shapeFlag & 1 && transition && !transition.persisted) {
			const { leave, delayLeave } = transition;
			const leavingEl = leavingNode.el;
			const performLeave = () => leave(leavingEl, performRemove);
			if (delayLeave) delayLeave(leavingEl, performRemove, performLeave);
			else performLeave();
		} else performRemove();
	};
	const removeFragment = (cur, end) => {
		let next;
		while (cur !== end) {
			next = hostNextSibling(cur);
			hostRemove(cur);
			cur = next;
		}
		hostRemove(end);
	};
	const unmountComponent = (instance, parentSuspense, doRemove) => {
		const { bum, scope, job, subTree, um, m, a } = instance;
		invalidateMount(m);
		invalidateMount(a);
		if (bum) invokeArrayFns(bum);
		scope.stop();
		if (job) {
			job.flags |= 8;
			unmount(subTree, instance, parentSuspense, doRemove);
		} else if (instance.vnode.el && subTree) {
			subTree.transition = instance.vnode.transition;
			unmount(subTree, instance, parentSuspense, doRemove);
		}
		if (um) queuePostRenderEffect(um, parentSuspense);
		queuePostRenderEffect(() => {
			instance.isUnmounted = true;
		}, parentSuspense);
		devtoolsComponentRemoved(instance);
	};
	const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
		for (let i = start; i < children.length; i++) unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
	};
	const getNextHostNode = (vnode) => {
		if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
		if (vnode.shapeFlag & 128) return vnode.suspense.next();
		const el = hostNextSibling(vnode.anchor || vnode.el);
		const teleportEnd = el && el[TeleportEndKey];
		return teleportEnd ? hostNextSibling(teleportEnd) : el;
	};
	const render = (vnode, container, namespace) => {
		flushOnAppMount(() => {
			if (vnode == null) {
				if (container._vnode) unmount(container._vnode, null, null, true);
			} else patch(container._vnode || null, vnode, container, null, null, null, namespace);
			container._vnode = vnode;
		}, vnode && container._vnode ? void 0 : vnode && vnode.component ? vnode.component.uid : getNextUid());
	};
	const internals = {
		p: patch,
		um: unmount,
		m: move,
		r: remove,
		mt: mountComponent,
		mc: mountChildren,
		pc: patchChildren,
		pbc: patchBlockChildren,
		n: getNextHostNode,
		o: options
	};
	let hydrate;
	let hydrateNode;
	if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
	return {
		render,
		hydrate,
		createApp: createAppAPI(render, hydrate)
	};
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
	return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, job }, allowed) {
	if (allowed) {
		effect.flags |= 32;
		job.flags |= 4;
	} else {
		effect.flags &= -33;
		job.flags &= -5;
	}
}
function needTransition(parentSuspense, transition) {
	return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
	const ch1 = n1.children;
	const ch2 = n2.children;
	if (isArray(ch1) && isArray(ch2)) for (let i = 0; i < ch1.length; i++) {
		const c1 = ch1[i];
		let c2 = ch2[i];
		if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
			if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
				c2 = ch2[i] = cloneIfMounted(ch2[i]);
				c2.el = c1.el;
			}
			if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
		}
		if (c2.type === Text) {
			if (c2.patchFlag === -1) c2 = ch2[i] = cloneIfMounted(c2);
			c2.el = c1.el;
		}
		if (c2.type === Comment && !c2.el) c2.el = c1.el;
	}
}
function getSequence(arr) {
	const p = arr.slice();
	const result = [0];
	let i, j, u, v, c;
	const len = arr.length;
	for (i = 0; i < len; i++) {
		const arrI = arr[i];
		if (arrI !== 0) {
			j = result[result.length - 1];
			if (arr[j] < arrI) {
				p[i] = j;
				result.push(i);
				continue;
			}
			u = 0;
			v = result.length - 1;
			while (u < v) {
				c = u + v >> 1;
				if (arr[result[c]] < arrI) u = c + 1;
				else v = c;
			}
			if (arrI < arr[result[u]]) {
				if (u > 0) p[i] = result[u - 1];
				result[u] = i;
			}
		}
	}
	u = result.length;
	v = result[u - 1];
	while (u-- > 0) {
		result[u] = v;
		v = p[v];
	}
	return result;
}
function locateNonHydratedAsyncRoot(instance) {
	const subComponent = instance.subTree.component;
	if (subComponent) {
		if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
		else return locateNonHydratedAsyncRoot(subComponent);
	}
}
function invalidateMount(hooks) {
	if (hooks) for (let i = 0; i < hooks.length; i++) hooks[i].flags |= 8;
}
function resolveAsyncComponentPlaceholder(anchorVnode) {
	if (anchorVnode.placeholder) return anchorVnode.placeholder;
	const instance = anchorVnode.component;
	if (instance) return resolveAsyncComponentPlaceholder(instance.subTree);
	return null;
}
var isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn, suspense) {
	if (suspense && suspense.pendingBranch) {
		if (isArray(fn)) suspense.effects.push(...fn);
		else suspense.effects.push(fn);
	} else queuePostFlushCb(fn);
}
var Fragment = /* @__PURE__ */ Symbol.for("v-fgt");
var Text = /* @__PURE__ */ Symbol.for("v-txt");
var Comment = /* @__PURE__ */ Symbol.for("v-cmt");
var Static = /* @__PURE__ */ Symbol.for("v-stc");
var blockStack = [];
var currentBlock = null;
function openBlock(disableTracking = false) {
	blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
	blockStack.pop();
	currentBlock = blockStack[blockStack.length - 1] || null;
}
var isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
	isBlockTreeEnabled += value;
	if (value < 0 && currentBlock && inVOnce) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
	vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
	closeBlock();
	if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
	return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
	return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
	return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
	return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
	return n1.type === n2.type && n1.key === n2.key;
}
var normalizeKey = ({ key }) => key != null ? key : null;
var normalizeRef = ({ ref, ref_key, ref_for }) => {
	if (typeof ref === "number") ref = "" + ref;
	return ref != null ? isString(ref) || /* @__PURE__ */ isRef(ref) || isFunction(ref) ? {
		i: currentRenderingInstance,
		r: ref,
		k: ref_key,
		f: !!ref_for
	} : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
	const vnode = {
		__v_isVNode: true,
		__v_skip: true,
		type,
		props,
		key: props && normalizeKey(props),
		ref: props && normalizeRef(props),
		scopeId: currentScopeId,
		slotScopeIds: null,
		children,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag,
		patchFlag,
		dynamicProps,
		dynamicChildren: null,
		appContext: null,
		ctx: currentRenderingInstance
	};
	if (needFullChildrenNormalization) {
		normalizeChildren(vnode, children);
		if (shapeFlag & 128) type.normalize(vnode);
	} else if (children) vnode.shapeFlag |= isString(children) ? 8 : 16;
	if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) currentBlock.push(vnode);
	return vnode;
}
var createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
	if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
	if (isVNode(type)) {
		const cloned = cloneVNode(type, props, true);
		if (children) normalizeChildren(cloned, children);
		if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
			if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
			else currentBlock.push(cloned);
		}
		cloned.patchFlag = -2;
		return cloned;
	}
	if (isClassComponent(type)) type = type.__vccOpts;
	if (props) {
		props = guardReactiveProps(props);
		let { class: klass, style } = props;
		if (klass && !isString(klass)) props.class = normalizeClass(klass);
		if (isObject(style)) {
			if (/* @__PURE__ */ isProxy(style) && !isArray(style)) style = extend({}, style);
			props.style = normalizeStyle(style);
		}
	}
	const shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject(type) ? 4 : isFunction(type) ? 2 : 0;
	return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
	if (!props) return null;
	return /* @__PURE__ */ isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
	const { props, ref, patchFlag, children, transition } = vnode;
	const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
	const cloned = {
		__v_isVNode: true,
		__v_skip: true,
		type: vnode.type,
		props: mergedProps,
		key: mergedProps && normalizeKey(mergedProps),
		ref: extraProps && extraProps.ref ? mergeRef && ref ? isArray(ref) ? ref.concat(normalizeRef(extraProps)) : [ref, normalizeRef(extraProps)] : normalizeRef(extraProps) : ref,
		scopeId: vnode.scopeId,
		slotScopeIds: vnode.slotScopeIds,
		children,
		target: vnode.target,
		targetStart: vnode.targetStart,
		targetAnchor: vnode.targetAnchor,
		staticCount: vnode.staticCount,
		shapeFlag: vnode.shapeFlag,
		patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
		dynamicProps: vnode.dynamicProps,
		dynamicChildren: vnode.dynamicChildren,
		appContext: vnode.appContext,
		dirs: vnode.dirs,
		transition,
		component: vnode.component,
		suspense: vnode.suspense,
		ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
		ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
		placeholder: vnode.placeholder,
		el: vnode.el,
		anchor: vnode.anchor,
		ctx: vnode.ctx,
		ce: vnode.ce,
		cacheIndex: vnode.cacheIndex
	};
	if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
	return cloned;
}
function createTextVNode(text = " ", flag = 0) {
	return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
	return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
	if (child == null || typeof child === "boolean") return createVNode(Comment);
	else if (isArray(child)) return createVNode(Fragment, null, child.slice());
	else if (isVNode(child)) return cloneIfMounted(child);
	else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
	return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
	let type = 0;
	const { shapeFlag } = vnode;
	if (children == null) children = null;
	else if (isArray(children)) type = 16;
	else if (typeof children === "object") {
		if (shapeFlag & 65) {
			const slot = children.default;
			if (slot) {
				slot._c && (slot._d = false);
				normalizeChildren(vnode, slot());
				slot._c && (slot._d = true);
			}
			return;
		} else {
			type = 32;
			const slotFlag = children._;
			if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
			else if (slotFlag === 3 && currentRenderingInstance) {
				if (currentRenderingInstance.slots._ === 1) children._ = 1;
				else {
					children._ = 2;
					vnode.patchFlag |= 1024;
				}
			}
		}
	} else if (isFunction(children)) {
		if (shapeFlag & 65) {
			normalizeChildren(vnode, { default: children });
			return;
		}
		children = {
			default: children,
			_ctx: currentRenderingInstance
		};
		type = 32;
	} else {
		children = String(children);
		if (shapeFlag & 64) {
			type = 16;
			children = [createTextVNode(children)];
		} else type = 8;
	}
	vnode.children = children;
	vnode.shapeFlag |= type;
}
function mergeProps(...args) {
	const ret = {};
	for (let i = 0; i < args.length; i++) {
		const toMerge = args[i];
		for (const key in toMerge) if (key === "class") {
			if (ret.class !== toMerge.class) ret.class = normalizeClass([ret.class, toMerge.class]);
		} else if (key === "style") ret.style = normalizeStyle([ret.style, toMerge.style]);
		else if (isOn(key)) {
			const existing = ret[key];
			const incoming = toMerge[key];
			if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
			else if (incoming == null && existing == null && !isModelListener(key)) ret[key] = incoming;
		} else if (key !== "") ret[key] = toMerge[key];
	}
	return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
	callWithAsyncErrorHandling(hook, instance, 7, [vnode, prevVNode]);
}
var emptyAppContext = createAppContext();
var uid = 0;
function getNextUid() {
	return uid;
}
function createComponentInstance(vnode, parent, suspense) {
	const type = vnode.type;
	const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
	const instance = {
		uid: uid++,
		vnode,
		type,
		parent,
		appContext,
		root: null,
		next: null,
		subTree: null,
		effect: null,
		update: null,
		job: null,
		scope: new EffectScope(true),
		render: null,
		proxy: null,
		exposed: null,
		exposeProxy: null,
		withProxy: null,
		provides: parent ? parent.provides : Object.create(appContext.provides),
		ids: parent ? parent.ids : [
			"",
			0,
			0
		],
		accessCache: null,
		renderCache: [],
		components: null,
		directives: null,
		propsOptions: normalizePropsOptions(type, appContext),
		emitsOptions: normalizeEmitsOptions(type, appContext),
		emit: null,
		emitted: null,
		propsDefaults: EMPTY_OBJ,
		inheritAttrs: type.inheritAttrs,
		ctx: EMPTY_OBJ,
		data: EMPTY_OBJ,
		props: EMPTY_OBJ,
		attrs: EMPTY_OBJ,
		slots: EMPTY_OBJ,
		refs: EMPTY_OBJ,
		setupState: EMPTY_OBJ,
		setupContext: null,
		suspense,
		suspenseId: suspense ? suspense.pendingId : 0,
		asyncDep: null,
		asyncResolved: false,
		isMounted: false,
		isUnmounted: false,
		isDeactivated: false,
		bc: null,
		c: null,
		bm: null,
		m: null,
		bu: null,
		u: null,
		um: null,
		bum: null,
		da: null,
		a: null,
		rtg: null,
		rtc: null,
		ec: null,
		sp: null
	};
	instance.ctx = { _: instance };
	instance.root = parent ? parent.root : instance;
	instance.emit = emit.bind(null, instance);
	if (vnode.ce) vnode.ce(instance);
	return instance;
}
var currentInstance = null;
var getCurrentInstance = () => currentInstance || currentRenderingInstance;
var internalSetCurrentInstance;
var setInSSRSetupState;
{
	const g = getGlobalThis();
	const registerGlobalSetter = (key, setter) => {
		let setters;
		if (!(setters = g[key])) setters = g[key] = [];
		setters.push(setter);
		return (v) => {
			if (setters.length > 1) setters.forEach((set) => set(v));
			else setters[0](v);
		};
	};
	internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v) => currentInstance = v);
	setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v) => isInSSRComponentSetup = v);
}
var setCurrentInstance = (instance) => {
	const prev = currentInstance;
	internalSetCurrentInstance(instance);
	instance.scope.on();
	return () => {
		instance.scope.off();
		internalSetCurrentInstance(prev);
	};
};
var unsetCurrentInstance = () => {
	currentInstance && currentInstance.scope.off();
	internalSetCurrentInstance(null);
};
function isStatefulComponent(instance) {
	return instance.vnode.shapeFlag & 4;
}
var isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
	isSSR && setInSSRSetupState(isSSR);
	const { props, children } = instance.vnode;
	const isStateful = isStatefulComponent(instance);
	initProps(instance, props, isStateful, isSSR);
	initSlots(instance, children, optimized || isSSR);
	const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
	isSSR && setInSSRSetupState(false);
	return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
	const Component = instance.type;
	instance.accessCache = /* @__PURE__ */ Object.create(null);
	instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
	const { setup } = Component;
	if (setup) {
		pauseTracking();
		const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
		const reset = setCurrentInstance(instance);
		const setupResult = callWithErrorHandling(setup, instance, 0, [instance.props, setupContext]);
		const isAsyncSetup = isPromise(setupResult);
		resetTracking();
		reset();
		if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) markAsyncBoundary(instance);
		if (isAsyncSetup) {
			setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
			if (isSSR) return setupResult.then((resolvedResult) => {
				setInSSRSetupState(true);
				try {
					handleSetupResult(instance, resolvedResult, isSSR);
				} finally {
					setInSSRSetupState(false);
				}
			}).catch((e) => {
				handleError(e, instance, 0);
			});
			else instance.asyncDep = setupResult;
		} else handleSetupResult(instance, setupResult, isSSR);
	} else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
	if (isFunction(setupResult)) {
		if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
		else instance.render = setupResult;
	} else if (isObject(setupResult)) {
		instance.devtoolsRawSetupState = setupResult;
		instance.setupState = proxyRefs(setupResult);
	}
	finishComponentSetup(instance, isSSR);
}
function finishComponentSetup(instance, isSSR, skipOptions) {
	const Component = instance.type;
	if (!instance.render) instance.render = Component.render || NOOP;
	{
		const reset = setCurrentInstance(instance);
		pauseTracking();
		try {
			applyOptions(instance);
		} finally {
			resetTracking();
			reset();
		}
	}
}
var attrsProxyHandlers = { get(target, key) {
	track(target, "get", "");
	return target[key];
} };
function createSetupContext(instance) {
	const expose = (exposed) => {
		instance.exposed = exposed || {};
	};
	return {
		attrs: new Proxy(instance.attrs, attrsProxyHandlers),
		slots: instance.slots,
		emit: instance.emit,
		expose
	};
}
function getComponentPublicInstance(instance) {
	if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
		get(target, key) {
			if (key in target) return target[key];
			else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
		},
		has(target, key) {
			return key in target || key in publicPropertiesMap;
		}
	}));
	else return instance.proxy;
}
function isClassComponent(value) {
	return isFunction(value) && "__vccOpts" in value;
}
var computed = (getterOrOptions, debugOptions) => {
	return /* @__PURE__ */ computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
};
function h(type, propsOrChildren, children) {
	try {
		setBlockTracking(-1);
		const l = arguments.length;
		if (l === 2) {
			if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
				if (isVNode(propsOrChildren)) return createVNode(type, null, [propsOrChildren]);
				return createVNode(type, propsOrChildren);
			} else return createVNode(type, null, propsOrChildren);
		} else {
			if (l > 3) children = Array.prototype.slice.call(arguments, 2);
			else if (l === 3 && isVNode(children)) children = [children];
			return createVNode(type, propsOrChildren, children);
		}
	} finally {
		setBlockTracking(1);
	}
}
var version = "3.5.44";
//#endregion
//#region node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
/**
* @vue/runtime-dom v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
var policy = void 0;
var tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) try {
	policy = /* @__PURE__ */ tt.createPolicy("vue", { createHTML: (val) => val });
} catch (e) {}
var unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
var svgNS = "http://www.w3.org/2000/svg";
var mathmlNS = "http://www.w3.org/1998/Math/MathML";
var doc = typeof document !== "undefined" ? document : null;
var templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
var nodeOps = {
	insert: (child, parent, anchor) => {
		parent.insertBefore(child, anchor || null);
	},
	remove: (child) => {
		const parent = child.parentNode;
		if (parent) parent.removeChild(child);
	},
	createElement: (tag, namespace, is, props) => {
		const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, { is }) : doc.createElement(tag);
		if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
		return el;
	},
	createText: (text) => doc.createTextNode(text),
	createComment: (text) => doc.createComment(text),
	setText: (node, text) => {
		node.nodeValue = text;
	},
	setElementText: (el, text) => {
		el.textContent = text;
	},
	parentNode: (node) => node.parentNode,
	nextSibling: (node) => node.nextSibling,
	querySelector: (selector) => doc.querySelector(selector),
	setScopeId(el, id) {
		el.setAttribute(id, "");
	},
	insertStaticContent(content, parent, anchor, namespace, start, end) {
		const before = anchor ? anchor.previousSibling : parent.lastChild;
		if (start && (start === end || start.nextSibling)) while (true) {
			parent.insertBefore(start.cloneNode(true), anchor);
			if (start === end || !(start = start.nextSibling)) break;
		}
		else {
			templateContainer.innerHTML = unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
			const template = templateContainer.content;
			if (namespace === "svg" || namespace === "mathml") {
				const wrapper = template.firstChild;
				while (wrapper.firstChild) template.appendChild(wrapper.firstChild);
				template.removeChild(wrapper);
			}
			parent.insertBefore(template, anchor);
		}
		return [before ? before.nextSibling : parent.firstChild, anchor ? anchor.previousSibling : parent.lastChild];
	}
};
var vtcKey = /* @__PURE__ */ Symbol("_vtc");
function patchClass(el, value, isSVG) {
	const transitionClasses = el[vtcKey];
	if (transitionClasses) value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
	if (value == null) el.removeAttribute("class");
	else if (isSVG) el.setAttribute("class", value);
	else el.className = value;
}
var vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
var vShowHidden = /* @__PURE__ */ Symbol("_vsh");
var CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
var displayRE = /(?:^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
	const style = el.style;
	const isCssString = isString(next);
	let hasControlledDisplay = false;
	if (next && !isCssString) {
		if (prev) {
			if (!isString(prev)) {
				for (const key in prev) if (next[key] == null) setStyle(style, key, "");
			} else for (const prevStyle of prev.split(";")) {
				const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
				if (next[key] == null) setStyle(style, key, "");
			}
		}
		for (const key in next) {
			if (key === "display") hasControlledDisplay = true;
			const value = next[key];
			if (value != null) {
				if (!shouldPreserveTextareaResizeStyle(el, key, !isString(prev) && prev ? prev[key] : void 0, value)) setStyle(style, key, value);
			} else setStyle(style, key, "");
		}
	} else if (isCssString) {
		if (prev !== next) {
			const cssVarText = style[CSS_VAR_TEXT];
			if (cssVarText) next += ";" + cssVarText;
			style.cssText = next;
			hasControlledDisplay = displayRE.test(next);
		}
	} else if (prev) el.removeAttribute("style");
	if (vShowOriginalDisplay in el) {
		if (!isCssString || prev !== next) el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
		if (el[vShowHidden]) style.display = "none";
	}
}
var importantRE = /\s*!important$/;
function setStyle(style, name, val) {
	if (isArray(val)) val.forEach((v) => setStyle(style, name, v));
	else {
		if (val == null) val = "";
		if (name.startsWith("--")) {
			if (importantRE.test(val)) style.setProperty(name, val.replace(importantRE, ""), "important");
			else style.setProperty(name, val);
		} else {
			const prefixed = autoPrefix(style, name);
			if (importantRE.test(val)) style.setProperty(hyphenate(prefixed), val.replace(importantRE, ""), "important");
			else style[prefixed] = val;
		}
	}
}
var prefixes = [
	"Webkit",
	"Moz",
	"ms"
];
var prefixCache = {};
function autoPrefix(style, rawName) {
	const cached = prefixCache[rawName];
	if (cached) return cached;
	let name = camelize(rawName);
	if (name !== "filter" && name in style) return prefixCache[rawName] = name;
	name = capitalize(name);
	for (let i = 0; i < prefixes.length; i++) {
		const prefixed = prefixes[i] + name;
		if (prefixed in style) return prefixCache[rawName] = prefixed;
	}
	return rawName;
}
function shouldPreserveTextareaResizeStyle(el, key, prev, next) {
	return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && isString(next) && prev === next;
}
var xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = isSpecialBooleanAttr(key)) {
	if (isSVG && key.startsWith("xlink:")) {
		if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
		else el.setAttributeNS(xlinkNS, key, value);
	} else if (value == null || isBoolean && !includeBooleanAttr(value)) el.removeAttribute(key);
	else el.setAttribute(key, isBoolean ? "" : isSymbol(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
	if (key === "innerHTML" || key === "textContent") {
		if (value != null) el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
		return;
	}
	const tag = el.tagName;
	if (key === "value" && tag !== "PROGRESS" && !tag.includes("-")) {
		const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
		const newValue = value == null ? el.type === "checkbox" ? "on" : "" : String(value);
		if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
		if (value == null) el.removeAttribute(key);
		el._value = value;
		return;
	}
	let needRemove = false;
	if (value === "" || value == null) {
		const type = typeof el[key];
		if (type === "boolean") value = includeBooleanAttr(value);
		else if (value == null && type === "string") {
			value = "";
			needRemove = true;
		} else if (type === "number") {
			value = 0;
			needRemove = true;
		}
	}
	try {
		el[key] = value;
	} catch (e) {}
	needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
	el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
	el.removeEventListener(event, handler, options);
}
var veiKey = /* @__PURE__ */ Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
	const invokers = el[veiKey] || (el[veiKey] = {});
	const existingInvoker = invokers[rawName];
	if (nextValue && existingInvoker) existingInvoker.value = nextValue;
	else {
		const [name, options] = parseName(rawName);
		if (nextValue) addEventListener(el, name, invokers[rawName] = createInvoker(nextValue, instance), options);
		else if (existingInvoker) {
			removeEventListener(el, name, existingInvoker, options);
			invokers[rawName] = void 0;
		}
	}
}
var optionsModifierRE = /(Once|Passive|Capture)$/;
var optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function parseName(name) {
	let options;
	let m;
	while ((m = name.match(optionsModifierRE)) && !optionsModifierEventRE.test(name)) {
		if (!options) options = {};
		name = name.slice(0, name.length - m[1].length);
		options[m[1].toLowerCase()] = true;
	}
	return [name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2)), options];
}
var cachedNow = 0;
var p = /* @__PURE__ */ Promise.resolve();
var getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
	const invoker = (e) => {
		if (!e._vts) e._vts = Date.now();
		else if (e._vts <= invoker.attached) return;
		const value = invoker.value;
		if (isArray(value)) {
			const originalStop = e.stopImmediatePropagation;
			e.stopImmediatePropagation = () => {
				originalStop.call(e);
				e._stopped = true;
			};
			const handlers = value.slice();
			const args = [e];
			for (let i = 0; i < handlers.length; i++) {
				if (e._stopped) break;
				const handler = handlers[i];
				if (handler) callWithAsyncErrorHandling(handler, instance, 5, args);
			}
		} else callWithAsyncErrorHandling(value, instance, 5, [e]);
	};
	invoker.value = initialValue;
	invoker.attached = getNow();
	return invoker;
}
var isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
var patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
	const isSVG = namespace === "svg";
	if (key === "class") patchClass(el, nextValue, isSVG);
	else if (key === "style") patchStyle(el, prevValue, nextValue);
	else if (isOn(key)) {
		if (!isModelListener(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
	} else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
		patchDOMProp(el, key, nextValue);
		if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
	} else if (el._isVueCE && (shouldSetAsPropForVueCE(el, key) || el._def.__asyncLoader && (/[A-Z]/.test(key) || !isString(nextValue)))) patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
	else {
		if (key === "true-value") el._trueValue = nextValue;
		else if (key === "false-value") el._falseValue = nextValue;
		patchAttr(el, key, nextValue, isSVG);
	}
};
function shouldSetAsProp(el, key, value, isSVG) {
	if (isSVG) {
		if (key === "innerHTML" || key === "textContent") return true;
		if (key in el && isNativeOn(key) && isFunction(value)) return true;
		return false;
	}
	if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
	if (key === "sandbox" && el.tagName === "IFRAME") return false;
	if (key === "form") return false;
	if (key === "list" && el.tagName === "INPUT") return false;
	if (key === "type" && el.tagName === "TEXTAREA") return false;
	if (key === "width" || key === "height") {
		const tag = el.tagName;
		if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
	}
	if (isNativeOn(key) && isString(value)) return false;
	return key in el;
}
function shouldSetAsPropForVueCE(el, key) {
	const props = el._def.props;
	if (!props) return false;
	const camelKey = camelize(key);
	return Array.isArray(props) ? props.some((prop) => camelize(prop) === camelKey) : Object.keys(props).some((prop) => camelize(prop) === camelKey);
}
var rendererOptions = /* @__PURE__ */ extend({ patchProp }, nodeOps);
var renderer;
function ensureRenderer() {
	return renderer || (renderer = createRenderer(rendererOptions));
}
var createApp = ((...args) => {
	const app = ensureRenderer().createApp(...args);
	const { mount } = app;
	app.mount = (containerOrSelector) => {
		const container = normalizeContainer(containerOrSelector);
		if (!container) return;
		const component = app._component;
		if (!isFunction(component) && !component.render && !component.template) component.template = container.innerHTML;
		if (container.nodeType === 1) container.textContent = "";
		const proxy = mount(container, false, resolveRootNamespace(container));
		if (container instanceof Element) {
			container.removeAttribute("v-cloak");
			container.setAttribute("data-v-app", "");
		}
		return proxy;
	};
	return app;
});
function resolveRootNamespace(container) {
	if (container instanceof SVGElement) return "svg";
	if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function normalizeContainer(container) {
	if (isString(container)) return document.querySelector(container);
	return container;
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/graphql-client/constants.mjs
var CLIENT$1 = "GraphQL Client";
var GQL_API_ERROR = "An error occurred while fetching from the API. Review 'graphQLErrors' for details.";
var UNEXPECTED_CONTENT_TYPE_ERROR = "Response returned unexpected Content-Type:";
var NO_DATA_OR_ERRORS_ERROR = "An unknown error has occurred. The API did not return a data object or any errors in its response.";
var CONTENT_TYPES = {
	json: "application/json",
	multipart: "multipart/mixed"
};
var SDK_VARIANT_HEADER$1 = "X-SDK-Variant";
var SDK_VERSION_HEADER$1 = "X-SDK-Version";
var DEFAULT_SDK_VARIANT$1 = "shopify-graphql-client";
var DEFAULT_CLIENT_VERSION$1 = "1.4.2";
var RETRY_WAIT_TIME = 1e3;
var RETRIABLE_STATUS_CODES = [429, 503];
var DEFER_OPERATION_REGEX = /@(defer)\b/i;
var BOUNDARY_HEADER_REGEX = /boundary="?([^=";]+)"?/i;
var HEADER_SEPARATOR = "\r\n\r\n";
//#endregion
//#region node_modules/@shopify/graphql-client/dist/graphql-client/utilities.mjs
function formatErrorMessage(message, client = CLIENT$1) {
	return message.startsWith(`${client}`) ? message : `${client}: ${message}`;
}
function getErrorMessage(error) {
	return error instanceof Error ? error.message : JSON.stringify(error);
}
function getErrorCause(error) {
	return error instanceof Error && error.cause ? error.cause : void 0;
}
function combineErrors(dataArray) {
	return dataArray.flatMap(({ errors }) => {
		return errors ?? [];
	});
}
function validateRetries({ client, retries }) {
	if (retries !== void 0 && (typeof retries !== "number" || retries < 0 || retries > 3)) throw new Error(`${client}: The provided "retries" value (${retries}) is invalid - it cannot be less than 0 or greater than 3`);
}
function getKeyValueIfValid(key, value) {
	return value && (typeof value !== "object" || Array.isArray(value) || typeof value === "object" && Object.keys(value).length > 0) ? { [key]: value } : {};
}
function buildDataObjectByPath(path, data) {
	if (path.length === 0) return data;
	const newData = { [path.pop()]: data };
	if (path.length === 0) return newData;
	return buildDataObjectByPath(path, newData);
}
function combineObjects(baseObject, newObject) {
	return Object.keys(newObject || {}).reduce((acc, key) => {
		if ((typeof newObject[key] === "object" || Array.isArray(newObject[key])) && baseObject[key]) {
			acc[key] = combineObjects(baseObject[key], newObject[key]);
			return acc;
		}
		acc[key] = newObject[key];
		return acc;
	}, Array.isArray(baseObject) ? [...baseObject] : { ...baseObject });
}
function buildCombinedDataObject([initialDatum, ...remainingData]) {
	return remainingData.reduce(combineObjects, { ...initialDatum });
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/graphql-client/http-fetch.mjs
function generateHttpFetch({ clientLogger, customFetchApi = fetch, client = CLIENT$1, defaultRetryWaitTime = RETRY_WAIT_TIME, retriableCodes = RETRIABLE_STATUS_CODES }) {
	const httpFetch = async (requestParams, count, maxRetries) => {
		const nextCount = count + 1;
		const maxTries = maxRetries + 1;
		let response;
		try {
			response = await customFetchApi(...requestParams);
			clientLogger({
				type: "HTTP-Response",
				content: {
					requestParams,
					response
				}
			});
			if (!response.ok && retriableCodes.includes(response.status) && nextCount <= maxTries) throw new Error();
			const deprecationNotice = response?.headers.get("X-Shopify-API-Deprecated-Reason") || "";
			if (deprecationNotice) clientLogger({
				type: "HTTP-Response-GraphQL-Deprecation-Notice",
				content: {
					requestParams,
					deprecationNotice
				}
			});
			return response;
		} catch (error) {
			if (nextCount <= maxTries) {
				const retryAfter = response?.headers.get("Retry-After");
				await sleep(retryAfter ? parseInt(retryAfter, 10) : defaultRetryWaitTime);
				clientLogger({
					type: "HTTP-Retry",
					content: {
						requestParams,
						lastResponse: response,
						retryAttempt: count,
						maxRetries
					}
				});
				return httpFetch(requestParams, nextCount, maxRetries);
			}
			throw new Error(formatErrorMessage(`${maxRetries > 0 ? `Attempted maximum number of ${maxRetries} network retries. Last message - ` : ""}${getErrorMessage(error)}`, client));
		}
	};
	return httpFetch;
}
async function sleep(waitTime) {
	return new Promise((resolve) => setTimeout(resolve, waitTime));
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/graphql-client/graphql-client.mjs
function createGraphQLClient({ headers, url, customFetchApi = fetch, retries = 0, logger }) {
	validateRetries({
		client: CLIENT$1,
		retries
	});
	const config = {
		headers,
		url,
		retries
	};
	const fetchFn = generateFetch(generateHttpFetch({
		customFetchApi,
		clientLogger: generateClientLogger(logger),
		defaultRetryWaitTime: RETRY_WAIT_TIME
	}), config);
	return {
		config,
		fetch: fetchFn,
		request: generateRequest(fetchFn),
		requestStream: generateRequestStream(fetchFn)
	};
}
function generateClientLogger(logger) {
	return (logContent) => {
		if (logger) logger(logContent);
	};
}
async function processJSONResponse(response) {
	const { errors, data, extensions } = await response.json();
	return {
		...getKeyValueIfValid("data", data),
		...getKeyValueIfValid("extensions", extensions),
		headers: response.headers,
		...errors || !data ? { errors: {
			networkStatusCode: response.status,
			message: formatErrorMessage(errors ? GQL_API_ERROR : NO_DATA_OR_ERRORS_ERROR),
			...getKeyValueIfValid("graphQLErrors", errors),
			response
		} } : {}
	};
}
function generateFetch(httpFetch, { url, headers, retries }) {
	return async (operation, options = {}) => {
		const { variables, headers: overrideHeaders, url: overrideUrl, retries: overrideRetries, keepalive, signal } = options;
		const body = JSON.stringify({
			query: operation,
			variables
		});
		validateRetries({
			client: CLIENT$1,
			retries: overrideRetries
		});
		const flatHeaders = Object.entries({
			...headers,
			...overrideHeaders
		}).reduce((headers, [key, value]) => {
			headers[key] = Array.isArray(value) ? value.join(", ") : value.toString();
			return headers;
		}, {});
		if (!flatHeaders["X-SDK-Variant"] && !flatHeaders["X-SDK-Version"]) {
			flatHeaders[SDK_VARIANT_HEADER$1] = DEFAULT_SDK_VARIANT$1;
			flatHeaders[SDK_VERSION_HEADER$1] = DEFAULT_CLIENT_VERSION$1;
		}
		return httpFetch([overrideUrl ?? url, {
			method: "POST",
			headers: flatHeaders,
			body,
			signal,
			keepalive
		}], 1, overrideRetries ?? retries);
	};
}
function generateRequest(fetchFn) {
	return async (...props) => {
		if (DEFER_OPERATION_REGEX.test(props[0])) throw new Error(formatErrorMessage("This operation will result in a streamable response - use requestStream() instead."));
		let response = null;
		try {
			response = await fetchFn(...props);
			const { status, statusText } = response;
			const contentType = response.headers.get("content-type") || "";
			if (!response.ok) return { errors: {
				networkStatusCode: status,
				message: formatErrorMessage(statusText),
				response
			} };
			if (!contentType.includes(CONTENT_TYPES.json)) return { errors: {
				networkStatusCode: status,
				message: formatErrorMessage(`${UNEXPECTED_CONTENT_TYPE_ERROR} ${contentType}`),
				response
			} };
			return await processJSONResponse(response);
		} catch (error) {
			return { errors: {
				message: getErrorMessage(error),
				...response == null ? {} : {
					networkStatusCode: response.status,
					response
				}
			} };
		}
	};
}
async function* getStreamBodyIterator(response) {
	const decoder = new TextDecoder();
	if (response.body[Symbol.asyncIterator]) for await (const chunk of response.body) yield decoder.decode(chunk);
	else {
		const reader = response.body.getReader();
		let readResult;
		try {
			while (!(readResult = await reader.read()).done) yield decoder.decode(readResult.value);
		} finally {
			reader.cancel();
		}
	}
}
function readStreamChunk(streamBodyIterator, boundary) {
	return { async *[Symbol.asyncIterator]() {
		try {
			let buffer = "";
			for await (const textChunk of streamBodyIterator) {
				buffer += textChunk;
				if (buffer.indexOf(boundary) > -1) {
					const lastBoundaryIndex = buffer.lastIndexOf(boundary);
					const chunkBodies = buffer.slice(0, lastBoundaryIndex).split(boundary).filter((chunk) => chunk.trim().length > 0).map((chunk) => {
						return chunk.slice(chunk.indexOf(HEADER_SEPARATOR) + HEADER_SEPARATOR.length).trim();
					});
					if (chunkBodies.length > 0) yield chunkBodies;
					buffer = buffer.slice(lastBoundaryIndex + boundary.length);
					if (buffer.trim() === `--`) buffer = "";
				}
			}
		} catch (error) {
			throw new Error(`Error occured while processing stream payload - ${getErrorMessage(error)}`);
		}
	} };
}
function createJsonResponseAsyncIterator(response) {
	return { async *[Symbol.asyncIterator]() {
		try {
			yield {
				...await processJSONResponse(response),
				hasNext: false
			};
		} catch (error) {
			yield {
				errors: {
					message: formatErrorMessage(getErrorMessage(error)),
					networkStatusCode: response.status,
					response
				},
				hasNext: false
			};
		}
	} };
}
function getResponseDataFromChunkBodies(chunkBodies) {
	return chunkBodies.map((value) => {
		try {
			return JSON.parse(value);
		} catch (error) {
			throw new Error(`Error in parsing multipart response - ${getErrorMessage(error)}`);
		}
	}).map((payload) => {
		const { data, incremental, hasNext, extensions, errors } = payload;
		if (!incremental) return {
			data: data || {},
			...getKeyValueIfValid("errors", errors),
			...getKeyValueIfValid("extensions", extensions),
			hasNext
		};
		const incrementalArray = incremental.map(({ data, path, errors }) => {
			return {
				data: data && path ? buildDataObjectByPath(path, data) : {},
				...getKeyValueIfValid("errors", errors)
			};
		});
		return {
			data: incrementalArray.length === 1 ? incrementalArray[0].data : buildCombinedDataObject([...incrementalArray.map(({ data }) => data)]),
			...getKeyValueIfValid("errors", combineErrors(incrementalArray)),
			hasNext
		};
	});
}
function validateResponseData(responseErrors, combinedData) {
	if (responseErrors.length > 0) throw new Error(GQL_API_ERROR, { cause: { graphQLErrors: responseErrors } });
	if (Object.keys(combinedData).length === 0) throw new Error(NO_DATA_OR_ERRORS_ERROR);
}
function createMultipartResponseAsyncInterator(response, responseContentType) {
	const boundaryHeader = (responseContentType ?? "").match(BOUNDARY_HEADER_REGEX);
	const boundary = `--${boundaryHeader ? boundaryHeader[1] : "-"}`;
	if (!response.body?.getReader && !response.body?.[Symbol.asyncIterator]) throw new Error("API multipart response did not return an iterable body", { cause: response });
	const streamBodyIterator = getStreamBodyIterator(response);
	let combinedData = {};
	let responseExtensions;
	return { async *[Symbol.asyncIterator]() {
		try {
			let streamHasNext = true;
			for await (const chunkBodies of readStreamChunk(streamBodyIterator, boundary)) {
				const responseData = getResponseDataFromChunkBodies(chunkBodies);
				responseExtensions = responseData.find((datum) => datum.extensions)?.extensions ?? responseExtensions;
				const responseErrors = combineErrors(responseData);
				combinedData = buildCombinedDataObject([combinedData, ...responseData.map(({ data }) => data)]);
				streamHasNext = responseData.slice(-1)[0].hasNext;
				validateResponseData(responseErrors, combinedData);
				yield {
					...getKeyValueIfValid("data", combinedData),
					...getKeyValueIfValid("extensions", responseExtensions),
					hasNext: streamHasNext
				};
			}
			if (streamHasNext) throw new Error(`Response stream terminated unexpectedly`);
		} catch (error) {
			const cause = getErrorCause(error);
			yield {
				...getKeyValueIfValid("data", combinedData),
				...getKeyValueIfValid("extensions", responseExtensions),
				errors: {
					message: formatErrorMessage(getErrorMessage(error)),
					networkStatusCode: response.status,
					...getKeyValueIfValid("graphQLErrors", cause?.graphQLErrors),
					response
				},
				hasNext: false
			};
		}
	} };
}
function generateRequestStream(fetchFn) {
	return async (...props) => {
		if (!DEFER_OPERATION_REGEX.test(props[0])) throw new Error(formatErrorMessage("This operation does not result in a streamable response - use request() instead."));
		try {
			const response = await fetchFn(...props);
			const { statusText } = response;
			if (!response.ok) throw new Error(statusText, { cause: response });
			const responseContentType = response.headers.get("content-type") || "";
			switch (true) {
				case responseContentType.includes(CONTENT_TYPES.json): return createJsonResponseAsyncIterator(response);
				case responseContentType.includes(CONTENT_TYPES.multipart): return createMultipartResponseAsyncInterator(response, responseContentType);
				default: throw new Error(`${UNEXPECTED_CONTENT_TYPE_ERROR} ${responseContentType}`, { cause: response });
			}
		} catch (error) {
			return { async *[Symbol.asyncIterator]() {
				const response = getErrorCause(error);
				yield {
					errors: {
						message: formatErrorMessage(getErrorMessage(error)),
						...getKeyValueIfValid("networkStatusCode", response?.status),
						...getKeyValueIfValid("response", response)
					},
					hasNext: false
				};
			} };
		}
	};
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/api-client-utilities/validations.mjs
function validateDomainAndGetStoreUrl({ client, storeDomain }) {
	try {
		if (!storeDomain || typeof storeDomain !== "string") throw new Error();
		const trimmedDomain = storeDomain.trim();
		const protocolUrl = trimmedDomain.match(/^https?:/) ? trimmedDomain : `https://${trimmedDomain}`;
		const url = new URL(protocolUrl);
		url.protocol = "https";
		return url.origin;
	} catch (error) {
		throw new Error(`${client}: a valid store domain ("${storeDomain}") must be provided`, { cause: error });
	}
}
function validateApiVersion({ client, currentSupportedApiVersions, apiVersion, logger }) {
	const versionError = `${client}: the provided apiVersion ("${apiVersion}")`;
	const supportedVersion = `Currently supported API versions: ${currentSupportedApiVersions.join(", ")}`;
	if (!apiVersion || typeof apiVersion !== "string") throw new Error(`${versionError} is invalid. ${supportedVersion}`);
	const trimmedApiVersion = apiVersion.trim();
	if (!currentSupportedApiVersions.includes(trimmedApiVersion)) {
		if (logger) logger({
			type: "Unsupported_Api_Version",
			content: {
				apiVersion,
				supportedApiVersions: currentSupportedApiVersions
			}
		});
		else console.warn(`${versionError} is likely deprecated or not supported. ${supportedVersion}`);
	}
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/api-client-utilities/api-versions.mjs
function getQuarterMonth(quarter) {
	const month = quarter * 3 - 2;
	return month === 10 ? month : `0${month}`;
}
function getPrevousVersion(year, quarter, nQuarter) {
	const versionQuarter = quarter - nQuarter;
	if (versionQuarter <= 0) return `${year - 1}-${getQuarterMonth(versionQuarter + 4)}`;
	return `${year}-${getQuarterMonth(versionQuarter)}`;
}
function getCurrentApiVersion() {
	const date = /* @__PURE__ */ new Date();
	const month = date.getUTCMonth();
	const year = date.getUTCFullYear();
	const quarter = Math.floor(month / 3 + 1);
	return {
		year,
		quarter,
		version: `${year}-${getQuarterMonth(quarter)}`
	};
}
function getCurrentSupportedApiVersions() {
	const { year, quarter, version: currentVersion } = getCurrentApiVersion();
	const nextVersion = quarter === 4 ? `${year + 1}-01` : `${year}-${getQuarterMonth(quarter + 1)}`;
	return [
		getPrevousVersion(year, quarter, 3),
		getPrevousVersion(year, quarter, 2),
		getPrevousVersion(year, quarter, 1),
		currentVersion,
		nextVersion,
		"unstable"
	];
}
//#endregion
//#region node_modules/@shopify/graphql-client/dist/api-client-utilities/utilities.mjs
function generateGetHeaders(config) {
	return (customHeaders) => {
		return {
			...customHeaders ?? {},
			...config.headers
		};
	};
}
function generateGetGQLClientParams({ getHeaders, getApiUrl }) {
	return (operation, options) => {
		const props = [operation];
		if (options && Object.keys(options).length > 0) {
			const { variables, apiVersion: propApiVersion, headers, retries, signal } = options;
			props.push({
				...variables ? { variables } : {},
				...headers ? { headers: getHeaders(headers) } : {},
				...propApiVersion ? { url: getApiUrl(propApiVersion) } : {},
				...retries ? { retries } : {},
				...signal ? { signal } : {}
			});
		}
		return props;
	};
}
//#endregion
//#region node_modules/@shopify/storefront-api-client/dist/constants.mjs
var DEFAULT_CONTENT_TYPE = "application/json";
var DEFAULT_SDK_VARIANT = "storefront-api-client";
var DEFAULT_CLIENT_VERSION = "1.0.10";
var PUBLIC_ACCESS_TOKEN_HEADER = "X-Shopify-Storefront-Access-Token";
var PRIVATE_ACCESS_TOKEN_HEADER = "Shopify-Storefront-Private-Token";
var SDK_VARIANT_HEADER = "X-SDK-Variant";
var SDK_VERSION_HEADER = "X-SDK-Version";
var SDK_VARIANT_SOURCE_HEADER = "X-SDK-Variant-Source";
var CLIENT = "Storefront API Client";
//#endregion
//#region node_modules/@shopify/storefront-api-client/dist/validations.mjs
function validatePrivateAccessTokenUsage(privateAccessToken) {
	if (privateAccessToken && typeof window !== "undefined") throw new Error(`${CLIENT}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`);
}
function validateRequiredAccessTokens(publicAccessToken, privateAccessToken) {
	if (!publicAccessToken && !privateAccessToken) throw new Error(`${CLIENT}: a public or private access token must be provided`);
	if (publicAccessToken && privateAccessToken) throw new Error(`${CLIENT}: only provide either a public or private access token`);
}
//#endregion
//#region node_modules/@shopify/storefront-api-client/dist/storefront-api-client.mjs
function createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken, privateAccessToken, clientName, retries = 0, customFetchApi, logger }) {
	const currentSupportedApiVersions = getCurrentSupportedApiVersions();
	const storeUrl = validateDomainAndGetStoreUrl({
		client: CLIENT,
		storeDomain
	});
	const baseApiVersionValidationParams = {
		client: CLIENT,
		currentSupportedApiVersions,
		logger
	};
	validateApiVersion({
		...baseApiVersionValidationParams,
		apiVersion
	});
	validateRequiredAccessTokens(publicAccessToken, privateAccessToken);
	validatePrivateAccessTokenUsage(privateAccessToken);
	const apiUrlFormatter = generateApiUrlFormatter(storeUrl, apiVersion, baseApiVersionValidationParams);
	const config = {
		storeDomain: storeUrl,
		apiVersion,
		...publicAccessToken ? { publicAccessToken } : { privateAccessToken },
		headers: {
			"Content-Type": DEFAULT_CONTENT_TYPE,
			Accept: DEFAULT_CONTENT_TYPE,
			[SDK_VARIANT_HEADER]: DEFAULT_SDK_VARIANT,
			[SDK_VERSION_HEADER]: DEFAULT_CLIENT_VERSION,
			...clientName ? { [SDK_VARIANT_SOURCE_HEADER]: clientName } : {},
			...publicAccessToken ? { [PUBLIC_ACCESS_TOKEN_HEADER]: publicAccessToken } : { [PRIVATE_ACCESS_TOKEN_HEADER]: privateAccessToken }
		},
		apiUrl: apiUrlFormatter(),
		clientName
	};
	const graphqlClient = createGraphQLClient({
		headers: config.headers,
		url: config.apiUrl,
		retries,
		customFetchApi,
		logger
	});
	const getHeaders = generateGetHeaders(config);
	const getApiUrl = generateGetApiUrl(config, apiUrlFormatter);
	const getGQLClientParams = generateGetGQLClientParams({
		getHeaders,
		getApiUrl
	});
	return Object.freeze({
		config,
		getHeaders,
		getApiUrl,
		fetch: (...props) => {
			return graphqlClient.fetch(...getGQLClientParams(...props));
		},
		request: (...props) => {
			return graphqlClient.request(...getGQLClientParams(...props));
		},
		requestStream: (...props) => {
			return graphqlClient.requestStream(...getGQLClientParams(...props));
		}
	});
}
function generateApiUrlFormatter(storeUrl, defaultApiVersion, baseApiVersionValidationParams) {
	return (apiVersion) => {
		if (apiVersion) validateApiVersion({
			...baseApiVersionValidationParams,
			apiVersion
		});
		return `${storeUrl}/api/${(apiVersion ?? defaultApiVersion).trim()}/graphql.json`;
	};
}
function generateGetApiUrl(config, apiUrlFormatter) {
	return (propApiVersion) => {
		return propApiVersion ? apiUrlFormatter(propApiVersion) : config.apiUrl;
	};
}
//#endregion
//#region scripts/utils/storefront-client.js
function initClient(domain, publicKey) {
	return createStorefrontApiClient({
		storeDomain: domain,
		apiVersion: "2026-04",
		publicAccessToken: publicKey
	});
}
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region vue/Bundle.vue
var _sfc_main = {
	name: "Bundle",
	data() {
		return {
			screen: window.innerWidth,
			products: null,
			storefrontApiClient: null,
			showMore: false
		};
	},
	props: {
		domain: String,
		country_code: String,
		settings: Object,
		section: Object,
		product: Object,
		metafield_namespace: String
	},
	watch: { showMore(val, oldVal) {
		let containerEl = document.querySelector(".pdp-bundle-items__list");
		let listEl = document.querySelector(".pdp-bundle-items__list ul");
		if (val) containerEl.style.maxHeight = listEl.scrollHeight + "px";
		else containerEl.style.maxHeight = "400px";
	} },
	async mounted() {
		this.storefrontApiClient = initClient(this.domain, "2c33bf83da08a7b9704490acb4389535");
		const getBundleProducts = `#graphql
      query ProductQuery($handle: String!) @inContext(country: ${this.country_code}) {
        product(handle:$handle) {
          metafield(key: "tutorial_bundle_items", namespace: "${this.metafield_namespace}") {
            references(first: 50) {
              edges {
                node {
                  ...on Product {
                    id
                    title
                    handle
                    onlineStoreUrl
                    featuredImage {
                      url
                      altText
                      width
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
		const response = await this.storefrontApiClient.fetch(getBundleProducts, { variables: { handle: this.product.handle } });
		if (response.ok) {
			const json = await response.json();
			this.products = json.data.product.metafield.references.edges.map((b) => b.node);
		} else console.error("Error fetching bundle products:", response);
	}
};
var _hoisted_1 = { class: "product-main__bundle-items pdp-bundle-items" };
var _hoisted_2 = { class: "pdp-bundle-items__list-container" };
var _hoisted_3 = { class: "pdp-bundle-items__product bundle-product" };
var _hoisted_4 = { class: "bundle-product__media" };
var _hoisted_5 = ["src"];
var _hoisted_6 = { class: "bundle-product__info" };
var _hoisted_7 = ["href"];
var _hoisted_8 = { key: 1 };
var _hoisted_9 = { key: 0 };
var _hoisted_10 = { key: 1 };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = createBaseVNode("div", { class: "pdp-bundle-items__title" }, " Bundle Includes: ", -1)), createBaseVNode("div", _hoisted_2, [createBaseVNode("div", { class: normalizeClass(["pdp-bundle-items__list", {
		open: this.showMore,
		"show-more": $data.products.length > 12
	}]) }, [createBaseVNode("ul", null, [(openBlock(true), createElementBlock(Fragment, null, renderList($data.products, (product) => {
		return openBlock(), createElementBlock("li", null, [createBaseVNode("div", _hoisted_3, [createBaseVNode("div", _hoisted_4, [createBaseVNode("img", {
			src: product.featuredImage.url,
			width: "105"
		}, null, 8, _hoisted_5)]), createBaseVNode("div", _hoisted_6, [product.onlineStoreUrl ? (openBlock(), createElementBlock("a", {
			key: 0,
			href: product.onlineStoreUrl,
			class: "full-unstyled-link"
		}, [createBaseVNode("span", null, toDisplayString(product.title.replace("Crochet Kit", "").replace("Accessory Kit", "")), 1)], 8, _hoisted_7)) : createCommentVNode("", true), !product.onlineStoreUrl ? (openBlock(), createElementBlock("span", _hoisted_8, toDisplayString(product.title.replace("Crochet Kit", "").replace("Accessory Kit", "")), 1)) : createCommentVNode("", true)])])]);
	}), 256))])], 2), $data.products.length > 12 ? (openBlock(), createElementBlock("button", {
		key: 0,
		onClick: _cache[0] || (_cache[0] = ($event) => this.showMore = !this.showMore),
		class: "button button--compact"
	}, [!$data.showMore ? (openBlock(), createElementBlock("span", _hoisted_9, "Show More")) : (openBlock(), createElementBlock("span", _hoisted_10, "Show Less"))])) : createCommentVNode("", true)])]);
}
var Bundle_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render], ["__file", "Bundle.vue"]]);
//#endregion
//#region scripts/vue/apps/bundle.js
var BundleApp = class {
	constructor(id, data) {
		this._sectionId = id;
		this._appType = "bundle";
		this._appInstance = null;
		this._appData = data;
		this._mountingNode = null;
	}
	getSectionId() {
		return this._sectionId;
	}
	setMountingNode() {
		this._mountingNode = document.querySelector(`div[data-app-id="${this._sectionId}"][data-app-type="${this._appType}"]`);
	}
	kill() {
		this._appInstance.kill();
	}
	init() {
		this.setMountingNode();
		this._appInstance = createApp({
			el: this._mountingNode,
			render: () => h(Bundle_default, { props: { ...this._appData } })
		}, { ...this._appData }).mount(this._mountingNode);
	}
};
//#endregion
//#region scripts/vue/vue-loader.js
document.addEventListener("DOMContentLoaded", function() {
	let activeApps = [];
	const appTypeClass = [];
	appTypeClass["bundle"] = BundleApp;
	window.vue.availableApps.forEach((app) => {
		if (appTypeClass[app.type]) {
			const newApp = new appTypeClass[app.type](app.id, app.data);
			activeApps.push(newApp);
			newApp.init();
		} else console.log(`App "${app.type}" was not registered`);
	});
	if (Shopify.designMode) {
		const registerNewApps = function(event) {
			const eventSectionId = event.detail.sectionId;
			event.target.querySelectorAll(`div[data-app-id="${eventSectionId}"]`).forEach((appElement) => {
				const appType = appElement.getAttribute("data-app-type");
				eval?.(`"use strict";(${document.getElementById(`${eventSectionId}-${appType}`).innerHTML})`);
			});
		};
		document.addEventListener("shopify:section:load", (event) => {
			const eventSectionId = event.detail.sectionId;
			registerNewApps(event);
			window.vue.availableApps.forEach((app) => {
				if (app.id == eventSectionId) {
					if (appTypeClass[app.type]) {
						const newApp = new appTypeClass[app.type](app.id, app.data);
						activeApps.push(newApp);
						newApp.init();
					} else console.log(`App "${app.type}" was not registered`);
				}
			});
		});
		document.addEventListener("shopify:section:unload", (event) => {
			const eventSectionId = event.detail.sectionId, newActiveApps = [], newAvailableApps = [];
			activeApps.forEach((app) => {
				if (app.getSectionId() == eventSectionId) app.kill();
				else newActiveApps.push(app);
			});
			window.vue.availableApps.forEach((app) => {
				if (app.id != eventSectionId) newAvailableApps.push(app);
			});
			window.vue.availableApps = newAvailableApps;
			activeApps = newActiveApps;
		});
	}
});
//#endregion
//#region \0vite/preload-helper.js
var scriptRel = "modulepreload";
var assetsURL = function(dep, importerUrl) {
	return new URL(dep, importerUrl).href;
};
var seen = {};
var isCssPreloadUrl = function isCssPreloadUrl(url) {
	return url.pathname.endsWith(".css");
};
var preloadOnce = function preloadOnce(seen, href, preload) {
	if (href in seen) return seen[href];
	const promise = preload();
	if (!promise) {
		seen[href] = void 0;
		return;
	}
	const preloadPromise = promise.then(() => {
		seen[href] = void 0;
	}, (err) => {
		seen[href] = void 0;
		throw err;
	});
	seen[href] = preloadPromise;
	return preloadPromise;
};
var __vitePreload = function preload(baseModule, deps, importerUrl) {
	let promise = Promise.resolve();
	if (deps && deps.length > 0) {
		let preloadedHrefs;
		const cspNonceMeta = document.querySelector("meta[property=csp-nonce]");
		const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
		function allSettled(promises) {
			return Promise.all(promises.map((p) => Promise.resolve(p).then((value) => ({
				status: "fulfilled",
				value
			}), (reason) => ({
				status: "rejected",
				reason
			}))));
		}
		function importMetaResolve(specifier) {
			if (import.meta.resolve) return new URL(import.meta.resolve(specifier));
			return new URL(
				specifier,
				/** #__KEEP__ */
				import.meta.url
			);
		}
		promise = allSettled(deps.map((depString) => {
			depString = assetsURL(depString, importerUrl);
			const dep = importMetaResolve(depString);
			const isCss = isCssPreloadUrl(dep);
			return preloadOnce(seen, dep.href, () => {
				if (preloadedHrefs === void 0) {
					preloadedHrefs = {
						all: /* @__PURE__ */ new Set(),
						styles: /* @__PURE__ */ new Set()
					};
					const links = document.getElementsByTagName("link");
					for (let i = links.length - 1; i >= 0; i--) {
						const link = links[i];
						preloadedHrefs.all.add(link.href);
						if (link.rel === "stylesheet") preloadedHrefs.styles.add(link.href);
					}
				}
				if ((isCss ? preloadedHrefs.styles : preloadedHrefs.all).has(dep.href)) return;
				const link = document.createElement("link");
				link.rel = isCss ? "stylesheet" : scriptRel;
				if (!isCss) link.as = "script";
				link.crossOrigin = "";
				link.href = dep.href;
				if (cspNonce) link.setAttribute("nonce", cspNonce);
				document.head.appendChild(link);
				if (isCss) return new Promise((res, rej) => {
					link.addEventListener("load", res);
					link.addEventListener("error", () => rej(/* @__PURE__ */ new Error(`Unable to preload CSS for ${dep}`)));
				});
			});
		}).filter((p) => p !== void 0));
	}
	function handlePreloadError(err) {
		const e = new Event("vite:preloadError", { cancelable: true });
		e.payload = err;
		window.dispatchEvent(e);
		if (!e.defaultPrevented) throw err;
	}
	return promise.then((res) => {
		for (const item of res || []) {
			if (item.status !== "rejected") continue;
			handlePreloadError(item.reason);
		}
		return baseModule().catch(handlePreloadError);
	});
};
//#endregion
//#region scripts/theme.js
window.Splide = Splide;
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([0]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([1]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([2]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([3]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([4]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([5]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([6]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([7]), import.meta.url);
__vitePreload(() => Promise.resolve({}), __vite__mapDeps([8]), import.meta.url);
document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelectorAll(".splide").length) document.querySelectorAll(".splide").forEach((slider) => {
		if (!slider.parentElement.classList.contains("product__media-gallery") && !slider.classList.contains("product-recommendations")) new Splide(slider).mount();
	});
	if (Shopify.designMode) document.addEventListener("shopify:section:load", (event) => {
		let slider = event.target.querySelector(".splide");
		if (slider) new Splide(slider).mount();
	});
});
//#endregion
